<template>
  <div id="errosGerais" ref="errosGerais">
    <div
      v-if="loading"
      class="ms-7 mb-7"
      v-bind:data-kt-indicator="loading ? 'on' : 'off'"
    >
      <span class="indicator-progress">
        Aguarde, carregando...
        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
      </span>
    </div>
    <div
      v-if="this.errosGerais.Message"
      class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-0 me-0 mb-9 p-6"
    >
      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
        <inline-svg src="media/icons/duotune/general/gen044.svg" />
      </span>
      <div class="d-flex flex-stack flex-grow-1">
        <div class="fw-bold">
          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
          <div class="fs-6 text-gray-600">
            {{ this.errosGerais.Message }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="this.errosValidacaoGeral.length && !this.loading"
      class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-0 me-0 mb-9 p-6"
    >
      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
        <inline-svg src="media/icons/duotune/general/gen044.svg" />
      </span>
      <div class="d-flex flex-stack flex-grow-1">
        <div class="fw-bold">
          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
          <div class="fs-6 text-gray-600">
            <ul>
              <li v-for="value in this.errosValidacaoGeral" :key="value">
                <button
                  class="btn btn-link p-0"
                  v-if="value.error"
                  @click="focusAviso(value)"
                >
                  {{ value.error }}
                </button>
                <a v-else>
                  {{ value }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading" class="d-flex flex-column flex-xl-row">
      <div class="d-flex flex-column flex-row-fluid gap-6 mb-7 gap-lg-10">
        <div class="card">
          <div class="card-body pt-9 pb-0">
            <div class="d-flex flex-wrap flex-sm-nowrap mb-3">
              <div class="flex-grow-1">
                <div
                  class="d-flex justify-content-between align-items-start flex-wrap mb-2"
                >
                  <div class="d-flex flex-column mb-4">
                    <h2>
                      Faturamento Nº
                      {{
                        this.faturamento &&
                        this.faturamento.id &&
                        this.faturamento.id > 0
                          ? this.faturamento.id
                          : "EDIÇÃO"
                      }}
                    </h2>
                    <div
                      class="d-flex text-muted mb-2 fs-7 align-items-center"
                      v-if="
                        this.faturamento &&
                        this.faturamento.id &&
                        this.faturamento.id > 0
                      "
                    >
                      Nota nº:
                      <span class="badge badge-light-primary ms-2 me-2">{{
                        this.faturamento.nota
                      }}</span>
                      Modelo:
                      <span class="badge badge-light-danger ms-2 me-2">{{
                        this.faturamento.modelo
                      }}</span>
                      Série:
                      <span class="badge badge-light-success ms-2 me-2">{{
                        this.faturamento.serie
                      }}</span>
                    </div>
                    <div
                      v-if="
                        this.faturamento &&
                        this.faturamento.id &&
                        this.faturamento.id === 0
                      "
                      class="d-flex text-muted fs-7 align-items-center"
                    >
                      <div class="badge badge-light-info text-info">
                        {{ "NOVO FATURAMENTO" }}
                      </div>
                    </div>
                    <div
                      v-else
                      class="d-flex text-muted fs-7 align-items-center"
                    >
                      GUID:
                      <div class="badge badge-light-info text-info ms-2">
                        {{ this.faturamento.guid }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex flex-wrap flex-row-fluid justify-content-end gap-5"
                  >
                    <button
                      class="btn btn btn-light-info btn-active-info"
                      data-kt-menu-trigger="click"
                      data-kt-menu-placement="bottom-end"
                      data-kt-menu-flip="top-end"
                    >
                      <span class="svg-icon svg-icon-1">
                        <inline-svg
                          src="media/icons/duotune/abstract/abs027.svg"
                          class="me-2"
                        />Ações
                      </span>
                      <span class="svg-icon svg-icon-5 m-0">
                        <inline-svg
                          src="media/icons/duotune/arrows/arr072.svg"
                        />
                      </span>
                    </button>
                    <div
                      class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4"
                      data-kt-menu="true"
                    >
                      <div class="menu-item px-3">
                        <a
                          @click="this.exibirModalImportarPedidoVenda(true)"
                          class="menu-link px-3 align-items-center"
                        >
                          <span class="svg-icon svg-icon-1 align-self-center">
                            <inline-svg
                              src="media/icons/duotune/ecommerce/ecm002.svg"
                              class="me-2"
                            />Importar Pedido
                          </span>
                        </a>
                      </div>
                    </div>
                    <button
                      class="btn btn-danger svg-icon-white"
                      @click="this.cancelarFaturamento()"
                    >
                      <span class="svg-icon svg-icon-1">
                        <inline-svg
                          src="media/icons/duotune/arrows/arr015.svg"
                          class="me-2"
                        />Cancelar
                      </span>
                    </button>
                    <button
                      class="btn btn-success svg-icon-white"
                      @click="confirmarFaturamento()"
                      v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
                    >
                      <span class="indicator-progress">
                        <span
                          class="spinner-border spinner-border-sm align-middle ms-1"
                        ></span>
                        Aguarde...
                      </span>
                      <span class="svg-icon svg-icon-1" v-if="!this.loading">
                        <inline-svg
                          src="media/icons/duotune/arrows/arr016.svg"
                          class="me-2"
                        />Confirmar
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="separator"></div>
            <div class="d-flex overflow-auto h-55px">
              <ul
                class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold flex-nowrap"
              >
                <li class="nav-item">
                  <a
                    ref="tabGeral"
                    id="tabGeral"
                    class="nav-link text-active-primary pb-4 active nav-link-faturamento"
                    data-bs-toggle="tab"
                    href="#kt_faturamento_geral"
                    >Geral</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    ref="tabProduto"
                    id="tabProduto"
                    class="nav-link text-active-primary pb-4 nav-link-faturamento"
                    data-bs-toggle="tab"
                    href="#kt_faturamento_produtos"
                    >Produtos</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    ref="tabPagamento"
                    id="tabPagamento"
                    class="nav-link text-active-primary pb-4 nav-link-faturamento"
                    data-bs-toggle="tab"
                    href="#kt_faturamento_pagamento"
                    >Pagamento</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    ref="tabDuplicatas"
                    id="tabDuplicatas"
                    class="nav-link text-active-primary pb-4 nav-link-faturamento"
                    data-bs-toggle="tab"
                    href="#kt_faturamento_duplicatas"
                    >Duplicatas</a
                  >
                </li>
                <li
                  v-if="this.faturamento && this.faturamento.modelo === '55'"
                  class="nav-item"
                >
                  <a
                    ref="tabNFe"
                    id="tabNFe"
                    class="nav-link min-w-50px text-active-primary pb-4 nav-link-faturamento"
                    data-bs-toggle="tab"
                    href="#kt_faturamento_nfe"
                    >NF-e</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="tab-content">
          <div
            class="tab-pane fade show active tab-pane-faturamento"
            id="kt_faturamento_geral"
            role="tab-panel"
          >
            <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <div class="card-title" ref="faturamento_dados_geral">
                    <h2>Geral</h2>
                  </div>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3 fv-row mb-6"
                    >
                      <label class="form-label">C.F.O.P</label>
                      <div class="input-group mb-2">
                        <input
                          :id="`cfop`"
                          type="text"
                          class="form-control"
                          v-model="this.faturamento.cfop"
                          readonly
                          :class="[getErrorByID(`cfop`) ? 'is-invalid' : '']"
                        />
                        <button
                          type="button"
                          class="input-group-text"
                          @click="this.modalCfops(true)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        v-if="getErrorByID(`cfop`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`cfop`) }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 fv-row mb-6"
                    >
                      <label class="form-label">Natureza da operação</label>
                      <input
                        :id="`natureza_operacao`"
                        type="text"
                        class="form-control"
                        readonly
                        v-model="this.faturamento.natureza_operacao"
                        :class="[
                          getErrorByID(`natureza_operacao`) ? 'is-invalid' : '',
                        ]"
                      />
                      <div
                        v-if="getErrorByID(`natureza_operacao`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`natureza_operacao`) }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-2 fv-row mb-6"
                    >
                      <label class="form-label">IE Substituto</label>
                      <input
                        :id="`ie_substituto`"
                        type="text"
                        class="form-control"
                        v-model="this.faturamento.ie_substituto"
                        :class="[
                          getErrorByID(`ie_substituto`) ? 'is-invalid' : '',
                        ]"
                      />
                      <div
                        v-if="getErrorByID(`ie_substituto`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`ie_substituto`) }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3 fv-row mb-6"
                    >
                      <label class="form-label">Tipo da Nota</label>
                      <select
                        :id="`tipo_nota`"
                        class="form-select mb-2"
                        data-placeholder="Selecione uma opção"
                        v-model="faturamento.tipo_nota"
                        :class="[getErrorByID(`tipo_nota`) ? 'is-invalid' : '']"
                      >
                        <option value="S">Saída</option>
                        <option value="E">Entrada</option>
                      </select>
                      <div
                        v-if="getErrorByID(`tipo_nota`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`tipo_nota`) }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 mb-2"
                    >
                      <div class="mb-6 fv-row">
                        <label class="form-label">Data de Emissão</label>
                        <el-date-picker
                          :id="`data_emissao`"
                          v-model="this.faturamento.data_emissao"
                          type="datetime"
                          name="dtpDataEmissao"
                          placeholder="Selecione uma data"
                          class="w-100"
                          format="DD/MM/YYYY"
                          size="large"
                          @keydown.stop.prevent.enter=""
                        />
                        <div
                          v-if="getErrorByID(`data_emissao`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`data_emissao`) }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 mb-2"
                    >
                      <div class="mb-6 fv-row">
                        <label class="form-label">Data Saída</label>
                        <el-date-picker
                          :id="`data_saida`"
                          v-model.sync="this.faturamento.data_saida"
                          type="datetime"
                          name="dtpDataSaida"
                          placeholder="Selecione uma data"
                          class="w-100"
                          format="DD/MM/YYYY"
                          size="large"
                        />
                        <div
                          v-if="getErrorByID(`data_saida`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`data_saida`) }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 mb-2"
                    >
                      <div class="mb-6 fv-row">
                        <label class="form-label">Hora Saída</label>
                        <input
                          :id="`hora_saida`"
                          type="text"
                          class="form-control mb-2"
                          placeholder="Hora Saída"
                          v-model="this.faturamento.hora_saida"
                          v-mask="'##:##:##'"
                          :class="[
                            getErrorByID(`hora_saida`) ? 'is-invalid' : '',
                          ]"
                        />
                        <div
                          v-if="getErrorByID(`hora_saida`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`hora_saida`) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-3 mb-2"
                    >
                      <div class="mb-6 fv-row">
                        <label class="form-label">Conta</label>
                        <div class="input-group">
                          <input
                            :id="`id_conta`"
                            type="text"
                            class="form-control"
                            v-model="this.faturamento.id_conta"
                            readonly
                            :class="[
                              getErrorByID(`id_conta`) ? 'is-invalid' : '',
                            ]"
                          />
                          <button
                            class="input-group-text"
                            @click="this.modalContas(true)"
                          >
                            <span class="svg-icon svg-icon-2">
                              <inline-svg
                                src="media/icons/duotune/general/gen004.svg"
                              />
                            </span>
                          </button>
                        </div>
                        <div
                          v-if="getErrorByID(`id_conta`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`id_conta`) }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-3 mb-2"
                    >
                      <div class="mb-6 fv-row">
                        <label class="form-label">Custo</label>
                        <div class="input-group">
                          <input
                            :id="`id_custo`"
                            type="text"
                            class="form-control"
                            v-model="this.faturamento.id_custo"
                            readonly
                            :class="[
                              getErrorByID(`id_custo`) ? 'is-invalid' : '',
                            ]"
                          />
                          <button
                            class="input-group-text"
                            @click="this.modalCustos(true)"
                          >
                            <span class="svg-icon svg-icon-2">
                              <inline-svg
                                src="media/icons/duotune/general/gen004.svg"
                              />
                            </span>
                          </button>
                        </div>
                        <div
                          v-if="getErrorByID(`id_custo`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`id_custo`) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <div class="card-title" ref="faturamento_cliente">
                    <h2>Dados do Cliente</h2>
                  </div>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="row">
                    <!-- <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-2 mb-2"
                    >
                      <label class="form-label">Código</label>
                      <input
                        :id="`FaturamentoClienteid_cliente`"
                        type="text"
                        class="form-control form-control-solid"
                        v-model="this.faturamento.FaturamentoCliente.id_cliente"
                        readonly
                        :class="[
                          getErrorByID(`FaturamentoClienteid_cliente`)
                            ? 'is-invalid'
                            : '',
                        ]"
                      />
                      <div
                        v-if="getErrorByID(`FaturamentoClienteid_cliente`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`FaturamentoClienteid_cliente`) }}
                      </div>
                    </div> -->
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-2 mb-2"
                    >
                      <label class="form-label">Código</label>
                      <input
                        :id="`FaturamentoClienteClientecodigo`"
                        type="text"
                        class="form-control form-control-solid"
                        v-model="
                          this.faturamento.FaturamentoCliente.Cliente.codigo
                        "
                        readonly
                        :class="[
                          getErrorByID(`FaturamentoClienteClientecodigo`)
                            ? 'is-invalid'
                            : '',
                        ]"
                      />
                      <div
                        v-if="getErrorByID(`FaturamentoClienteClientecodigo`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`FaturamentoClienteClientecodigo`) }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-9 col-xxl-10 mb-2"
                    >
                      <div class="mb-6 fv-row">
                        <label for="txtNome" class="required form-label"
                          >Nome / Razão social</label
                        >
                        <div class="input-group mb-2">
                          <input
                            type="text"
                            :id="`FaturamentoClientenome`"
                            :value="
                              (this.faturamento.FaturamentoCliente.nome = this
                                .faturamento.FaturamentoCliente.nome
                                ? this.faturamento.FaturamentoCliente.nome.toUpperCase()
                                : '')
                            "
                            readonly
                            class="form-control"
                            :class="[
                              getErrorByID(`FaturamentoClientenome`)
                                ? 'is-invalid'
                                : '',
                            ]"
                          />
                          <button
                            type="button"
                            class="input-group-text"
                            @click="modalClientes(true)"
                          >
                            <span class="svg-icon svg-icon-2">
                              <inline-svg
                                src="media/icons/duotune/general/gen004.svg"
                              />
                            </span>
                          </button>
                        </div>
                        <div
                          v-if="getErrorByID(`FaturamentoClientenome`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`FaturamentoClientenome`) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-7 col-xxl-7 mb-2"
                    >
                      <div class="mb-6 fv-row">
                        <label for="txtCPFCNPJ" class="form-label"
                          >CPF / CNPJ</label
                        >
                        <input
                          type="text"
                          :id="`FaturamentoClientecpf_cnpj`"
                          :class="[
                            getErrorByID(`FaturamentoClientecpf_cnpj`)
                              ? 'is-invalid'
                              : '',
                          ]"
                          v-mask="['###.###.###-##', '##.###.###/####-##']"
                          v-model="this.faturamento.FaturamentoCliente.cpf_cnpj"
                          readonly
                          class="form-control"
                        />
                        <div
                          v-if="getErrorByID(`FaturamentoClientecpf_cnpj`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`FaturamentoClientecpf_cnpj`) }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xxl-5 mb-2"
                    >
                      <div class="mb-6 fv-row">
                        <label for="FaturamentoClienterg_ie" class="form-label"
                          >RG / IE</label
                        >
                        <input
                          type="text"
                          :id="`FaturamentoClienterg_ie`"
                          readonly
                          class="form-control"
                          v-model="this.faturamento.FaturamentoCliente.rg_ie"
                          :class="[
                            getErrorByID(`FaturamentoClienterg_ie`)
                              ? 'is-invalid'
                              : '',
                          ]"
                        />
                        <div
                          v-if="getErrorByID(`FaturamentoClienterg_ie`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`FaturamentoClienterg_ie`) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-5 mb-2"
                    >
                      <div class="mb-6 fv-row">
                        <label
                          for="FaturamentoClientetelefone"
                          class="form-label"
                          >Telefone</label
                        >
                        <div class="input-group">
                          <span class="input-group-text" id="basic-addon3">
                            <i class="bi bi-telephone fs-3"></i>
                          </span>
                          <input
                            type="text"
                            :id="`FaturamentoClientetelefone`"
                            readonly
                            class="form-control"
                            v-mask="['(##) ####-####', '(##) #####-####']"
                            v-model="
                              this.faturamento.FaturamentoCliente.telefone
                            "
                            :class="[
                              getErrorByID(`FaturamentoClientetelefone`)
                                ? 'is-invalid'
                                : '',
                            ]"
                          />
                        </div>
                        <div
                          v-if="getErrorByID(`FaturamentoClientetelefone`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`FaturamentoClientetelefone`) }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-7 mb-2"
                    >
                      <div class="mb-6 fv-row">
                        <label for="FaturamentoClienteemail" class="form-label"
                          >Email</label
                        >
                        <div class="input-group">
                          <span class="input-group-text" id="basic-addon3">
                            <i class="bi bi-at fs-3"></i>
                          </span>
                          <input
                            type="text"
                            :id="`FaturamentoClienteemail`"
                            readonly
                            class="form-control"
                            v-model="this.faturamento.FaturamentoCliente.email"
                          />
                        </div>
                        <div
                          v-if="getErrorByID(`FaturamentoClienteemail`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`FaturamentoClienteemail`) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 fv-row mb-6"
                    >
                      <label class="form-label fw-bold fs-6">CEP</label>
                      <div class="input-group">
                        <input
                          :id="`FaturamentoClienteFaturamentoEnderecocep`"
                          type="text"
                          @keydown.stop.prevent.enter="pesquisarCep(0)"
                          readonly
                          class="form-control"
                          v-mask="'#####-###'"
                          v-model="
                            this.faturamento.FaturamentoCliente
                              .FaturamentoEndereco.cep
                          "
                          :class="[
                            getErrorByID(
                              `FaturamentoClienteFaturamentoEnderecocep`
                            )
                              ? 'is-invalid'
                              : '',
                          ]"
                        />
                      </div>
                      <div
                        v-if="
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecocep`
                          )
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecocep`
                          )
                        }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-8 fv-row mb-6"
                    >
                      <label class="form-label fw-bold fs-6">Endereço</label>
                      <input
                        :id="`FaturamentoClienteFaturamentoEnderecoendereco`"
                        type="text"
                        readonly
                        class="form-control"
                        v-model="
                          this.faturamento.FaturamentoCliente
                            .FaturamentoEndereco.endereco
                        "
                        :class="[
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecoendereco`
                          )
                            ? 'is-invalid'
                            : '',
                        ]"
                      />
                      <div
                        v-if="
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecoendereco`
                          )
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecoendereco`
                          )
                        }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-2 fv-row mb-6"
                    >
                      <label class="form-label fw-bold fs-6">Número</label>
                      <input
                        :id="`FaturamentoClienteFaturamentoEndereconumero`"
                        type="text"
                        readonly
                        class="form-control"
                        v-model="
                          this.faturamento.FaturamentoCliente
                            .FaturamentoEndereco.numero
                        "
                        :class="[
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEndereconumero`
                          )
                            ? 'is-invalid'
                            : '',
                        ]"
                      />
                      <div
                        v-if="
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEndereconumero`
                          )
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEndereconumero`
                          )
                        }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
                    >
                      <label class="form-label fw-bold fs-6">Bairro</label>
                      <input
                        :id="`FaturamentoClienteFaturamentoEnderecobairro`"
                        type="text"
                        class="form-control"
                        readonly
                        v-model="
                          this.faturamento.FaturamentoCliente
                            .FaturamentoEndereco.bairro
                        "
                        :class="[
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecobairro`
                          )
                            ? 'is-invalid'
                            : '',
                        ]"
                      />
                      <div
                        v-if="
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecobairro`
                          )
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecobairro`
                          )
                        }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 fv-row mb-6"
                    >
                      <label class="form-label fw-bold fs-6">Complemento</label>
                      <input
                        :id="`FaturamentoClienteFaturamentoEnderecocomplemento`"
                        type="text"
                        readonly
                        class="form-control"
                        v-model="
                          this.faturamento.FaturamentoCliente
                            .FaturamentoEndereco.complemento
                        "
                        :class="[
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecocomplemento`
                          )
                            ? 'is-invalid'
                            : '',
                        ]"
                      />
                      <div
                        v-if="
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecocomplemento`
                          )
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecocomplemento`
                          )
                        }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-2 fv-row mb-6"
                    >
                      <label class="form-label required fw-bold fs-6">UF</label>
                      <input
                        :id="`FaturamentoClienteFaturamentoEnderecouf`"
                        type="text"
                        class="form-control"
                        readonly
                        :value="
                          this.faturamento.FaturamentoCliente
                            .FaturamentoEndereco.uf
                            ? this.faturamento.FaturamentoCliente.FaturamentoEndereco.uf.toUpperCase()
                            : ''
                        "
                        @input="
                          this.faturamento.FaturamentoCliente.FaturamentoEndereco.uf =
                            $event.target.value.toUpperCase()
                        "
                        :class="[
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecouf`
                          )
                            ? 'is-invalid'
                            : '',
                        ]"
                      />
                      <div
                        v-if="
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecouf`
                          )
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecouf`
                          )
                        }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 fv-row mb-6"
                    >
                      <label class="form-label fw-bold fs-6">Cidade</label>
                      <div class="input-group">
                        <input
                          :id="`FaturamentoClienteFaturamentoEnderecocidade`"
                          type="text"
                          class="form-control"
                          readonly
                          :value="
                            this.faturamento.FaturamentoCliente
                              .FaturamentoEndereco.cidade
                              ? this.faturamento.FaturamentoCliente.FaturamentoEndereco.cidade.toUpperCase()
                              : ''
                          "
                          @input="
                            this.faturamento.FaturamentoCliente.FaturamentoEndereco.cidade =
                              $event.target.value.toUpperCase()
                          "
                          :class="[
                            getErrorByID(
                              `FaturamentoClienteFaturamentoEnderecocidade`
                            )
                              ? 'is-invalid'
                              : '',
                          ]"
                        />
                      </div>
                      <div
                        v-if="
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecocidade`
                          )
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecocidade`
                          )
                        }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 fv-row mb-6"
                    >
                      <label class="form-label fw-bold fs-6">País</label>
                      <div class="input-group">
                        <input
                          :id="`FaturamentoClienteEnderecopais`"
                          type="text"
                          class="form-control"
                          readonly
                          :value="
                            this.faturamento.FaturamentoCliente
                              .FaturamentoEndereco.pais
                              ? this.faturamento.FaturamentoCliente.FaturamentoEndereco.pais.toUpperCase()
                              : ''
                          "
                          @input="
                            this.faturamento.FaturamentoCliente.FaturamentoEndereco.pais =
                              $event.target.value.toUpperCase()
                          "
                          :class="[
                            getErrorByID(
                              `FaturamentoClienteFaturamentoEnderecopais`
                            )
                              ? 'is-invalid'
                              : '',
                          ]"
                        />
                      </div>
                      <div
                        v-if="
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecopais`
                          )
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          getErrorByID(
                            `FaturamentoClienteFaturamentoEnderecopais`
                          )
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <div class="card-title">
                    <h2>Endereços</h2>
                  </div>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 align-self-end"
                    >
                      <div class="mb-8 fv-row">
                        <label for="txtEnderecoEntrega" class="form-label"
                          >Endereço de entrega</label
                        >
                        <div class="input-group mb-2">
                          <input
                            type="text"
                            id="txtEnderecoEntrega"
                            :value="
                              this.faturamento.FaturamentoCliente &&
                              this.faturamento.FaturamentoCliente
                                .FaturamentoEnderecoEntrega &&
                              this.faturamento.FaturamentoCliente
                                .FaturamentoEnderecoEntrega
                                .id_cliente_endereco > 0
                                ? this.faturamento.FaturamentoCliente
                                    .FaturamentoEnderecoEntrega.descricao
                                : ''
                            "
                            class="form-control"
                            readonly
                          />
                          <span
                            type="button"
                            class="svg-icon svg-icon-1 position-absolute end-0 me-18 mt-3"
                            @click="limparEnderecoEntrega()"
                          >
                            <inline-svg
                              src="media/icons/duotune/arrows/arr061.svg"
                            />
                          </span>
                          <button
                            type="button"
                            class="input-group-text"
                            @click="this.exibirEnderecos(1)"
                          >
                            <span class="svg-icon svg-icon-2">
                              <inline-svg
                                src="media/icons/duotune/general/gen004.svg"
                              />
                            </span>
                          </button>
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ errosValidacao["id_endereco_entrega"] }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 align-self-end"
                    >
                      <div class="mb-8 fv-row">
                        <label for="txtEnderecoRetirada" class="form-label"
                          >Endereço de retirada</label
                        >
                        <div class="input-group mb-2">
                          <input
                            type="text"
                            id="txtEnderecoRetirada"
                            :value="
                              this.faturamento.FaturamentoCliente &&
                              this.faturamento.FaturamentoCliente
                                .FaturamentoEnderecoRetirada &&
                              this.faturamento.FaturamentoCliente
                                .FaturamentoEnderecoRetirada
                                .id_cliente_endereco > 0
                                ? this.faturamento.FaturamentoCliente
                                    .FaturamentoEnderecoRetirada.descricao
                                : ''
                            "
                            class="form-control"
                            readonly
                          />
                          <span
                            type="button"
                            class="svg-icon svg-icon-1 position-absolute end-0 me-18 mt-3"
                            @click="limparEnderecoRetirada()"
                          >
                            <inline-svg
                              src="media/icons/duotune/arrows/arr061.svg"
                            />
                          </span>
                          <button
                            type="button"
                            class="input-group-text"
                            @click="this.exibirEnderecos(2)"
                          >
                            <span class="svg-icon svg-icon-2">
                              <inline-svg
                                src="media/icons/duotune/general/gen004.svg"
                              />
                            </span>
                          </button>
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ errosValidacao["id_endereco_retirada"] }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <div class="card-title">
                    <h2>Observações</h2>
                  </div>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="mb-6 fv-row">
                    <label class="form-label">Observações</label>
                    <textarea
                      :id="`observacao`"
                      class="form-control mb-2"
                      placeholder="Observações"
                      maxlength="5000"
                      style="height: 250px"
                      v-model="faturamento.observacao"
                      :class="[getErrorByID(`observacao`) ? 'is-invalid' : '']"
                    />
                    <div class="row">
                      <div class="col-6 pe-0">
                        <div
                          v-if="getErrorByID(`observacao`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`observacao`) }}
                        </div>
                      </div>
                      <div class="col-6 ps-2">
                        <div class="text-end text-muted fs-7">
                          {{
                            faturamento.observacao
                              ? faturamento.observacao.length
                              : "0"
                          }}/5000 caracteres
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <div class="card-title">
                    <h2>Transportadora</h2>
                  </div>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-7 align-self-end"
                    >
                      <div class="mb-8 fv-row">
                        <label for="txtTransportadora" class="form-label"
                          >Transportadora / Entregador</label
                        >
                        <div class="input-group mb-2">
                          <input
                            type="text"
                            id="txtTransportadora"
                            :value="
                              this.faturamento.Transportadora
                                ? (this.faturamento.Transportadora.nome = this
                                    .faturamento.Transportadora.nome
                                    ? this.faturamento.Transportadora.nome.toUpperCase()
                                    : '')
                                : ''
                            "
                            @input="
                              this.faturamento.Transportadora.nome =
                                $event.target.value.toUpperCase()
                            "
                            class="form-control"
                            readonly
                          />
                          <span
                            type="button"
                            class="svg-icon svg-icon-1 position-absolute end-0 me-18 mt-3"
                            @click="limparTransportadoraFaturamento()"
                          >
                            <inline-svg
                              src="media/icons/duotune/arrows/arr061.svg"
                            />
                          </span>
                          <button
                            type="button"
                            class="input-group-text"
                            @click="modalTransportadoras(true)"
                          >
                            <span class="svg-icon svg-icon-2">
                              <inline-svg
                                src="media/icons/duotune/general/gen004.svg"
                              />
                            </span>
                          </button>
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ errosValidacao["id_transportadora"] }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-5 mb-7"
                    >
                      <label class="form-label">Frete</label>
                      <select
                        class="form-select"
                        v-model="this.faturamento.frete"
                      >
                        <option value="0">Emitente</option>
                        <option value="1">Destinatário</option>
                        <option value="2">Terceiros</option>
                        <option value="9">Sem Frete</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-7 align-self-end"
                    >
                      <div class="mb-8 fv-row">
                        <label for="txtMotorista" class="form-label"
                          >Motorista</label
                        >
                        <div class="input-group mb-2">
                          <input
                            type="text"
                            id="txtMotorista"
                            :value="
                              this.faturamento.Motorista
                                ? (this.faturamento.Motorista.nome = this
                                    .faturamento.Motorista.nome
                                    ? this.faturamento.Motorista.nome.toUpperCase()
                                    : '')
                                : ''
                            "
                            @input="
                              this.faturamento.Motorista.nome =
                                $event.target.value.toUpperCase()
                            "
                            class="form-control"
                            readonly
                          />
                          <span
                            type="button"
                            class="svg-icon svg-icon-1 position-absolute end-0 me-18 mt-3"
                            @click="limparMotoristaFaturamento()"
                          >
                            <inline-svg
                              src="media/icons/duotune/arrows/arr061.svg"
                            />
                          </span>
                          <button
                            type="button"
                            class="input-group-text"
                            @click="modalMotoristas(true)"
                          >
                            <span class="svg-icon svg-icon-2">
                              <inline-svg
                                src="media/icons/duotune/general/gen004.svg"
                              />
                            </span>
                          </button>
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ errosValidacao["id_motorista"] }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-if="
                      this.faturamento.id_transportadora &&
                      this.faturamento.id_transportadora > 0
                    "
                  >
                    <div class="card card-flush py-4 px-0">
                      <div class="card-header px-3">
                        <h3 class="card-title align-items-start flex-column">
                          <span class="card-label fw-bolder fs-3 mb-1"
                            >Veículo Transporte</span
                          >
                        </h3>
                        <div class="card-toolbar">
                          <div
                            class="d-flex justify-content-end"
                            data-kt-customer-table-toolbar="base"
                          >
                            <button
                              @click="adicionarFaturamentoVeicTransp()"
                              type="button"
                              class="btn btn-sm btn-light btn-active-primary"
                            >
                              <span class="svg-icon svg-icon-1">
                                <inline-svg
                                  src="media/icons/duotune/arrows/arr075.svg" /></span
                              >Adicionar
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="card-body pt-0 pb-0 px-3">
                        <div class="table-responsive">
                          <table
                            :class="[
                              loadingVeicTransp && 'overlay overlay-block',
                            ]"
                            class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                            id="kt_table_veic_transp"
                          >
                            <thead>
                              <tr class="fw-bolder text-muted">
                                <th class="min-w-100px">Placa</th>
                                <th class="min-w-100px">UF</th>
                                <th class="min-w-100px">RNTC (ANTT)</th>
                                <th class="min-w-100px text-end">Ações</th>
                              </tr>
                            </thead>
                            <tbody>
                              <template
                                v-if="
                                  this.faturamento.FaturamentoVeicTransp
                                    .length > 0
                                "
                              >
                                <template
                                  v-for="(nf, i) in this.faturamento
                                    .FaturamentoVeicTransp"
                                  :key="i"
                                >
                                  <tr>
                                    <td>
                                      <div class="min-w-100px align-middle">
                                        <div>
                                          <span
                                            class="text-dark text-hover-primary mb-1"
                                          >
                                            {{ nf.placa }}
                                          </span>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div class="min-w-100px align-middle">
                                        <div>
                                          <span
                                            class="text-dark text-hover-primary mb-1"
                                          >
                                            {{ nf.UF }}
                                          </span>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div class="min-w-100px align-middle">
                                        <div>
                                          <span
                                            class="text-dark text-hover-primary mb-1"
                                          >
                                            {{ nf.RNTC }}
                                          </span>
                                        </div>
                                      </div>
                                    </td>
                                    <td
                                      class="d-flex justify-content-end flex-shrink-0"
                                    >
                                      <button
                                        class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                        @click="editarFaturamentoVeicTransp(i)"
                                      >
                                        <span class="svg-icon svg-icon-5 m-0">
                                          <inline-svg
                                            src="media/icons/duotune/art/art005.svg"
                                          />
                                        </span>
                                      </button>
                                      <button
                                        class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                        @click="removerFaturamentoVeicTransp(i)"
                                      >
                                        <span class="svg-icon svg-icon-5 m-0">
                                          <inline-svg
                                            src="media/icons/duotune/general/gen027.svg"
                                          />
                                        </span>
                                      </button>
                                    </td>
                                  </tr>
                                </template>
                              </template>
                              <template v-else>
                                <tr class="odd">
                                  <td :colSpan="12" class="dataTables_empty">
                                    {{ "Sem registros" }}
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                            <div
                              v-if="loadingVeicTransp"
                              class="overlay-layer card-rounded bg-dark bg-opacity-5"
                            >
                              <div
                                class="spinner-border text-primary"
                                role="status"
                              ></div>
                              <span class="ms-2">Aguarde, carregando...</span>
                            </div>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <div class="card-title">
                    <h2>Vendedor</h2>
                  </div>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6"
                    >
                      <div class="mb-8 fv-row">
                        <label for="txtVendedor" class="form-label"
                          >Vendedor</label
                        >
                        <div class="input-group mb-2">
                          <input
                            type="text"
                            id="txtVendedor"
                            :value="
                              this.faturamento.Vendedor
                                ? (this.faturamento.Vendedor.nome = this
                                    .faturamento.Vendedor.nome
                                    ? this.faturamento.Vendedor.nome.toUpperCase()
                                    : '')
                                : ''
                            "
                            @input="
                              this.faturamento.Vendedor.nome =
                                $event.target.value.toUpperCase()
                            "
                            class="form-control"
                            readonly
                          />
                          <span
                            type="button"
                            class="svg-icon svg-icon-1 position-absolute end-0 me-18 mt-3"
                            @click="limparVendedorPedido()"
                          >
                            <inline-svg
                              src="media/icons/duotune/arrows/arr061.svg"
                            />
                          </span>
                          <button
                            type="button"
                            class="input-group-text"
                            @click="modalVendedores(true)"
                          >
                            <span class="svg-icon svg-icon-2">
                              <inline-svg
                                src="media/icons/duotune/general/gen004.svg"
                              />
                            </span>
                          </button>
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ errosValidacao["id_vendedor"] }}
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-xl-6 col-xxl-3 fv-row mb-4">
                      <label class="form-label">Comissão %</label>
                      <CurrencyInput
                        class="form-control mb-2 text-primary"
                        placeholder="Comissão %"
                        style="text-align: right"
                        v-model="this.faturamento.comissao_per"
                        :options="options"
                        @change="recalcularValores()"
                      ></CurrencyInput>
                    </div>
                    <div class="col-lg-6 col-xl-6 col-xxl-3 fv-row mb-4">
                      <label class="form-label">Comissão R$</label>
                      <CurrencyInput
                        class="form-control mb-2 text-danger"
                        placeholder="Comissão R$"
                        style="text-align: right"
                        v-model="this.faturamento.comissao_valor"
                        :options="options"
                        @keydown.stop.prevent.enter="
                          calculaPercentualComissao()
                        "
                      ></CurrencyInput>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="this.faturamento.id === 0"
              class="d-flex flex-column gap-7 gap-lg-10 mb-10"
            >
              <div class="card card-flush py-4">
                <div class="card-header">
                  <h3 class="card-title align-items-start flex-column">
                    <span class="card-label fw-bolder fs-3 mb-1"
                      >Modelo Faturamento</span
                    >
                    <span class="text-muted mt-1 fw-bold fs-7"
                      >Modelo selecionado</span
                    >
                  </h3>
                  <div class="card-toolbar">
                    <div
                      class="d-flex justify-content-end"
                      data-kt-customer-table-toolbar="base"
                    >
                      <button
                        @click="selecionarModelosFaturamento()"
                        type="button"
                        class="btn btn-sm btn-light btn-active-primary"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/general/gen004.svg" /></span
                        >Selecionar Modelo
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-2 fv-row mb-6"
                    >
                      <label class="form-label">ID</label>
                      <input
                        type="text"
                        class="form-control form-control-solid"
                        v-model="this.faturamento.ModelosFaturamento.id"
                        readonly
                      />
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-2 fv-row mb-6"
                    >
                      <label class="form-label">Modelo</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="this.faturamento.ModelosFaturamento.modelo"
                        readonly
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ModelosFaturamento.modelo"] }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xxl-2 fv-row mb-6"
                    >
                      <label class="form-label">Série</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="this.faturamento.ModelosFaturamento.serie"
                        readonly
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ModelosFaturamento.serie"] }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 fv-row mb-6"
                    >
                      <label class="form-label">Descrição</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="this.faturamento.ModelosFaturamento.descricao"
                        readonly
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ModelosFaturamento.descricao"] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="
                this.faturamento.FaturamentoImportacoes !== undefined &&
                this.faturamento.FaturamentoImportacoes !== null &&
                this.faturamento.FaturamentoImportacoes.length > 0
              "
              class="d-flex flex-column gap-7 gap-lg-10 mb-10"
            >
              <div class="card card-flush py-4">
                <div class="card-header">
                  <h3 class="card-title align-items-start flex-column">
                    <span class="card-label fw-bolder fs-3 mb-1"
                      >Importações</span
                    >
                  </h3>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="row">
                    <div class="table-responsive">
                      <table
                        class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                        id="kt_table_importacoes"
                      >
                        <thead>
                          <tr class="fw-bolder text-muted">
                            <th class="min-w-100px">ID</th>
                            <th class="min-w-120px">Módulo</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template
                            v-if="
                              this.faturamento.FaturamentoImportacoes.length > 0
                            "
                          >
                            <template
                              v-for="(importacao, i) in this.faturamento
                                .FaturamentoImportacoes"
                              :key="i"
                            >
                              <tr>
                                <td>
                                  <div class="min-w-100px align-middle">
                                    <div>
                                      <span
                                        class="text-dark text-hover-primary mb-1"
                                      >
                                        {{ importacao.id_importacao }}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div class="min-w-120px align-middle">
                                    <div>
                                      <span
                                        class="badge badge-light-primary text-primary"
                                      >
                                        {{ importacao.modulo }}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </template>
                          </template>
                          <template v-else>
                            <tr class="odd">
                              <td :colSpan="12" class="dataTables_empty">
                                {{ "Sem registros" }}
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade tab-pane-faturamento"
            id="kt_faturamento_produtos"
            role="tab-panel"
          >
            <div class="d-flex flex-column gap-7 gap-lg-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <div class="card-title">
                    <h2>Produtos</h2>
                  </div>
                </div>
                <div class="card-body pt-4 pb-6">
                  <div class="row" v-if="this.exibirInclusaoRapida">
                    <div class="col-xl-7 col-xxl-5 col-lg-12 fv-row mb-6">
                      <div class="input-group h-45px">
                        <input
                          autocomplete="off"
                          type="search"
                          id="InclusaoRapida"
                          v-model="pesquisaProduto"
                          @keydown.stop.prevent.enter="inclusaoRapidaProduto()"
                          class="form-control"
                          placeholder="Informe o código do produto"
                        />
                        <button
                          type="button"
                          class="input-group-text py-0 px-2"
                          @click="inclusaoRapidaProduto()"
                        >
                          <span class="svg-icon svg-icon-primary svg-icon-2hx">
                            <inline-svg
                              src="media/icons/duotune/arrows/arr087.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["inclusaoRapida"] }}
                      </div>
                    </div>
                    <div class="col-xl-3 col-xxl-3 col-lg-4 fv-row mb-6">
                      <div class="form-check form-check-custom form-check-sm">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="rbPesquisaRapida"
                          id="rbCodigo"
                          checked
                        />
                        <label class="form-check-label" for="rbCodigo">
                          <h6>Código</h6>
                        </label>
                      </div>
                      <div class="form-check form-check-custom form-check-sm">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="rbPesquisaRapida"
                          id="rbBarras"
                        />
                        <label class="form-check-label" for="rbBarras">
                          <h6>Barras</h6>
                        </label>
                      </div>
                    </div>
                    <div
                      class="col-xxl-4 col-xl-12 col-lg-8 fv-row mb-6 d-flex justify-content-lg-end justify-content-xl-end"
                    >
                      <button
                        @click="modalProdutos(true)"
                        type="button"
                        class="btn btn-primary min-w-175px h-45px"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/ecommerce/ecm009.svg"
                          />
                          Pesquisar
                        </span>
                      </button>
                    </div>
                  </div>
                  <Datatable
                    :table-header="this.tableProdutoHeader"
                    :table-data="this.faturamento.FaturamentoItem"
                    :rowsPerPage="1000"
                    :emptyTableText="'Nenhum produto adicionado'"
                    :enableItemsPerPageDropdown="false"
                    :loading="this.isLoadingItens"
                  >
                    <template v-slot:cell-item="{ position: index }">
                      <div
                        :id="`FaturamentoItem[${index}]item`"
                        class="text-center"
                        tabindex="0"
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]item`)
                            ? 'min-w-100px'
                            : '',
                        ]"
                      >
                        {{
                          (this.faturamento.FaturamentoItem[index].item =
                            index + 1)
                        }}
                      </div>
                      <div
                        v-if="getErrorByID(`FaturamentoItem[${index}]item`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`FaturamentoItem[${index}]item`) }}
                      </div>
                    </template>
                    <template v-slot:cell-id_produto="{ position: index }">
                      <div
                        :id="`FaturamentoItem[${index}]id_produto`"
                        v-if="
                          this.faturamento.FaturamentoItem[index].em_branco ===
                            false ||
                          this.faturamento.FaturamentoItem[index].em_branco ===
                            undefined
                        "
                        class="text-center"
                        tabindex="0"
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]id_produto`)
                            ? 'min-w-100px'
                            : '',
                        ]"
                      >
                        {{
                          this.faturamento.FaturamentoItem[index].Produto.codigo
                        }}
                      </div>
                      <div
                        v-else
                        class="input-group"
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]id_produto`)
                            ? 'min-w-200px'
                            : 'min-w-150px',
                        ]"
                      >
                        <input
                          :id="`FaturamentoItem[${index}]id_produto`"
                          placeholder="Código"
                          class="form-control autosized-input text-hover input-focus"
                          v-model="
                            this.faturamento.FaturamentoItem[index].Produto
                              .codigo
                          "
                          @keydown.stop.prevent.enter="
                            adicionarProdutoCodigoGrid(index)
                          "
                          autocomplete="off"
                          type="search"
                          :class="[
                            getErrorByID(`FaturamentoItem[${index}]id_produto`)
                              ? 'is-invalid'
                              : '',
                          ]"
                        />
                        <button
                          type="button"
                          class="input-group-text"
                          @click="modalProdutos(true)"
                          data-bs-toggle="tooltip"
                          data-bs-dismiss="click"
                          title="(CTRL + S) (CMD + S) (F3) Pesquisar produtos"
                          tooltip="(CTRL + S) (CMD + S) (F3) Pesquisar produtos"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        v-if="
                          getErrorByID(`FaturamentoItem[${index}]id_produto`)
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          getErrorByID(`FaturamentoItem[${index}]id_produto`)
                        }}
                      </div>
                    </template>
                    <template v-slot:cell-imagem="{ row: faturamentoItem }">
                      <div
                        v-if="
                          faturamentoItem.Produto &&
                          faturamentoItem.Produto.imagem
                            ? faturamentoItem.Produto.imagem
                            : ''
                        "
                        class="symbol symbol-50px"
                      >
                        <div
                          class="symbol-label fs-2 fw-bold bg-light-dark"
                          :style="{
                            'background-image': `url(${
                              this.$utils.getUrl() +
                              faturamentoItem.Produto.imagem
                            })`,
                          }"
                        ></div>
                      </div>
                      <div v-else class="symbol symbol-50px">
                        <div
                          :class="[
                            'symbol-label fs-2 fw-bold ' +
                              faturamentoItem.color,
                          ]"
                        >
                          {{
                            faturamentoItem.nome
                              ? faturamentoItem.nome
                                  .substring(0, 1)
                                  .toUpperCase()
                              : ""
                          }}
                        </div>
                      </div>
                    </template>
                    <template
                      v-slot:cell-nome="{
                        row: faturamentoItem,
                        position: index,
                      }"
                    >
                      <div class="min-w-200px align-middle">
                        <FocusTextInput
                          :id="`FaturamentoItem[${index}]nome`"
                          class="min-w-200px"
                          placeholder="Descrição do produto"
                          v-model="this.faturamento.FaturamentoItem[index].nome"
                          @keydown.stop.prevent.enter="
                            nextFocus(`FaturamentoItem[${index}]und`)
                          "
                          :hasError="
                            getErrorByID(`FaturamentoItem[${index}]nome`)
                              ? true
                              : false
                          "
                        ></FocusTextInput>
                        <div
                          v-if="faturamentoItem.observacao"
                          class="ps-4 text-quebrar-linha fs-7"
                        >
                          {{ faturamentoItem.observacao }}
                        </div>
                        <div
                          v-if="getErrorByID(`FaturamentoItem[${index}]nome`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`FaturamentoItem[${index}]nome`) }}
                        </div>
                      </div>
                    </template>
                    <template v-slot:cell-und="{ position: index }">
                      <FocusTextInput
                        :id="`FaturamentoItem[${index}]und`"
                        placeholder="UND"
                        v-model="this.faturamento.FaturamentoItem[index].und"
                        :maxlength="3"
                        :upper="true"
                        style="text-align: center"
                        @keydown.stop.prevent.enter="
                          nextFocus(`FaturamentoItem[${index}]qtd`)
                        "
                        :hasError="
                          getErrorByID(`FaturamentoItem[${index}]und`)
                            ? true
                            : false
                        "
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]und`)
                            ? 'min-w-100px'
                            : 'min-w-60px',
                        ]"
                      ></FocusTextInput>
                      <div
                        v-if="getErrorByID(`FaturamentoItem[${index}]und`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`FaturamentoItem[${index}]und`) }}
                      </div>
                    </template>
                    <template v-slot:cell-qtd="{ position: index }">
                      <FocusCurrencyInput
                        :id="`FaturamentoItem[${index}]qtd`"
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]qtd`)
                            ? 'min-w-100px'
                            : 'min-w-60px',
                        ]"
                        :hasError="
                          getErrorByID(`FaturamentoItem[${index}]qtd`)
                            ? true
                            : false
                        "
                        placeholder="QTD"
                        v-model="this.faturamento.FaturamentoItem[index].qtd"
                        :options="optionsQtd"
                        style="text-align: center"
                        @keydown.stop.prevent.enter="
                          nextFocus(`FaturamentoItem[${index}]preco`)
                        "
                        @change="recalcularValores()"
                      ></FocusCurrencyInput>
                      <div
                        v-if="getErrorByID(`FaturamentoItem[${index}]qtd`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`FaturamentoItem[${index}]qtd`) }}
                      </div>
                    </template>
                    <template v-slot:cell-preco="{ position: index }">
                      <FocusCurrencyInput
                        :id="`FaturamentoItem[${index}]preco`"
                        :hasError="
                          getErrorByID(`FaturamentoItem[${index}]preco`)
                            ? true
                            : false
                        "
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]preco`)
                            ? 'min-w-100px'
                            : 'min-w-60px',
                        ]"
                        placeholder="Preço"
                        v-model="this.faturamento.FaturamentoItem[index].preco"
                        :options="optionsPreco"
                        style="text-align: right"
                        @keydown.stop.prevent.enter="
                          nextFocus(`FaturamentoItem[${index}]cfop`)
                        "
                        @change="recalcularValores()"
                      ></FocusCurrencyInput>
                      <div
                        v-if="getErrorByID(`FaturamentoItem[${index}]preco`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`FaturamentoItem[${index}]preco`) }}
                      </div>
                    </template>
                    <template v-slot:cell-total="{ position: index }">
                      <FocusCurrencyInput
                        :id="`FaturamentoItem[${index}]total`"
                        placeholder="Total"
                        readonly
                        v-model="this.faturamento.FaturamentoItem[index].total"
                        :options="options"
                        style="text-align: right"
                        @keydown.stop.prevent.enter="
                          nextFocus(`FaturamentoItem[${index}]cfop`)
                        "
                        @change="recalcularValores()"
                        :hasError="
                          getErrorByID(`FaturamentoItem[${index}]total`)
                            ? true
                            : false
                        "
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]total`)
                            ? 'min-w-100px'
                            : 'min-w-60px',
                        ]"
                      ></FocusCurrencyInput>
                      <div
                        v-if="getErrorByID(`FaturamentoItem[${index}]total`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`FaturamentoItem[${index}]total`) }}
                      </div>
                    </template>
                    <template v-slot:cell-cfop="{ position: index }">
                      <FocusTextInput
                        :id="`FaturamentoItem[${index}]cfop`"
                        :hasError="
                          getErrorByID(`FaturamentoItem[${index}]cfop`)
                            ? true
                            : false
                        "
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]cfop`)
                            ? 'min-w-100px'
                            : 'min-w-60px',
                        ]"
                        placeholder="CFOP"
                        v-model="this.faturamento.FaturamentoItem[index].cfop"
                        :maxlength="4"
                        :upper="true"
                        style="text-align: center"
                        @keydown.stop.prevent.enter="
                          verificarCFOP(`FaturamentoItem[${index}]cfop`, index)
                        "
                        @change="
                          recalcularValores();
                          verificarCFOP(`FaturamentoItem[${index}]cfop`, index);
                        "
                      ></FocusTextInput>
                      <div
                        v-if="getErrorByID(`FaturamentoItem[${index}]cfop`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`FaturamentoItem[${index}]cfop`) }}
                      </div>
                    </template>
                    <template
                      v-if="this.user.User.Emitente.crt != 1"
                      v-slot:cell-cst="{ position: index }"
                    >
                      <FocusTextInput
                        :id="`FaturamentoItem[${index}]st`"
                        :hasError="
                          getErrorByID(`FaturamentoItem[${index}]st`)
                            ? true
                            : false
                        "
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]st`)
                            ? 'min-w-100px'
                            : 'min-w-60px',
                        ]"
                        placeholder="CST"
                        v-model="this.faturamento.FaturamentoItem[index].st"
                        :maxlength="3"
                        :upper="true"
                        style="text-align: center"
                        @keydown.stop.prevent.enter="
                          verificarCST(`FaturamentoItem[${index}]st`, index)
                        "
                        @change="
                          recalcularValores();
                          verificarCST(`FaturamentoItem[${index}]st`, index);
                        "
                      ></FocusTextInput>
                      <div
                        v-if="getErrorByID(`FaturamentoItem[${index}]st`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`FaturamentoItem[${index}]st`) }}
                      </div>
                    </template>
                    <template v-else v-slot:cell-csosn="{ position: index }">
                      <FocusTextInput
                        :id="`FaturamentoItem[${index}]csosn`"
                        placeholder="CSOSN"
                        v-model="this.faturamento.FaturamentoItem[index].csosn"
                        :maxlength="4"
                        :upper="true"
                        style="text-align: center"
                        @keydown.stop.prevent.enter="
                          verificarCSOSN(
                            `FaturamentoItem[${index}]csosn`,
                            index
                          )
                        "
                        @change="
                          recalcularValores();
                          verificarCSOSN(
                            `FaturamentoItem[${index}]csosn`,
                            index
                          );
                        "
                        :hasError="
                          getErrorByID(`FaturamentoItem[${index}]csosn`)
                            ? true
                            : false
                        "
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]csosn`)
                            ? 'min-w-100px'
                            : 'min-w-60px',
                        ]"
                      ></FocusTextInput>
                      <div
                        v-if="getErrorByID(`FaturamentoItem[${index}]csosn`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`FaturamentoItem[${index}]csosn`) }}
                      </div>
                    </template>
                    <template v-slot:cell-icms="{ position: index }">
                      <FocusCurrencyInput
                        :id="`FaturamentoItem[${index}]icms`"
                        class="min-w-60px"
                        placeholder="ICMS"
                        v-model="this.faturamento.FaturamentoItem[index].icms"
                        :options="options"
                        style="text-align: right"
                        @keydown.stop.prevent.enter="
                          nextFocus(`FaturamentoItem[${index}]ipi`)
                        "
                        @change="recalcularValores()"
                        :hasError="
                          getErrorByID(`FaturamentoItem[${index}]icms`)
                            ? true
                            : false
                        "
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]icms`)
                            ? 'min-w-100px'
                            : 'min-w-60px',
                        ]"
                      ></FocusCurrencyInput>
                      <div
                        v-if="getErrorByID(`FaturamentoItem[${index}]icms`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`FaturamentoItem[${index}]icms`) }}
                      </div>
                    </template>
                    <template v-slot:cell-ipi="{ position: index }">
                      <FocusCurrencyInput
                        :id="`FaturamentoItem[${index}]ipi`"
                        class="min-w-60px"
                        placeholder="IPI"
                        v-model="this.faturamento.FaturamentoItem[index].ipi"
                        :options="options"
                        style="text-align: right"
                        @keydown.stop.prevent.enter="
                          this.camposLivres === true
                            ? nextFocus(`FaturamentoItem[${index}]base_icms`)
                            : adicionarProdutoFaturamento()
                        "
                        @change="recalcularValores()"
                        :hasError="
                          getErrorByID(`FaturamentoItem[${index}]ipi`)
                            ? true
                            : false
                        "
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]ipi`)
                            ? 'min-w-100px'
                            : 'min-w-60px',
                        ]"
                      ></FocusCurrencyInput>
                      <div
                        v-if="getErrorByID(`FaturamentoItem[${index}]ipi`)"
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`FaturamentoItem[${index}]ipi`) }}
                      </div>
                    </template>
                    <template
                      v-if="this.camposLivres === true"
                      v-slot:cell-base_icms="{ position: index }"
                    >
                      <FocusCurrencyInput
                        :id="`FaturamentoItem[${index}]base_icms`"
                        class="min-w-60px"
                        placeholder="Base ICMS"
                        v-model="
                          this.faturamento.FaturamentoItem[index].base_icms
                        "
                        :options="options"
                        style="text-align: right"
                        @keydown.stop.prevent.enter="
                          nextFocus(`FaturamentoItem[${index}]total_icms`)
                        "
                        @change="recalcularValores()"
                        :hasError="
                          getErrorByID(`FaturamentoItem[${index}]base_icms`)
                            ? true
                            : false
                        "
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]base_icms`)
                            ? 'min-w-100px'
                            : 'min-w-60px',
                        ]"
                      ></FocusCurrencyInput>
                      <div
                        v-if="
                          getErrorByID(`FaturamentoItem[${index}]base_icms`)
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`FaturamentoItem[${index}]base_icms`) }}
                      </div>
                    </template>
                    <template
                      v-if="this.camposLivres === true"
                      v-slot:cell-total_icms="{ position: index }"
                    >
                      <FocusCurrencyInput
                        :id="`FaturamentoItem[${index}]total_icms`"
                        class="min-w-60px"
                        placeholder="Total ICMS"
                        v-model="
                          this.faturamento.FaturamentoItem[index].total_icms
                        "
                        :options="options"
                        style="text-align: right"
                        @keydown.stop.prevent.enter="
                          nextFocus(`FaturamentoItem[${index}]base_icms_sub`)
                        "
                        @change="recalcularValores()"
                        :hasError="
                          getErrorByID(`FaturamentoItem[${index}]total_icms`)
                            ? true
                            : false
                        "
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]total_icms`)
                            ? 'min-w-100px'
                            : 'min-w-60px',
                        ]"
                      ></FocusCurrencyInput>
                      <div
                        v-if="
                          getErrorByID(`FaturamentoItem[${index}]total_icms`)
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          getErrorByID(`FaturamentoItem[${index}]total_icms`)
                        }}
                      </div>
                    </template>
                    <template
                      v-if="this.camposLivres === true"
                      v-slot:cell-base_icms_sub="{ position: index }"
                    >
                      <FocusCurrencyInput
                        :id="`FaturamentoItem[${index}]base_icms_sub`"
                        class="min-w-60px"
                        placeholder="Base ICMS Sub"
                        v-model="
                          this.faturamento.FaturamentoItem[index].base_icms_sub
                        "
                        :options="options"
                        style="text-align: right"
                        @keydown.stop.prevent.enter="
                          nextFocus(`FaturamentoItem[${index}]total_icms_sub`)
                        "
                        @change="recalcularValores()"
                        :hasError="
                          getErrorByID(`FaturamentoItem[${index}]base_icms_sub`)
                            ? true
                            : false
                        "
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]base_icms_sub`)
                            ? 'min-w-100px'
                            : 'min-w-60px',
                        ]"
                      ></FocusCurrencyInput>
                      <div
                        v-if="
                          getErrorByID(`FaturamentoItem[${index}]base_icms_sub`)
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          getErrorByID(`FaturamentoItem[${index}]base_icms_sub`)
                        }}
                      </div>
                    </template>
                    <template
                      v-if="this.camposLivres === true"
                      v-slot:cell-total_icms_sub="{ position: index }"
                    >
                      <FocusCurrencyInput
                        :id="`FaturamentoItem[${index}]total_icms_sub`"
                        class="min-w-60px"
                        placeholder="Total ICMS Substituição"
                        v-model="
                          this.faturamento.FaturamentoItem[index].total_icms_sub
                        "
                        :options="options"
                        style="text-align: right"
                        @keydown.stop.prevent.enter="
                          nextFocus(`FaturamentoItem[${index}]total_ipi`)
                        "
                        @change="recalcularValores()"
                        :hasError="
                          getErrorByID(
                            `FaturamentoItem[${index}]total_icms_sub`
                          )
                            ? true
                            : false
                        "
                        :class="[
                          getErrorByID(
                            `FaturamentoItem[${index}]total_icms_sub`
                          )
                            ? 'min-w-100px'
                            : 'min-w-60px',
                        ]"
                      ></FocusCurrencyInput>
                      <div
                        v-if="
                          getErrorByID(
                            `FaturamentoItem[${index}]total_icms_sub`
                          )
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          getErrorByID(
                            `FaturamentoItem[${index}]total_icms_sub`
                          )
                        }}
                      </div>
                    </template>
                    <template
                      v-if="this.camposLivres === true"
                      v-slot:cell-total_ipi="{ position: index }"
                    >
                      <FocusCurrencyInput
                        :id="`FaturamentoItem[${index}]total_ipi`"
                        class="min-w-60px"
                        placeholder="Total IPI"
                        v-model="
                          this.faturamento.FaturamentoItem[index].total_ipi
                        "
                        :options="options"
                        style="text-align: right"
                        @change="recalcularValores()"
                        :hasError="
                          getErrorByID(`FaturamentoItem[${index}]total_ipi`)
                            ? true
                            : false
                        "
                        :class="[
                          getErrorByID(`FaturamentoItem[${index}]total_ipi`)
                            ? 'min-w-100px'
                            : 'min-w-60px',
                        ]"
                      ></FocusCurrencyInput>
                      <div
                        v-if="
                          getErrorByID(`FaturamentoItem[${index}]total_ipi`)
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(`FaturamentoItem[${index}]total_ipi`) }}
                      </div>
                    </template>
                    <template
                      v-slot:cell-acoes="{
                        row: faturamentoItem,
                        position: index,
                      }"
                    >
                      <div class="d-flex justify-content-end flex-shrink-0">
                        <button
                          class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                          @click="removerProduto(index)"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Remover"
                        >
                          <span class="svg-icon svg-icon-5 m-0">
                            <inline-svg
                              src="media/icons/duotune/general/gen027.svg"
                            />
                          </span>
                        </button>
                        <button
                          class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                          @click="editarObservacoesProduto(index)"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Observações"
                        >
                          <span class="svg-icon svg-icon-5 m-0">
                            <inline-svg
                              src="media/icons/duotune/communication/com012.svg"
                            />
                          </span>
                        </button>
                        <button
                          class="btn btn-sm btn-light btn-active-light-primary d-flex align-items-center"
                          data-kt-menu-trigger="click"
                          data-kt-menu-placement="bottom-end"
                          data-kt-menu-flip="top-end"
                          tabindex="-1"
                        >
                          Ações
                          <span class="svg-icon svg-icon-5 m-0">
                            <inline-svg
                              src="media/icons/duotune/arrows/arr072.svg"
                            />
                          </span>
                        </button>
                        <div
                          class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
                          data-kt-menu="true"
                        >
                          <div class="menu-item px-3">
                            <a
                              @click="editarEstoque(index)"
                              class="menu-link px-3"
                              >Estoque</a
                            >
                          </div>
                          <div class="menu-item px-3">
                            <a
                              v-if="faturamentoItem.Produto.Adicional"
                              @click="editarAdicional(index)"
                              class="menu-link px-3"
                              >Adicionais</a
                            >
                            <a
                              v-else
                              @click="editarObservacoesProduto(index)"
                              class="menu-link px-3"
                              >Observações</a
                            >
                          </div>
                          <div class="menu-item px-3">
                            <a
                              @click="editarPesoProduto(index)"
                              class="menu-link px-3"
                              >Peso</a
                            >
                          </div>
                          <div class="menu-item px-3">
                            <a
                              @click="editarFaturamentoNFeProduto(index)"
                              class="menu-link px-3"
                              >NF-e</a
                            >
                          </div>
                          <div class="menu-item px-3">
                            <a
                              @click="editarTotalProduto(index)"
                              class="menu-link px-3"
                              >Desconto</a
                            >
                          </div>
                          <div class="menu-item px-3">
                            <a
                              @click="editarDetalhesProduto(index)"
                              class="menu-link px-3"
                              >Detalhes</a
                            >
                          </div>
                          <div class="menu-item px-3">
                            <a
                              @click="editarVendedorItem(index)"
                              class="menu-link px-3"
                              >Vendedor</a
                            >
                          </div>
                          <div class="menu-item px-3">
                            <a
                              @click="removerProduto(index)"
                              class="menu-link px-3"
                              >Excluir</a
                            >
                          </div>
                        </div>
                      </div>
                    </template>
                  </Datatable>
                  <div class="fs-6 mt-4">
                    <b class="">{{ "Qtd Itens: " }}</b>
                    <b class="text-primary">{{
                      this.faturamento.FaturamentoItem.length
                    }}</b>
                    <b class="ms-4">{{ "Qtd Produtos: " }}</b>
                    <b class="text-primary">{{ this.somaQtdProdutos() }}</b>
                  </div>
                </div>
                <div class="card-footer d-flex justify-content-end">
                  <div class="row">
                    <div class="col-auto">
                      <button
                        @click="this.ativarCamposLivres()"
                        type="button"
                        class="btn svg-icon-white mb-2 min-w-150px"
                        :class="[
                          this.camposLivres === true
                            ? 'btn-danger'
                            : 'btn-light',
                        ]"
                      >
                        <span
                          class="svg-icon svg-icon-1"
                          v-if="!this.camposLivres"
                        >
                          <inline-svg
                            src="media/icons/duotune/art/art005.svg"
                          />
                          Edição livre
                        </span>
                        <span class="svg-icon svg-icon-1" v-else>
                          <inline-svg
                            src="media/icons/duotune/arrows/arr015.svg"
                          />
                          Cancelar edição livre
                        </span>
                      </button>
                    </div>
                    <div class="col-auto">
                      <button
                        @click="recalcularItensFaturamento()"
                        type="button"
                        class="btn btn-light svg-icon-white mb-2 min-w-150px"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/finance/fin007.svg"
                          />
                          Recalcular
                        </span>
                      </button>
                    </div>
                    <div class="col-auto">
                      <button
                        @click="adicionarProdutoFaturamento()"
                        type="button"
                        class="btn btn-primary svg-icon-white mb-2"
                        data-bs-toggle="tooltip"
                        data-bs-dismiss="click"
                        title="(CTRL + A) (CMD + A) (F5) Adicionar produto"
                        tooltip="(CTRL + A) (CMD + A) (F5) Adicionar produto"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/general/gen041.svg"
                          />
                          Adicionar
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade tab-pane-faturamento"
            id="kt_faturamento_pagamento"
            role="tab-panel"
          >
            <div class="d-flex flex-column gap-7 gap-lg-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <div class="card-title">
                    <h2>Pagamento</h2>
                  </div>
                  <div class="card-toolbar">
                    <div
                      class="d-flex justify-content-end"
                      data-kt-customer-table-toolbar="base"
                    >
                      <button
                        v-if="exibirPagamento"
                        @click="adicionarFaturamentoPagamento()"
                        type="button"
                        class="btn btn-sm btn-primary"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/finance/fin008.svg" /></span
                        >Adicionar Pagamento
                      </button>
                      <button
                        v-if="exibirFaturamentoReceberModal"
                        @click="adicionarFaturamentoReceber()"
                        type="button"
                        class="btn btn-sm btn-light-info ms-2"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/finance/fin005.svg" /></span
                        >Parcelamento
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-4 pb-6">
                  <div v-if="exibirPagamento" class="table-responsive">
                    <table
                      :class="[loadingPagamento && 'overlay overlay-block']"
                      class="table align-middle table-row-dashed fs-6 gy-5 gs-7 text-gray-600 fw-bold dataTable no-footer table-hover"
                      id="kt_table_pagamentos"
                    >
                      <tbody>
                        <template
                          v-if="
                            this.faturamento.FaturamentoPagamento.length > 0
                          "
                        >
                          <template
                            v-for="(pagamento, i) in this.faturamento
                              .FaturamentoPagamento"
                            :key="i"
                          >
                            <tr>
                              <td class="align-middle">
                                <div>
                                  <span class="svg-icon svg-icon-2qx"
                                    ><inline-svg
                                      :src="
                                        getEspeciePagamento(
                                          pagamento.cod_especie
                                        )
                                      "
                                  /></span>
                                </div>
                              </td>
                              <td class="ps-0">
                                <div class="min-w-150px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ pagamento.descricao }}
                                    </span>
                                    <span class="text-muted fw-bold d-block">
                                      {{ pagamento.emissor }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td class="min-w-125px text-success">
                                R$
                                {{
                                  this.$utils.formatarNumero(
                                    pagamento.valor_recebido
                                  )
                                }}
                              </td>
                              <td>
                                <div>
                                  <div>
                                    <span
                                      v-if="pagamento.tipo"
                                      class="badge badge-light-dark d-block mb-2"
                                      >{{ pagamento.tipo }}</span
                                    >
                                    <span
                                      v-if="pagamento.pendente === '0'"
                                      class="badge badge-light-success d-block"
                                      >Aprovado</span
                                    >
                                    <span
                                      v-else
                                      class="badge badge-light-danger d-block"
                                      >Pendente</span
                                    >
                                  </div>
                                </div>
                              </td>
                              <td>
                                {{
                                  this.$utils.formatarDataHora(
                                    pagamento.createdAt
                                  )
                                }}
                              </td>
                              <td>
                                <div class="min-w-85px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      Troco para
                                    </span>
                                    <span class="text-primary fw-bold d-block">
                                      R$
                                      {{
                                        this.$utils.formatarNumero(
                                          pagamento.troco_entrega
                                        )
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td class="min-w-125px pe-5 text-end">
                                <button
                                  class="btn btn-sm btn-light btn-active-light-primary"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                  data-kt-menu-flip="top-end"
                                >
                                  Ações
                                  <span class="svg-icon svg-icon-5 m-0">
                                    <inline-svg
                                      src="media/icons/duotune/arrows/arr072.svg"
                                    />
                                  </span>
                                </button>
                                <div
                                  class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
                                  data-kt-menu="true"
                                >
                                  <div class="menu-item px-3">
                                    <a
                                      @click="editarFaturamentoPagamento(i)"
                                      class="menu-link px-3"
                                      >Editar</a
                                    >
                                  </div>
                                  <div class="menu-item px-3">
                                    <a
                                      @click="removerPagamento(pagamento.id, i)"
                                      class="menu-link px-3"
                                      >Excluír</a
                                    >
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </template>
                        <template v-else>
                          <tr class="odd">
                            <td :colSpan="12" class="dataTables_empty">
                              {{ "Nenhuma forma de pagamento foi adicionada" }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                      <div
                        v-if="loadingPagamento"
                        class="overlay-layer card-rounded bg-dark bg-opacity-5"
                      >
                        <div
                          class="spinner-border text-primary"
                          role="status"
                        ></div>
                        <span class="ms-2">Aguarde, carregando...</span>
                      </div>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade tab-pane-faturamento"
            id="kt_faturamento_duplicatas"
            role="tab-panel"
          >
            <div class="d-flex flex-column gap-7 gap-lg-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <div class="card-title">
                    <h2>Duplicatas</h2>
                  </div>
                </div>
                <div class="card-body pt-4 pb-6">
                  <FaturamentoReceberModal
                    v-if="
                      exibirFaturamentoReceberModal === false
                        ? true
                        : exibirFaturamentoReceber
                    "
                    :faturamento="this.faturamento"
                    :modal="exibirFaturamentoReceberModal"
                    @exibirModalFaturamentoReceber="modalFaturamentoReceber"
                    @confirmarParcelamento="confirmarParcelamento"
                  ></FaturamentoReceberModal>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade tab-pane-faturamento"
            id="kt_faturamento_nfe"
            role="tab-panel"
          >
            <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <h3 class="card-title align-items-start flex-column">
                    <span class="card-label fw-bolder fs-3 mb-1"
                      >Identificação da NF-e</span
                    >
                  </h3>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 fv-row mb-6"
                    >
                      <label class="form-label"
                        >Finalidade de emissão da NF-e</label
                      >
                      <select
                        class="form-select mb-2"
                        data-placeholder="Selecione uma opção"
                        v-model="faturamento.fin_nfe"
                      >
                        <option value="1">1 - NF-e normal</option>
                        <option value="2">2 - NF-e complementar</option>
                        <option value="3">3 - NF-e de ajuste</option>
                        <option value="4">4 - Devolução de mercadoria</option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["fin_nfe"] }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 fv-row mb-6"
                    >
                      <label class="form-label">Local destino operação</label>
                      <select
                        class="form-select mb-2"
                        data-placeholder="Selecione uma opção"
                        v-model="faturamento.id_dest"
                      >
                        <option value="1">1 - Operação interna</option>
                        <option value="2">2 - Operação interestadual</option>
                        <option value="3">3 - Operação com exterior</option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["id_dest"] }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 fv-row mb-6"
                    >
                      <label class="form-label">Tipo de Emissão</label>
                      <select
                        class="form-select mb-2"
                        data-placeholder="Selecione uma opção"
                        v-model="faturamento.tp_emis"
                      >
                        <option value="1">1 - Emissão normal</option>
                        <option value="2">
                          2 - Contingência FS-IA, com impressão do DANFE em
                          formulário de segurança
                        </option>
                        <option value="3">
                          3 - Contingência SCAN (Sistema de Contingência do
                          Ambiente Nacional)
                        </option>
                        <option value="4">
                          4 - Contingência DPEC (Declaração Prévia da Emissão em
                          Contingência)
                        </option>
                        <option value="5">
                          5 - Contingência FS-DA, com impressão do DANFE em
                          formulário de segurança
                        </option>
                        <option value="6">
                          6 - Contingência SVC-AN (SEFAZ Virtual de Contingência
                          do AN)
                        </option>
                        <option value="7">
                          7 - Contingência SVC-RS (SEFAZ Virtual de Contingência
                          do RS)
                        </option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["tp_emis"] }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 fv-row mb-6"
                    >
                      <label class="form-label"
                        >Operação com consumidor final</label
                      >
                      <select
                        class="form-select mb-2"
                        data-placeholder="Selecione uma opção"
                        v-model="faturamento.id_final"
                      >
                        <option value="0">0 - Normal</option>
                        <option value="1">1 - Consumidor final</option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["id_final"] }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 fv-row mb-6"
                    >
                      <label class="form-label">Indicador de presença</label>
                      <select
                        class="form-select mb-2"
                        data-placeholder="Selecione uma opção"
                        v-model="faturamento.ind_pres"
                      >
                        <option value="0">
                          0 - Não se aplica (por exemplo, Nota Fiscal
                          complementar ou de ajuste)
                        </option>
                        <option value="1">1 - Operação presencial</option>
                        <option value="2">
                          2 - Operação não presencial, pela Internet
                        </option>
                        <option value="3">
                          3 - Operação não presencial, Teleatendimento
                        </option>
                        <option value="5">
                          5 - Operação presencial, fora do estabelecimento
                        </option>
                        <option value="9">
                          9 - Operação não presencial, outros
                        </option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ind_pres"] }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 fv-row mb-6"
                    >
                      <label class="form-label"
                        >Indicador de intermediador</label
                      >
                      <select
                        class="form-select mb-2"
                        data-placeholder="Selecione uma opção"
                        v-model="faturamento.ind_intermed"
                      >
                        <option value="0">
                          0 - Operação sem intermediador (em site ou plataforma
                          própria)
                        </option>
                        <option value="1">
                          1 - Operação em site ou plataforma de terceiros
                          (intermediadores/marketplace)
                        </option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ind_intermed"] }}
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="this.verificarIndicadorPresenca()">
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 fv-row mb-6"
                    >
                      <label class="form-label">CNPJ Intermediador</label>
                      <input
                        type="text"
                        id="txtCNPJIntermediador"
                        :class="['form-control mb-2']"
                        v-model="this.faturamento.cnpj_intermediador"
                        v-mask="['##.###.###/####-##']"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["cnpj_intermediador"] }}
                      </div>
                    </div>
                    <div
                      class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-8 fv-row mb-6"
                    >
                      <label class="form-label"
                        >Identificação do intermediador</label
                      >
                      <input
                        type="text"
                        id="txtItentificacaoIntermediador"
                        :class="['form-control mb-2']"
                        v-model="this.faturamento.id_cad_int_tran"
                        maxlength="60"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["id_cad_int_tran"] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <h3 class="card-title align-items-start flex-column">
                    <span class="card-label fw-bolder fs-3 mb-1"
                      >Referenciar notas</span
                    >
                    <span class="text-muted mt-1 fw-bold fs-7"
                      >Máximo 500 notas</span
                    >
                  </h3>
                  <div class="card-toolbar">
                    <div
                      class="d-flex justify-content-end"
                      data-kt-customer-table-toolbar="base"
                    >
                      <button
                        @click="adicionarFaturamentoChave()"
                        type="button"
                        class="btn btn-sm btn-light btn-active-primary"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/arrows/arr075.svg" /></span
                        >Adicionar chave
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="table-responsive">
                    <table
                      :class="[
                        loadingNFeReferenciada && 'overlay overlay-block',
                      ]"
                      class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                      id="kt_table_nfe_referenciada"
                    >
                      <thead>
                        <tr class="fw-bolder text-muted">
                          <th>Item</th>
                          <th class="min-w-200px">Chave de acesso</th>
                          <th class="min-w-100px text-end">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-if="
                            this.faturamento.FaturamentoChaveReferenciada
                              .length > 0
                          "
                        >
                          <template
                            v-for="(chave, i) in this.faturamento
                              .FaturamentoChaveReferenciada"
                            :key="i"
                          >
                            <tr>
                              <td>
                                <div class="align-middle">
                                  <div>
                                    <span
                                      class="badge badge-light badge-square badge-sm mb-1"
                                    >
                                      {{ i + 1 }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-150px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ chave.chave }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td
                                class="d-flex justify-content-end flex-shrink-0"
                              >
                                <button
                                  class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                  @click="editarFaturamentoChave(i)"
                                >
                                  <span class="svg-icon svg-icon-5 m-0">
                                    <inline-svg
                                      src="media/icons/duotune/art/art005.svg"
                                    />
                                  </span>
                                </button>
                                <button
                                  class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                  @click="removerFaturamentoChave(i)"
                                >
                                  <span class="svg-icon svg-icon-5 m-0">
                                    <inline-svg
                                      src="media/icons/duotune/general/gen027.svg"
                                    />
                                  </span>
                                </button>
                              </td>
                            </tr>
                          </template>
                        </template>
                        <template v-else>
                          <tr class="odd">
                            <td :colSpan="12" class="dataTables_empty">
                              {{ "Nenhuma chave de acesso foi adicionada" }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                      <div
                        v-if="loadingNFeReferenciada"
                        class="overlay-layer card-rounded bg-dark bg-opacity-5"
                      >
                        <div
                          class="spinner-border text-primary"
                          role="status"
                        ></div>
                        <span class="ms-2">Aguarde, carregando...</span>
                      </div>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <h3 class="card-title align-items-start flex-column">
                    <span class="card-label fw-bolder fs-3 mb-1"
                      >Autorizados</span
                    >
                    <span class="text-muted mt-1 fw-bold fs-7"
                      >Máximo 10 autorizados</span
                    >
                  </h3>
                  <div class="card-toolbar">
                    <div
                      class="d-flex justify-content-end"
                      data-kt-customer-table-toolbar="base"
                    >
                      <button
                        @click="adicionarFaturamentoAutorizados()"
                        type="button"
                        class="btn btn-sm btn-light btn-active-primary"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/arrows/arr075.svg" /></span
                        >Adicionar autorizado
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="table-responsive">
                    <table
                      :class="[
                        loadingNFeAutorizados && 'overlay overlay-block',
                      ]"
                      class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                      id="kt_table_nfe_referenciada"
                    >
                      <thead>
                        <tr class="fw-bolder text-muted">
                          <th>Item</th>
                          <th class="min-w-200px">CPF/CNPJ</th>
                          <th class="min-w-100px text-end">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-if="
                            this.faturamento.FaturamentoAutorizados.length > 0
                          "
                        >
                          <template
                            v-for="(autorizado, i) in this.faturamento
                              .FaturamentoAutorizados"
                            :key="i"
                          >
                            <tr>
                              <td>
                                <div class="align-middle">
                                  <div>
                                    <span
                                      class="badge badge-light badge-square badge-sm mb-1"
                                    >
                                      {{ i + 1 }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-150px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ autorizado.documento }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td
                                class="d-flex justify-content-end flex-shrink-0"
                              >
                                <button
                                  class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                  @click="editarFaturamentoAutorizado(i)"
                                >
                                  <span class="svg-icon svg-icon-5 m-0">
                                    <inline-svg
                                      src="media/icons/duotune/art/art005.svg"
                                    />
                                  </span>
                                </button>
                                <button
                                  class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                  @click="removerFaturamentoAutorizado(i)"
                                >
                                  <span class="svg-icon svg-icon-5 m-0">
                                    <inline-svg
                                      src="media/icons/duotune/general/gen027.svg"
                                    />
                                  </span>
                                </button>
                              </td>
                            </tr>
                          </template>
                        </template>
                        <template v-else>
                          <tr class="odd">
                            <td :colSpan="12" class="dataTables_empty">
                              {{ "Sem registros" }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                      <div
                        v-if="loadingNFeAutorizados"
                        class="overlay-layer card-rounded bg-dark bg-opacity-5"
                      >
                        <div
                          class="spinner-border text-primary"
                          role="status"
                        ></div>
                        <span class="ms-2">Aguarde, carregando...</span>
                      </div>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <h3 class="card-title align-items-start flex-column">
                    <span class="card-label fw-bolder fs-3 mb-1"
                      >NF Produtor rural</span
                    >
                    <span class="text-muted mt-1 fw-bold fs-7"
                      >Informações da NF de produtor rural referenciada</span
                    >
                  </h3>
                  <div class="card-toolbar">
                    <div
                      class="d-flex justify-content-end"
                      data-kt-customer-table-toolbar="base"
                    >
                      <button
                        @click="adicionarFaturamentoNFProdutor()"
                        type="button"
                        class="btn btn-sm btn-light btn-active-primary"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/arrows/arr075.svg" /></span
                        >Adicionar produtor
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="table-responsive">
                    <table
                      :class="[loadingNFProdutor && 'overlay overlay-block']"
                      class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                      id="kt_table_nfe_produtor"
                    >
                      <thead>
                        <tr class="fw-bolder text-muted">
                          <th>Item</th>
                          <th class="min-w-150px">Documento</th>
                          <th class="min-w-100px">Modelo</th>
                          <th class="min-w-60px">Série</th>
                          <th class="min-w-100px">Emissão</th>
                          <th class="min-w-50px">UF</th>
                          <th class="min-w-100px">CNPJ</th>
                          <th class="min-w-100px">CPF</th>
                          <th class="min-w-100px">IE</th>
                          <th class="min-w-100px text-end">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-if="this.faturamento.FaturamentoRefNFP.length > 0"
                        >
                          <template
                            v-for="(nfp, i) in this.faturamento
                              .FaturamentoRefNFP"
                            :key="i"
                          >
                            <tr>
                              <td>
                                <div class="align-middle">
                                  <div>
                                    <span
                                      class="badge badge-light badge-square badge-sm mb-1"
                                    >
                                      {{ i + 1 }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-150px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nfp.nNF }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-100px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nfp.mod }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-60px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nfp.serie }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-100px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ this.$utils.formatarData(nfp.AAMM) }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-50px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nfp.cUF }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-100px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nfp.CNPJ }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-100px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nfp.CPF }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-100px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nfp.IE }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td
                                class="d-flex justify-content-end flex-shrink-0"
                              >
                                <button
                                  class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                  @click="editarFaturamentoNFProdutor(i)"
                                >
                                  <span class="svg-icon svg-icon-5 m-0">
                                    <inline-svg
                                      src="media/icons/duotune/art/art005.svg"
                                    />
                                  </span>
                                </button>
                                <button
                                  class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                  @click="removerFaturamentoNFProdutor(i)"
                                >
                                  <span class="svg-icon svg-icon-5 m-0">
                                    <inline-svg
                                      src="media/icons/duotune/general/gen027.svg"
                                    />
                                  </span>
                                </button>
                              </td>
                            </tr>
                          </template>
                        </template>
                        <template v-else>
                          <tr class="odd">
                            <td :colSpan="12" class="dataTables_empty">
                              {{ "Sem registros" }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                      <div
                        v-if="loadingNFProdutor"
                        class="overlay-layer card-rounded bg-dark bg-opacity-5"
                      >
                        <div
                          class="spinner-border text-primary"
                          role="status"
                        ></div>
                        <span class="ms-2">Aguarde, carregando...</span>
                      </div>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <h3 class="card-title align-items-start flex-column">
                    <span class="card-label fw-bolder fs-3 mb-1"
                      >NF modelo 1/1A</span
                    >
                    <span class="text-muted mt-1 fw-bold fs-7"
                      >Informações da NF modelo 1/1A referenciada</span
                    >
                  </h3>
                  <div class="card-toolbar">
                    <div
                      class="d-flex justify-content-end"
                      data-kt-customer-table-toolbar="base"
                    >
                      <button
                        @click="adicionarFaturamentoNFA()"
                        type="button"
                        class="btn btn-sm btn-light btn-active-primary"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/arrows/arr075.svg" /></span
                        >Adicionar
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="table-responsive">
                    <table
                      :class="[loadingNFA && 'overlay overlay-block']"
                      class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                      id="kt_table_nfe_nfa"
                    >
                      <thead>
                        <tr class="fw-bolder text-muted">
                          <th>Item</th>
                          <th class="min-w-150px">Documento</th>
                          <th class="min-w-100px">Modelo</th>
                          <th class="min-w-60px">Série</th>
                          <th class="min-w-100px">Emissão</th>
                          <th class="min-w-50px">UF</th>
                          <th class="min-w-100px">CNPJ</th>
                          <th class="min-w-100px text-end">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-if="this.faturamento.FaturamentoRefNFA.length > 0"
                        >
                          <template
                            v-for="(nf, i) in this.faturamento
                              .FaturamentoRefNFA"
                            :key="i"
                          >
                            <tr>
                              <td>
                                <div class="align-middle">
                                  <div>
                                    <span
                                      class="badge badge-light badge-square badge-sm mb-1"
                                    >
                                      {{ i + 1 }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-150px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nf.nNF }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-100px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nf.mod }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-60px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nf.serie }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-100px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ this.$utils.formatarData(nf.AAMM) }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-50px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nf.cUF }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-100px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nf.CNPJ }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td
                                class="d-flex justify-content-end flex-shrink-0"
                              >
                                <button
                                  class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                  @click="editarFaturamentoNFA(i)"
                                >
                                  <span class="svg-icon svg-icon-5 m-0">
                                    <inline-svg
                                      src="media/icons/duotune/art/art005.svg"
                                    />
                                  </span>
                                </button>
                                <button
                                  class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                  @click="removerFaturamentoNFA(i)"
                                >
                                  <span class="svg-icon svg-icon-5 m-0">
                                    <inline-svg
                                      src="media/icons/duotune/general/gen027.svg"
                                    />
                                  </span>
                                </button>
                              </td>
                            </tr>
                          </template>
                        </template>
                        <template v-else>
                          <tr class="odd">
                            <td :colSpan="12" class="dataTables_empty">
                              {{ "Sem registros" }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                      <div
                        v-if="loadingNFA"
                        class="overlay-layer card-rounded bg-dark bg-opacity-5"
                      >
                        <div
                          class="spinner-border text-primary"
                          role="status"
                        ></div>
                        <span class="ms-2">Aguarde, carregando...</span>
                      </div>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <h3 class="card-title align-items-start flex-column">
                    <span class="card-label fw-bolder fs-3 mb-1"
                      >Exportação</span
                    >
                  </h3>
                  <div class="card-toolbar">
                    <div
                      class="d-flex justify-content-end"
                      data-kt-customer-table-toolbar="base"
                    >
                      <button
                        @click="adicionarFaturamentoExporta()"
                        type="button"
                        class="btn btn-sm btn-light btn-active-primary"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/arrows/arr075.svg" /></span
                        >Adicionar
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="table-responsive">
                    <table
                      :class="[loadingExporta && 'overlay overlay-block']"
                      class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                      id="kt_table_nfe_exporta"
                    >
                      <thead>
                        <tr class="fw-bolder text-muted">
                          <th class="min-w-60px">UF Saída</th>
                          <th class="min-w-100px">Local Embarque</th>
                          <th class="min-w-100px">Local Despacho</th>
                          <th class="min-w-100px text-end">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-if="this.faturamento.FaturamentoExporta.length > 0"
                        >
                          <template
                            v-for="(nf, i) in this.faturamento
                              .FaturamentoExporta"
                            :key="i"
                          >
                            <tr>
                              <td>
                                <div class="min-w-60px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nf.UFSaidaPais }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-100px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nf.xLocExporta }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-100px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nf.xLocDespacho }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td
                                class="d-flex justify-content-end flex-shrink-0"
                              >
                                <button
                                  class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                  @click="editarFaturamentoExporta(i)"
                                >
                                  <span class="svg-icon svg-icon-5 m-0">
                                    <inline-svg
                                      src="media/icons/duotune/art/art005.svg"
                                    />
                                  </span>
                                </button>
                                <button
                                  class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                  @click="removerFaturamentoExporta(i)"
                                >
                                  <span class="svg-icon svg-icon-5 m-0">
                                    <inline-svg
                                      src="media/icons/duotune/general/gen027.svg"
                                    />
                                  </span>
                                </button>
                              </td>
                            </tr>
                          </template>
                        </template>
                        <template v-else>
                          <tr class="odd">
                            <td :colSpan="12" class="dataTables_empty">
                              {{ "Sem registros" }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                      <div
                        v-if="loadingExporta"
                        class="overlay-layer card-rounded bg-dark bg-opacity-5"
                      >
                        <div
                          class="spinner-border text-primary"
                          role="status"
                        ></div>
                        <span class="ms-2">Aguarde, carregando...</span>
                      </div>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="d-flex flex-column gap-7 gap-lg-10 mb-10"
              v-if="exibirGrupoCompra"
            >
              <div class="card card-flush py-4">
                <div class="card-header">
                  <h3 class="card-title align-items-start flex-column">
                    <span class="card-label fw-bolder fs-3 mb-1">Compra</span>
                  </h3>
                  <div class="card-toolbar">
                    <div
                      class="d-flex justify-content-end"
                      data-kt-customer-table-toolbar="base"
                    >
                      <button
                        @click="adicionarFaturamentoCompra()"
                        type="button"
                        class="btn btn-sm btn-light btn-active-primary"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/arrows/arr075.svg" /></span
                        >Adicionar
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="table-responsive">
                    <table
                      :class="[loadingCompra && 'overlay overlay-block']"
                      class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                      id="kt_table_nfe_compra"
                    >
                      <thead>
                        <tr class="fw-bolder text-muted">
                          <th class="min-w-100px">Nota de Empenho</th>
                          <th class="min-w-100px">Pedido</th>
                          <th class="min-w-100px">Contrato</th>
                          <th class="min-w-100px text-end">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-if="this.faturamento.FaturamentoCompra.length > 0"
                        >
                          <template
                            v-for="(nf, i) in this.faturamento
                              .FaturamentoCompra"
                            :key="i"
                          >
                            <tr>
                              <td>
                                <div class="min-w-100px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nf.xNEmp }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-100px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nf.xPed }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="min-w-100px align-middle">
                                  <div>
                                    <span
                                      class="text-dark text-hover-primary mb-1"
                                    >
                                      {{ nf.xCont }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td
                                class="d-flex justify-content-end flex-shrink-0"
                              >
                                <button
                                  class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                  @click="editarFaturamentoCompra(i)"
                                >
                                  <span class="svg-icon svg-icon-5 m-0">
                                    <inline-svg
                                      src="media/icons/duotune/art/art005.svg"
                                    />
                                  </span>
                                </button>
                                <button
                                  class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                  @click="removerFaturamentoCompra(i)"
                                >
                                  <span class="svg-icon svg-icon-5 m-0">
                                    <inline-svg
                                      src="media/icons/duotune/general/gen027.svg"
                                    />
                                  </span>
                                </button>
                              </td>
                            </tr>
                          </template>
                        </template>
                        <template v-else>
                          <tr class="odd">
                            <td :colSpan="12" class="dataTables_empty">
                              {{ "Sem registros" }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                      <div
                        v-if="loadingCompra"
                        class="overlay-layer card-rounded bg-dark bg-opacity-5"
                      >
                        <div
                          class="spinner-border text-primary"
                          role="status"
                        ></div>
                        <span class="ms-2">Aguarde, carregando...</span>
                      </div>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
              <div class="card card-flush py-4">
                <div class="card-header">
                  <h3 class="card-title align-items-start flex-column">
                    <span class="card-label fw-bolder fs-3 mb-1"
                      >Informações Adicionais de Interesse do Fisco</span
                    >
                  </h3>
                </div>
                <div class="card-body pt-0 pb-0">
                  <div class="mb-6 fv-row">
                    <label class="form-label">Informações</label>
                    <textarea
                      id="txtInfAdFisco"
                      class="form-control mb-2"
                      maxlength="2000"
                      style="height: 200px"
                      v-model="faturamento.inf_ad_fisco"
                    />
                    <div class="row">
                      <div class="col-6 pe-0">
                        <div
                          class="fv-plugins-message-container invalid-feedback m-0"
                        >
                          {{ errosValidacao["inf_ad_fisco"] }}
                        </div>
                      </div>
                      <div class="col-6 ps-2">
                        <div class="text-end text-muted fs-7">
                          {{
                            faturamento.inf_ad_fisco
                              ? faturamento.inf_ad_fisco.length
                              : "0"
                          }}/2000 caracteres
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-column flex-lg-row-auto w-100 w-xl-350px ms-xl-10">
        <div class="card card-flush py-4 mb-10">
          <div class="card-header">
            <div class="card-title">
              <h2>Totalizadores</h2>
            </div>
          </div>
          <div class="card-body pt-0">
            <label class="form-label">Total da Nota</label>
            <div class="input-group mb-2">
              <button
                type="button"
                class="btn btn-warning py-0 ps-4 pe-2"
                @click="editarTotal()"
              >
                <span class="svg-icon svg-icon-1">
                  <inline-svg src="media/icons/duotune/finance/fin010.svg" />
                </span>
              </button>
              <CurrencyInput
                class="form-control text-danger"
                :class="[
                  this.camposLivres === true ? '' : 'form-control-solid',
                ]"
                placeholder="Total da nota"
                style="text-align: right"
                v-model="this.faturamento.total"
                :options="options"
                :readonly="this.camposLivres === false"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["total"] }}
              </div>
            </div>
            <label class="form-label">Total dos produtos</label>
            <CurrencyInput
              class="form-control mb-2"
              :class="[this.camposLivres === true ? '' : 'form-control-solid']"
              placeholder="Total dos produtos"
              style="text-align: right"
              v-model="this.faturamento.total_produtos"
              :options="options"
              :readonly="this.camposLivres === false"
            ></CurrencyInput>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["total_produtos"] }}
            </div>
            <label class="form-label">Descontos</label>
            <CurrencyInput
              class="form-control form-control-solid mb-2 text-primary"
              placeholder="Descontos"
              style="text-align: right"
              v-model="this.faturamento.total_descontos"
              :options="options"
              readonly
            >
            </CurrencyInput>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["total_descontos"] }}
            </div>
            <label class="form-label">Acréscimos</label>
            <CurrencyInput
              class="form-control form-control-solid mb-2"
              placeholder="Acréscimos"
              style="text-align: right"
              v-model="this.faturamento.total_acrescimo"
              :options="options"
              readonly
            ></CurrencyInput>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["total_acrescimo"] }}
            </div>
            <label class="form-label">Valor do Frete</label>
            <CurrencyInput
              class="form-control mb-2"
              placeholder="Valor do Frete"
              style="text-align: right"
              v-model="this.faturamento.total_frete"
              :options="options"
              @change="recalcularValores()"
            ></CurrencyInput>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["total_frete"] }}
            </div>
            <label class="form-label">Valor do Seguro</label>
            <CurrencyInput
              class="form-control mb-2"
              placeholder="Valor do Seguro"
              style="text-align: right"
              v-model="this.faturamento.total_seguro"
              :options="options"
              @change="recalcularValores()"
            ></CurrencyInput>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["total_seguro"] }}
            </div>
            <label class="form-label">Outras Despesas</label>
            <CurrencyInput
              class="form-control mb-2"
              placeholder="Outras Despesas"
              style="text-align: right"
              v-model="this.faturamento.total_outras"
              :options="options"
              @change="recalcularValores()"
            ></CurrencyInput>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["total_outras"] }}
            </div>
            <label class="form-label">Base ICMS</label>
            <CurrencyInput
              class="form-control mb-2"
              :class="[this.camposLivres === true ? '' : 'form-control-solid']"
              placeholder="Base Icms"
              style="text-align: right"
              v-model="this.faturamento.base_icms"
              :options="options"
              :readonly="this.camposLivres === false"
            ></CurrencyInput>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["base_icms"] }}
            </div>
            <label class="form-label">Valor ICMS</label>
            <CurrencyInput
              class="form-control mb-2"
              :class="[this.camposLivres === true ? '' : 'form-control-solid']"
              placeholder="Valor Icms"
              style="text-align: right"
              v-model="this.faturamento.total_icms"
              :options="options"
              :readonly="this.camposLivres === false"
            ></CurrencyInput>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["total_icms"] }}
            </div>
            <label class="form-label">Base ICMS Substituição</label>
            <CurrencyInput
              class="form-control mb-2"
              :class="[this.camposLivres === true ? '' : 'form-control-solid']"
              placeholder="BC Icms Sub"
              style="text-align: right"
              v-model="this.faturamento.base_icms_sub"
              :options="options"
              :readonly="this.camposLivres === false"
            ></CurrencyInput>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["base_icms_sub"] }}
            </div>
            <div class="fv-row">
              <div class="d-flex justify-content-between">
                <label class="form-label me-4">Valor ICMS Substituição</label>
                <div class="card-toolbar">
                  <div class="form-check form-check-custom form-check-sm">
                    <input
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Somar Valor do Icms Substituição ao Total da Nota"
                      class="form-check-input"
                      type="checkbox"
                      v-model="this.faturamento.utiliza_icms_sub"
                      id="ckUtilizaIcmsSub"
                      tabindex="-1"
                      @change="this.recalcularValores()"
                    />
                  </div>
                </div>
              </div>
              <CurrencyInput
                class="form-control mb-2"
                :class="[
                  this.camposLivres === true ? '' : 'form-control-solid',
                ]"
                placeholder="Valor ICMS Subs"
                style="text-align: right"
                v-model="this.faturamento.total_icms_sub"
                :options="options"
                :readonly="this.camposLivres === false"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["total_icms_sub"] }}
              </div>
            </div>
            <label class="form-label">Total do IPI</label>
            <CurrencyInput
              class="form-control mb-2"
              :class="[this.camposLivres === true ? '' : 'form-control-solid']"
              placeholder="Total do IPI"
              style="text-align: right"
              v-model="this.faturamento.total_ipi"
              :options="options"
              :readonly="this.camposLivres === false"
            ></CurrencyInput>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["total_ipi"] }}
            </div>
            <label class="form-label">Total FCP ST</label>
            <CurrencyInput
              class="form-control mb-2"
              :class="[this.camposLivres === true ? '' : 'form-control-solid']"
              placeholder="Total FCP ST"
              style="text-align: right"
              v-model="this.faturamento.total_fcp_st"
              :options="options"
              :readonly="this.camposLivres === false"
            ></CurrencyInput>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["total_fcp_st"] }}
            </div>
            <label class="form-label">Quantidade</label>
            <input
              type="text"
              class="form-control mb-2 text-end"
              v-model="this.faturamento.quantidade"
            />
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["quantidade"] }}
            </div>
            <label class="form-label">Espécie</label>
            <input
              type="text"
              class="form-control mb-2 text-end"
              v-model="this.faturamento.especie"
            />
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["especie"] }}
            </div>
            <label class="form-label">Marca</label>
            <input
              type="text"
              class="form-control mb-2 text-end"
              v-model="this.faturamento.marca"
            />
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["marca"] }}
            </div>
            <label class="form-label">Numeração</label>
            <input
              type="text"
              class="form-control mb-2 text-end"
              v-model="this.faturamento.numeracao"
            />
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["numeracao"] }}
            </div>
            <label class="form-label">Peso Bruto</label>
            <CurrencyInput
              class="form-control mb-2"
              placeholder="Peso Bruto"
              style="text-align: right"
              v-model="this.faturamento.peso_bruto"
              :options="options"
            ></CurrencyInput>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["peso_bruto"] }}
            </div>
            <label class="form-label">Peso Líquido</label>
            <CurrencyInput
              class="form-control mb-2"
              placeholder="Peso Líquido"
              style="text-align: right"
              v-model="this.faturamento.peso_liquido"
              :options="options"
            ></CurrencyInput>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["peso_liquido"] }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ClientesModal
    v-if="exibirClientes"
    @exibirModalClientes="modalClientes"
    @selecionarCliente="selecionarCliente"
  >
  </ClientesModal>
  <ClienteModal
    v-if="exibirCliente"
    :idModal="idModalCliente"
    :idCliente="idCliente"
    @exibirModalCliente="modalCliente"
    @selecionarTelefone="selecionarTelefone"
    @selecionarEmail="selecionarEmail"
    @selecionarEndereco="selecionarEndereco"
  >
  </ClienteModal>
  <component
    :is="modalComponent"
    v-if="exibirProdutos"
    @exibirModalProdutos="modalProdutos"
    @selecionarProduto="selecionarProduto"
  ></component>
  <AdicionalModal
    v-if="exibirAdicional"
    :produto="this.adicionalProduto"
    :add="this.addFaturamentoItem"
    :indexEdicao="this.indexEdicaoFaturamentoItem"
    @exibirModalAdicional="modalAdicional"
    @confirmarAdicional="confirmarAdicional"
  ></AdicionalModal>
  <TransportadorasModal
    v-if="exibirTransportadoras"
    @exibirModalTransportadora="modalTransportadoras"
    @selecionarTransportadora="selecionarTransportadora"
  ></TransportadorasModal>
  <MotoristasModal
    v-if="exibirMotoristas"
    @exibirModalMotoristas="modalMotoristas"
    @selecionarMotorista="selecionarMotorista"
  ></MotoristasModal>
  <VendedoresModal
    v-if="exibirVendedores"
    @exibirModalVendedores="modalVendedores"
    @selecionarVendedor="selecionarVendedor"
  ></VendedoresModal>
  <ObservacoesModal
    v-if="exibirEditarProdutoObservacoes"
    @exibirModalObservacoesProduto="modalEditarProdutoObservacoes"
    @confirmarObservacoesProduto="confirmarObservacoesProduto"
    :observacoes="this.observacaoFaturamentoItem"
  >
  </ObservacoesModal>
  <FaturamentoEditarItemPesoModal
    v-if="exibirEditarProdutoPeso"
    @exibirModalPesoProduto="modalEditarProdutoPeso"
    @confirmarPesoProduto="confirmarPesoProduto"
    :pesoBrutoItem="this.pesoBrutoFaturamentoItem"
    :pesoLiquidoItem="this.pesoLiquidoFaturamentoItem"
  ></FaturamentoEditarItemPesoModal>
  <FaturamentoPagamentoModal
    v-if="exibirFaturamentoPagamento"
    :index="indexFaturamentoPagamento"
    :faturamento="this.faturamento"
    @exibirModalFaturamentoPagamento="modalFaturamentoPagamento"
    @adicionarPagamento="adicionarPagamento"
    @editarPagamento="editarPagamento"
  ></FaturamentoPagamentoModal>
  <FaturamentoEditarChaveModal
    v-if="exibirFaturamentoEditarChave"
    :index="indexFaturamentoEditarChave"
    :chave="this.chaveAcessoAtual"
    @exibirModalEditarChave="modalFaturamentoEditarChave"
    @adicionarChave="adicionarChave"
    @editarChave="editarChave"
  ></FaturamentoEditarChaveModal>
  <FaturamentoEditarAutorizados
    v-if="exibirFaturamentoEditarAutorizados"
    :index="indexFaturamentoAutorizado"
    :autorizado="this.autorizadoAtual"
    @exibirModalEditarAutorizados="modalFaturamentoEditarAutorizados"
    @adicionarAutorizado="adicionarAutorizado"
    @editarAutorizado="editarAutorizado"
  ></FaturamentoEditarAutorizados>
  <FaturamentoEditarNFProdutorRural
    v-if="exibirFaturamentoEditarNFProdutorRural"
    :index="indexFaturamentoNFProdutorRural"
    :refNFPFaturamento="this.nfProdutorRuralAtual"
    :produtor="true"
    @exibirModalEditarNFProdutorRural="modalFaturamentoEditarNFProdutorRural"
    @adicionarNFProdutor="adicionarNFProdutor"
    @editarNFProdutor="editarNFProdutor"
  ></FaturamentoEditarNFProdutorRural>
  <FaturamentoEditarNFProdutorRural
    v-if="exibirFaturamentoEditarNFA"
    :index="indexFaturamentoNFA"
    :refNFPFaturamento="this.nfaAtual"
    :produtor="false"
    @exibirModalEditarNFProdutorRural="modalFaturamentoEditarNFA"
    @adicionarNFProdutor="adicionarNFA"
    @editarNFProdutor="editarNFA"
  ></FaturamentoEditarNFProdutorRural>
  <FaturamentoEditarNFeProduto
    v-if="exibirFaturamentoEditarNFeProduto"
    :index="indexFaturamentoNFeProduto"
    :refProduto="this.nfeProdutoAtual"
    @exibirModalEditarNFeProduto="modalFaturamentoEditarNFeProduto"
    @editarNFeProduto="editarNFeProduto"
  ></FaturamentoEditarNFeProduto>
  <FaturamentoDescontoModal
    v-if="exibirDesconto"
    :total="totalDescontoModal"
    :labelTotal="labelTotal"
    :exibirRemoverDesconto="exibirRemoverDesconto"
    @exibirModalDesconto="modalDesconto"
    @confirmarDesconto="confirmarDesconto"
    @removerDesconto="removerDesconto"
  ></FaturamentoDescontoModal>
  <CfopsModal
    v-if="exibirCfops"
    @exibirModalCfops="modalCfops"
    @selecionarCfop="selecionarCfop"
  ></CfopsModal>
  <ContasModal
    v-if="exibirContas"
    @exibirModalContas="modalContas"
    @selecionarConta="selecionarConta"
  ></ContasModal>
  <CustosModal
    v-if="exibirCustos"
    @exibirModalCustos="modalCustos"
    @selecionarCusto="selecionarCusto"
  ></CustosModal>
  <FaturamentoEditarExporta
    v-if="exibirFaturamentoEditarExporta"
    :index="indexFaturamentoExporta"
    :refExportaFaturamento="this.exportaAtual"
    @exibirModalEditarExporta="modalFaturamentoEditarExporta"
    @adicionarExporta="adicionarExporta"
    @editarExporta="editarExporta"
  ></FaturamentoEditarExporta>
  <FaturamentoEditarCompra
    v-if="exibirFaturamentoEditarCompra"
    :index="indexFaturamentoCompra"
    :refCompraFaturamento="this.compraAtual"
    @exibirModalEditarCompra="modalFaturamentoEditarCompra"
    @adicionarCompra="adicionarCompra"
    @editarCompra="editarCompra"
  ></FaturamentoEditarCompra>
  <FaturamentoEditarVeicTransp
    v-if="exibirFaturamentoEditarVeicTransp"
    :index="indexFaturamentoVeicTransp"
    :refVeicTranspFaturamento="this.veicTranspAtual"
    @exibirModalEditarVeicTransp="modalFaturamentoEditarVeicTransp"
    @adicionarVeicTransp="adicionarVeicTransp"
    @editarVeicTransp="editarVeicTransp"
  ></FaturamentoEditarVeicTransp>
  <FaturamentoSelecionarModelo
    v-if="exibirFaturamentoSelecionarModelo"
    @exibirModalModelosFaturamento="modalFaturamentoSelecionarModelo"
    @confirmarModeloFaturamento="confirmarModeloFaturamento"
  ></FaturamentoSelecionarModelo>
  <FaturamentoEditarProdutoDetalhesModal
    v-if="exibirEditarProdutoDetalhes"
    :detPesagemItem="this.detPesagemFaturamentoItem"
    :detToleranciaItem="this.detToleranciaFaturamentoItem"
    :detTipoEmbalagemItem="this.detTipoEmbalagemFaturamentoItem"
    :detCodBarrasItem="this.detCodBarrasFaturamentoItem"
    :detMetragemItem="this.detMetragemFaturamentoItem"
    @exibirModalEditarProdutoDetalhes="modalEditarProdutoDetalhes"
    @confirmarDetalhesProduto="confirmarDetalhesProduto"
  ></FaturamentoEditarProdutoDetalhesModal>
  <FaturamentoEditarVendedorItem
    v-if="exibirModalVendedorItem"
    :idVendedorItem="this.idVendedorItemAtual"
    :comissaoItem="this.comissaoVendedorItemAtual"
    @exibirModalVendedorItem="modalVendedorItem"
    @confirmarVendedorItem="confirmarVendedorItem"
  ></FaturamentoEditarVendedorItem>
  <FaturamentoImportacaoPedidoVenda
    v-if="exibirModalImportacaoPedidoVenda"
    :cliente="this.faturamento.FaturamentoCliente.id_cliente"
    @exibirModalImportarPedidoVenda="modalImportarPedidoVenda"
    @importarPedidoVenda="importarPedidoVenda"
  ></FaturamentoImportacaoPedidoVenda>
  <AcoesNFeModal
    v-if="this.exibirModalAcoesNFe"
    :id="this.faturamento.id"
    @exibirAcoesNFeModal="exibirAcoesNFeModal"
    @confirmarAcoesNFeModal="confirmarAcoesNFeModal"
    @editarAcoesNFeModal="editarAcoesNFeModal"
  >
  </AcoesNFeModal>
  <EstoquesModal
    v-if="exibirEstoques"
    :produto="this.produtoEstoque"
    :add="this.addFaturamentoItem"
    :indexEdicao="this.indexEdicaoFaturamentoItem"
    @exibirModalEstoques="modalEstoques"
    @confirmarEstoque="confirmarEstoque"
  ></EstoquesModal>
</template>

<script>
import { markRaw } from "vue";
import { hideModal, getOrCreateInstanceModal } from "@/core/helpers/dom";
import { MenuComponent } from "@/assets/ts/components";
import AdicionalModal from "@/views/adicionais/AdicionalModal.vue";
import EstoquesModal from "@/views/produtos/EstoquesModal.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import ClientesModal from "@/views/clientes/ClientesModal.vue";
import ClienteModal from "@/views/clientes/ClienteModal.vue";
import CurrencyInput from "@/components/text/CurrencyInput";
import FocusCurrencyInput from "@/components/text/FocusCurrencyInput";
import FocusTextInput from "@/components/text/FocusTextInput";
import FocusTextInputGroup from "@/components/text/FocusTextInputGroup";
import TransportadorasModal from "@/views/transportadoras/TransportadorasModal.vue";
import MotoristasModal from "@/views/motoristas/MotoristasModal.vue";
import VendedoresModal from "@/views/vendedores/VendedoresModal.vue";
import ObservacoesModal from "@/views/faturamento/ObservacoesProdutoModal.vue";
import FaturamentoReceberModal from "@/views/faturamento/FaturamentoReceberModal.vue";
import FaturamentoPagamentoModal from "@/views/faturamento/FaturamentoPagamentoModal.vue";
import FaturamentoEditarChaveModal from "@/views/faturamento/FaturamentoEditarChaveModal.vue";
import FaturamentoEditarAutorizados from "@/views/faturamento/FaturamentoEditarAutorizados.vue";
import FaturamentoEditarNFProdutorRural from "@/views/faturamento/FaturamentoEditarNFProdutorRural.vue";
import FaturamentoEditarNFeProduto from "@/views/faturamento/FaturamentoEditarNFeProduto.vue";
import FaturamentoEditarItemPesoModal from "@/views/faturamento/FaturamentoEditarItemPesoModal.vue";
import FaturamentoDescontoModal from "@/views/faturamento/FaturamentoDescontoModal.vue";
import CfopsModal from "@/views/produtos/CfopsModal.vue";
import ContasModal from "@/views/contas/ContasModal.vue";
import CustosModal from "@/views/custos/CustosModal.vue";
import FaturamentoEditarExporta from "@/views/faturamento/FaturamentoEditarExporta.vue";
import FaturamentoEditarCompra from "@/views/faturamento/FaturamentoEditarCompra.vue";
import FaturamentoEditarVeicTransp from "@/views/faturamento/FaturamentoEditarVeicTransp.vue";
import FaturamentoSelecionarModelo from "@/views/faturamento/FaturamentoSelecionarModelo.vue";
import FaturamentoEditarProdutoDetalhesModal from "@/views/faturamento/FaturamentoEditarProdutoDetalhesModal.vue";
import FaturamentoEditarVendedorItem from "@/views/faturamento/FaturamentoEditarVendedorItem.vue";
import FaturamentoImportacaoPedidoVenda from "@/views/faturamento/FaturamentoImportacaoPedidoVenda.vue";
import AcoesNFeModal from "@/views/faturamento/AcoesNFeModal.vue";

import { mapState } from "vuex";
import { useToast } from "vue-toastification";
import * as math from "mathjs";
import _ from "lodash";

const toast = useToast();

const faturamentoMapper = {
  cfop: ["tabGeral", "kt_faturamento_geral"],
  ie_substituto: ["tabGeral", "kt_faturamento_geral"],
  data_emissao: ["tabGeral", "kt_faturamento_geral"],
  data_saida: ["tabGeral", "kt_faturamento_geral"],
  hora_saida: ["tabGeral", "kt_faturamento_geral"],
  id_conta: ["tabGeral", "kt_faturamento_geral"],
  id_custo: ["tabGeral", "kt_faturamento_geral"],
  observacao: ["tabGeral", "kt_faturamento_geral"],
  id_transportadora: ["tabGeral", "kt_faturamento_geral"],
  frete: ["tabGeral", "kt_faturamento_geral"],
  id_motorista: ["tabGeral", "kt_faturamento_geral"],
  id_vendedor: ["tabGeral", "kt_faturamento_geral"],
  comissao_per: ["tabGeral", "kt_faturamento_geral"],
  comissao_valor: ["tabGeral", "kt_faturamento_geral"],
  FaturamentoItemitem: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemid_produto: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemnome: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemund: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemqtd: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItempreco: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemtotal_sub_itens: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemtotal: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemtipo_prod: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemipi: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemdesconto: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemacrescimo: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemst: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemcsosn: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemicms: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemcfop: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemxped: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemnitemped: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemobservacao: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemdet_pesagem: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemdet_metragem: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemdet_cod_barras: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemdet_tolerancia: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItemdet_tipo_embalagem: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoItembrinde: ["tabProduto", "kt_faturamento_produtos"],
  FaturamentoClienteFaturamentoEnderecocep: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecopais: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecobairro: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecocidade: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEndereconumero: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecocod_pais: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoendereco: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecodescricao: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecocod_cidade: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecouf: ["tabGeral", "kt_faturamento_geral"],

  FaturamentoClienteFaturamentoEnderecoEntregacep: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoEntregapais: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoEntregabairro: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoEntregacidade: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoEntreganumero: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoEntregacod_pais: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoEntregaendereco: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoEntregadescricao: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoEntregacod_cidade: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoEntregauf: [
    "tabGeral",
    "kt_faturamento_geral",
  ],

  FaturamentoClienteFaturamentoEnderecoRetiradacep: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoRetiradapais: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoRetiradabairro: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoRetiradacidade: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoRetiradanumero: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoRetiradacod_pais: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoRetiradaendereco: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoRetiradadescricao: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoRetiradacod_cidade: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  FaturamentoClienteFaturamentoEnderecoRetiradauf: [
    "tabGeral",
    "kt_faturamento_geral",
  ],
  total: ["", ""],
  total_produtos: ["", ""],
  total_descontos: ["", ""],
  total_acrescimo: ["", ""],
  total_frete: ["", ""],
  total_seguro: ["", ""],
  total_outras: ["", ""],
  base_icms: ["", ""],
  total_icms: ["", ""],
  base_icms_sub: ["", ""],
  total_icms_sub: ["", ""],
  total_ipi: ["", ""],
  quantidade: ["", ""],
  peso_bruto: ["", ""],
  peso_liquido: ["", ""],
  FaturamentoPagamentodescricao: ["tabPagamento", "kt_faturamento_pagamento"],
  FaturamentoPagamentocod_especie: ["tabPagamento", "kt_faturamento_pagamento"],
  FaturamentoPagamentovalor_recebido: [
    "tabPagamento",
    "kt_faturamento_pagamento",
  ],
  FaturamentoPagamentotroco_entrega: [
    "tabPagamento",
    "kt_faturamento_pagamento",
  ],
  FaturamentoPagamentoemissor: ["tabPagamento", "kt_faturamento_pagamento"],
  FaturamentoPagamentotipo: ["tabPagamento", "kt_faturamento_pagamento"],
  FaturamentoPagamentopendente: ["tabPagamento", "kt_faturamento_pagamento"],
};

const faturamentoInicializado = {
  id: 0,
  guid: "",
  nota: "",
  modelo: "55",
  serie: "001",
  cfop: "",
  natureza_operacao: "",
  ie_substituto: "",
  data_emissao: null,
  data_saida: null,
  hora_saida: null,
  tipo_nota: "S",
  total_seguro: 0,
  total_ipi: 0,
  total_frete: 0,
  total_descontos: 0,
  total_acrescimo: 0,
  total_outras: 0,
  total_produtos: 0,
  total: 0,
  base_icms: 0,
  total_icms: 0,
  base_icms_sub: 0,
  total_icms_sub: 0,
  utiliza_icms_sub: true,
  peso_bruto: 0,
  peso_liquido: 0,
  quantidade: "",
  especie: "",
  marca: "",
  numeracao: "",
  frete: "0",
  id_transportadora: null,
  id_conta: null,
  id_custo: null,
  id_motorista: null,
  id_vendedor: null,
  id_condicao: null,
  comissao_per: 0,
  comissao_valor: 0,
  id_dest: 1,
  fin_nfe: 1,
  tp_emis: 1,
  id_final: 0,
  ind_pres: 1,
  ind_intermed: 0,
  cnpj_intermediador: "",
  id_cad_int_tran: "",
  observacao: "",
  inf_ad_fisco: "",
  id_modelo_faturamento: 0,
  ModelosFaturamento: {},
  cancelado: "0",
  status_nfe: "Em Digitação",
  total_pis: 0,
  total_cofins: 0,
  total_imposto: 0,
  total_imposto_estadual: 0,
  total_fcp: 0,
  total_fcp_st: 0,
  FaturamentoCliente: {
    id: null,
    id_faturamento: null,
    id_cliente: null,
    nome: "",
    cpf_cnpj: "",
    rg_ie: "",
    telefone: "",
    email: "",
    Cliente: {
      codigo: null,
    },
    FaturamentoEnderecoEntrega: {},
    FaturamentoEnderecoRetirada: {},
    FaturamentoEndereco: {
      id: null,
      id_faturamento: null,
      id_faturamento_cliente: null,
      id_cliente_endereco: null,
      descricao: "",
      endereco: "",
      complemento: "",
      bairro: "",
      numero: "",
      cep: "",
      cidade: "",
      cod_cidade: "",
      uf: "SP",
      pais: "",
      cod_pais: "",
      latitude: "",
      longitude: "",
    },
  },
  FaturamentoPagamento: [],
  FaturamentoReceber: [],
  FaturamentoItem: [],
  FaturamentoChaveReferenciada: [],
  FaturamentoAutorizados: [],
  FaturamentoRefNFP: [],
  FaturamentoRefNFA: [],
  FaturamentoExporta: [],
  FaturamentoCompra: [],
  FaturamentoVeicTransp: [],
  FaturamentoImportacoes: [],
  Transportadora: {
    nome: "",
  },
  Motorista: {
    nome: "",
  },
  Vendedor: {
    nome: "",
  },
  Condicao: {
    condicoes: "",
  },
};

export default {
  emits: ["cancelarFaturamento", "confirmarFaturamento"],
  components: {
    ClientesModal,
    ClienteModal,
    AdicionalModal,
    Datatable,
    CurrencyInput,
    FocusCurrencyInput,
    FocusTextInput,
    FocusTextInputGroup,
    TransportadorasModal,
    MotoristasModal,
    VendedoresModal,
    ObservacoesModal,
    FaturamentoReceberModal,
    FaturamentoPagamentoModal,
    FaturamentoEditarChaveModal,
    FaturamentoEditarAutorizados,
    FaturamentoEditarNFProdutorRural,
    FaturamentoEditarNFeProduto,
    FaturamentoEditarItemPesoModal,
    FaturamentoDescontoModal,
    CfopsModal,
    ContasModal,
    CustosModal,
    FaturamentoEditarExporta,
    FaturamentoEditarCompra,
    FaturamentoEditarVeicTransp,
    FaturamentoSelecionarModelo,
    FaturamentoEditarProdutoDetalhesModal,
    FaturamentoEditarVendedorItem,
    FaturamentoImportacaoPedidoVenda,
    AcoesNFeModal,
    EstoquesModal,
  },
  props: {
    idFaturamento: { type: Number, required: false, default: 0 },
    modal: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    beforeRouteLeave(to, from, next) {
      if (to.fullPath.includes("movimentacao/faturamento/editar")) {
        this.asyncData();
      }
      next(); // Importante chamar next() para continuar a navegação
    },

    modalCliente(exibir) {
      this.exibirCliente = exibir;
    },

    async modalClientes(exibir) {
      this.exibirClientes = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_clientes_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarClientes");
          },
          /*close*/ () => {
            this.modalClientes(false);
          }
        );
      } else {
        if (this.faturamento.FaturamentoCliente.id_cliente === null) {
          await this.$swal.showQuestionAlert(
            "Para realizar o faturamento um cliente deve ser informado! Deseja continuar?",
            async (alert) => {
              if (alert.isConfirmed) {
                await this.modalClientes(true);
              } else {
                if (this.modal === true) {
                  this.$emit("cancelarFaturamento", false);
                } else {
                  this.$router.push("/movimentacao/faturamento/consultar");
                }
              }
            }
          );
        }
      }
    },

    async selecionarCliente(cliente) {
      this.faturamento.FaturamentoCliente.id_cliente = cliente.id;
      this.errosGerais = {};
      try {
        var ret = await this.$store.dispatch("cliente/getCliente", cliente.id);
        if (ret.Success === true) {
          cliente = ret.Data;
          this.faturamento.FaturamentoCliente.Cliente = cliente;
          this.faturamento.FaturamentoCliente.id_cliente = cliente.id;
          this.faturamento.FaturamentoCliente.nome = cliente.nome;
          this.faturamento.FaturamentoCliente.cpf_cnpj = cliente.cpf_cnpj;
          this.faturamento.FaturamentoCliente.rg_ie = cliente.rg_ie;

          if (cliente.ClienteTelefone.length > 0) {
            this.faturamento.FaturamentoCliente.telefone =
              cliente.ClienteTelefone[0].telefone;
          } else {
            this.faturamento.FaturamentoCliente.telefone = "";
          }

          if (cliente.ClienteEmail.length > 0) {
            this.faturamento.FaturamentoCliente.email =
              cliente.ClienteEmail[0].email;
          } else {
            this.faturamento.FaturamentoCliente.email = "";
          }

          if (cliente.ClienteEndereco.length > 0) {
            this.faturamento.FaturamentoCliente.FaturamentoEndereco.id_cliente_endereco =
              cliente.ClienteEndereco[0].id;
            this.faturamento.FaturamentoCliente.FaturamentoEndereco.descricao =
              cliente.ClienteEndereco[0].descricao;
            this.faturamento.FaturamentoCliente.FaturamentoEndereco.endereco =
              cliente.ClienteEndereco[0].endereco;
            this.faturamento.FaturamentoCliente.FaturamentoEndereco.complemento =
              cliente.ClienteEndereco[0].complemento;
            this.faturamento.FaturamentoCliente.FaturamentoEndereco.bairro =
              cliente.ClienteEndereco[0].bairro;
            this.faturamento.FaturamentoCliente.FaturamentoEndereco.numero =
              cliente.ClienteEndereco[0].numero;
            this.faturamento.FaturamentoCliente.FaturamentoEndereco.cep =
              cliente.ClienteEndereco[0].cep;
            this.faturamento.FaturamentoCliente.FaturamentoEndereco.cidade =
              cliente.ClienteEndereco[0].cidade;
            this.faturamento.FaturamentoCliente.FaturamentoEndereco.cod_cidade =
              cliente.ClienteEndereco[0].cod_cidade;
            this.faturamento.FaturamentoCliente.FaturamentoEndereco.uf =
              cliente.ClienteEndereco[0].uf;
            this.faturamento.FaturamentoCliente.FaturamentoEndereco.pais =
              cliente.ClienteEndereco[0].pais;
            this.faturamento.FaturamentoCliente.FaturamentoEndereco.cod_pais =
              cliente.ClienteEndereco[0].cod_pais;
            this.faturamento.FaturamentoCliente.FaturamentoEndereco.latitude =
              cliente.ClienteEndereco[0].latitude;
            this.faturamento.FaturamentoCliente.FaturamentoEndereco.longitude =
              cliente.ClienteEndereco[0].longitude;

            if (
              this.faturamento.FaturamentoCliente.FaturamentoEndereco.uf ===
              "EX"
            ) {
              this.faturamento.id_dest = 3;
            } else if (
              this.faturamento.FaturamentoCliente.FaturamentoEndereco.uf !==
              this.user.User.Emitente.uf
            ) {
              this.faturamento.id_dest = 2;
            }

            if (
              this.faturamento.FaturamentoCliente.cpf_cnpj &&
              this.faturamento.FaturamentoCliente.cpf_cnpj !== null &&
              this.faturamento.FaturamentoCliente.cpf_cnpj.length > 11 &&
              (this.faturamento.FaturamentoCliente.rg_ie ||
                this.faturamento.FaturamentoCliente.rg_ie === null ||
                this.faturamento.FaturamentoCliente.rg_ie === "")
            ) {
              this.faturamento.id_final = "1"; //Indicar que é consumidor final
            }
          } else {
            this.faturamento.FaturamentoCliente.FaturamentoEndereco =
              JSON.parse(
                JSON.stringify(
                  faturamentoInicializado.FaturamentoCliente.FaturamentoEndereco
                )
              );
          }

          if (this.importacaoPedidoVenda === false) {
            toast.info("Cliente selecionado com sucesso!", {
              timeout: 2000,
            });
          }

          this.modalClientes(false);

          if (
            this.add === true &&
            this.faturamento.FaturamentoItem.length === 1 &&
            this.faturamento.FaturamentoItem[0].em_branco === true
          ) {
            this.tabFocus("tabProduto", "kt_faturamento_produtos");
            this.nextFocus(
              `FaturamentoItem[${
                this.faturamento.FaturamentoItem.length - 1
              }]id_produto`
            );
          }
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },

    exibirEnderecos(index) {
      this.pesquisaEnderecoIndex = index;
      this.idCliente = this.faturamento.FaturamentoCliente.id_cliente;
      this.idModalCliente = 2;
      this.modalCliente(true);
      getOrCreateInstanceModal(
        "kt_modal_cliente_enderecos",
        /*open*/ () => {
          this.$utils.requestFocus("kt_modal_cliente_enderecos");
        },
        /*close*/ () => {
          this.modalCliente(false);
        }
      );
    },

    selecionarTelefone(telefone) {
      this.modalCliente(false);
      this.faturamento.FaturamentoCliente.telefone = telefone;
      toast.info("Telefone selecionado com sucesso!", { timeout: 2000 });
    },

    selecionarEmail(email) {
      this.modalCliente(false);
      this.faturamento.FaturamentoCliente.email = email;
      toast.info("Email selecionado com sucesso!", { timeout: 2000 });
    },

    async selecionarEndereco(endereco) {
      if (this.pesquisaEnderecoIndex === 0) {
        if (!this.faturamento.FaturamentoCliente.FaturamentoEndereco) {
          this.faturamento.FaturamentoCliente.FaturamentoEndereco = JSON.parse(
            JSON.stringify(
              faturamentoInicializado.FaturamentoCliente.FaturamentoEndereco
            )
          );
        }

        this.faturamento.FaturamentoCliente.FaturamentoEndereco.id_cliente_endereco =
          endereco.id;
        this.faturamento.FaturamentoCliente.FaturamentoEndereco.descricao =
          endereco.descricao;
        this.faturamento.FaturamentoCliente.FaturamentoEndereco.endereco =
          endereco.endereco;
        this.faturamento.FaturamentoCliente.FaturamentoEndereco.complemento =
          endereco.complemento;
        this.faturamento.FaturamentoCliente.FaturamentoEndereco.bairro =
          endereco.bairro;
        this.faturamento.FaturamentoCliente.FaturamentoEndereco.numero =
          endereco.numero;
        this.faturamento.FaturamentoCliente.FaturamentoEndereco.cep =
          endereco.cep;
        this.faturamento.FaturamentoCliente.FaturamentoEndereco.cidade =
          endereco.cidade;
        this.faturamento.FaturamentoCliente.FaturamentoEndereco.cod_cidade =
          endereco.cod_cidade;
        this.faturamento.FaturamentoCliente.FaturamentoEndereco.uf =
          endereco.uf;
        this.faturamento.FaturamentoCliente.FaturamentoEndereco.pais =
          endereco.pais;
        this.faturamento.FaturamentoCliente.FaturamentoEndereco.cod_pais =
          endereco.cod_pais;
        this.faturamento.FaturamentoCliente.FaturamentoEndereco.latitude =
          endereco.latitude;
        this.faturamento.FaturamentoCliente.FaturamentoEndereco.longitude =
          endereco.longitude;
      }
      if (this.pesquisaEnderecoIndex === 1) {
        if (!this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega) {
          this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega =
            JSON.parse(
              JSON.stringify(
                faturamentoInicializado.FaturamentoCliente
                  .FaturamentoEnderecoEntrega
              )
            );
        }

        this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega.id_cliente_endereco =
          endereco.id;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega.descricao =
          endereco.descricao;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega.endereco =
          endereco.endereco;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega.complemento =
          endereco.complemento;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega.bairro =
          endereco.bairro;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega.numero =
          endereco.numero;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega.cep =
          endereco.cep;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega.cidade =
          endereco.cidade;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega.cod_cidade =
          endereco.cod_cidade;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega.uf =
          endereco.uf;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega.pais =
          endereco.pais;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega.cod_pais =
          endereco.cod_pais;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega.latitude =
          endereco.latitude;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega.longitude =
          endereco.longitude;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega.cpf_cnpj =
          endereco.cpf_cnpj;
      }

      if (this.pesquisaEnderecoIndex === 2) {
        if (!this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada) {
          this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada =
            JSON.parse(
              JSON.stringify(
                faturamentoInicializado.FaturamentoCliente
                  .FaturamentoEnderecoRetirada
              )
            );
        }

        this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada.id_cliente_endereco =
          endereco.id;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada.descricao =
          endereco.descricao;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada.endereco =
          endereco.endereco;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada.complemento =
          endereco.complemento;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada.bairro =
          endereco.bairro;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada.numero =
          endereco.numero;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada.cep =
          endereco.cep;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada.cidade =
          endereco.cidade;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada.cod_cidade =
          endereco.cod_cidade;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada.uf =
          endereco.uf;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada.pais =
          endereco.pais;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada.cod_pais =
          endereco.cod_pais;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada.latitude =
          endereco.latitude;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada.longitude =
          endereco.longitude;
        this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada.cpf_cnpj =
          endereco.cpf_cnpj;
      }

      if (this.importacaoPedidoVenda === false) {
        toast.info("Endereço selecionado com sucesso!", { timeout: 2000 });
      }

      this.modalCliente(false);
    },

    tabFocus(idTab, idPage) {
      var tabs = document.getElementsByClassName("nav-link-faturamento");
      for (var i = 0; i < tabs.length; i++) {
        tabs[i].classList.remove("active");
      }

      var pages = document.getElementsByClassName("tab-pane-faturamento");
      for (var y = 0; y < pages.length; y++) {
        pages[y].classList.remove("show");
        pages[y].classList.remove("active");
      }

      document.getElementById(idTab).classList.add("active");
      document.getElementById(idPage).classList.add("show");
      document.getElementById(idPage).classList.add("active");
    },

    nextFocus(id) {
      setTimeout(() => {
        if (document.getElementById(id) != null) {
          document.getElementById(id).focus();
        }
      }, 10);
    },

    async carregarConfiguracoes() {
      try {
        var ret = await this.$store.dispatch(
          "configuracao/getConfiguracaoOData",
          "?$select=formula_basecalculo,formula_icms_sub,st_00,st_10,st_20,st_30,st_40,st_41,st_50,st_51,st_60,st_70,st_90,faturamento_exibir_selecao_modelo,utilizar_formula_bc_icms,formula_basecalculo_icms,formula_valor_icms,utilizar_formula_bc_ipi,formula_base_ipi,utilizar_formula_bc_pis_cofins,formula_base_pis,formula_base_cofins,obs_padrao_faturamento,percentual_simples_nacional"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.configuracao = ret.value[0];
        }
      } catch (error) {
        console.log(error);
      }
    },

    async asyncData() {
      try {
        this.loading = true;
        await this.carregarConfiguracoes();

        if (
          (this.$route.name.includes("movimentacao/faturamento/editar") &&
            this.$route.params.id !== undefined) ||
          this.idFaturamento !== 0
        ) {
          this.add = false;
          const id =
            this.modal === true
              ? this.idFaturamento
              : parseInt(this.$route.params.id);

          if ((await this.abrirFaturamento(id)) === false) {
            await this.carregarFaturamento(id);
          }
        } else if (
          this.$route.name.includes("movimentacao/faturamento/editar") ||
          (this.idFaturamento === 0 && this.modal === true)
        ) {
          this.add = true;

          if ((await this.abrirFaturamento(0)) === false) {
            await this.limparFaturamento();
            await this.carregarModeloPadrao();
          }

          if (
            this.$route.query.ImportarPedido !== undefined &&
            this.$route.query.ImportarPedido !== null &&
            this.$utils.isNumber(this.$route.query.ImportarPedido)
          ) {
            let pedido = this.$route.query.ImportarPedido;
            await this.importarPedidoVenda(pedido);
          } else {
            if (this.configuracao.faturamento_exibir_selecao_modelo === "1") {
              await this.selecionarModelosFaturamento();
            } else {
              if (this.faturamento.FaturamentoCliente.id_cliente === null) {
                await this.modalClientes(true);
              }
            }
          }
        }

        this.tableProdutoHeader = this.tableProdutoHeader.filter(
          (item) => item.key !== "csosn" || this.user.User.Emitente.crt === 1
        );

        this.tableProdutoHeader = this.tableProdutoHeader.filter(
          (item) => item.key !== "cst" || this.user.User.Emitente.crt !== 1
        );

        const itemsToSetVisible = [
          "base_icms",
          "total_icms",
          "base_icms_sub",
          "total_icms_sub",
          "total_ipi",
        ];
        this.setVisibilityTrueForItems(
          this.tableProdutoHeader,
          itemsToSetVisible,
          false
        );

        this.loading = false;
        this.confirmouCadastro = true;
      } catch (error) {
        console.log(error);
      }
      setTimeout(MenuComponent.reinitialization, 500);
    },

    async carregarFaturamento() {
      this.errosGerais = {};
      var id = 0;
      if (this.modal === true) {
        id = this.idFaturamento;
      } else if (this.idFaturamentoGravado > 0) {
        id = this.idFaturamentoGravado;
      } else {
        id = this.$route.params.id;
      }

      try {
        var ret = await this.$store.dispatch("faturamento/getFaturamento", id);
        if (ret.Success === true) {
          this.faturamento = ret.Data;

          this.faturamento.peso_bruto =
            this.faturamento.peso_bruto != null
              ? parseFloat(this.faturamento.peso_bruto)
              : 0;
          this.faturamento.peso_liquido =
            this.faturamento.peso_liquido != null
              ? parseFloat(this.faturamento.peso_liquido)
              : 0;

          this.faturamento.utiliza_icms_sub = this.$utils.stringToBoolean(
            this.faturamento.utiliza_icms_sub
          );

          if (this.faturamento.FaturamentoCliente != null) {
            if (this.faturamento.FaturamentoCliente.id_cliente != null) {
              try {
                var retCli = await this.$store.dispatch(
                  "cliente/getCliente",
                  this.faturamento.FaturamentoCliente.id_cliente
                );
                if (retCli.Success === true) {
                  this.faturamento.FaturamentoCliente.Cliente = retCli.Data;
                }
              } catch (error) {
                this.errosGerais = error;
              }
            }
          }
        } else {
          await this.$swal.showInvalidAlert(
            "Não foi possível encontrar o faturamento selecionado!",
            (alert) => {
              this.$router.push("/movimentacao/faturamento/consultar");
            }
          );
        }

        setTimeout(MenuComponent.reinitialization, 500);
      } catch (error) {
        this.errosGerais = error;
      }
      this.loading = false;
    },

    async limparFaturamento() {
      this.faturamento = JSON.parse(JSON.stringify(faturamentoInicializado));
      this.pesquisaProduto = "";
      this.pesquisaAdicionarExcluirProduto = "";
      this.idCliente = 0;
      this.errosGerais = {};
      this.errosValidacao = [];
      this.errosValidacaoGeral = [];

      this.faturamento.data_emissao = new Date();
      this.faturamento.data_saida = new Date();
      this.faturamento.hora_saida = new Date().toTimeString().slice(0, 8);

      if (
        this.configuracao.obs_padrao_faturamento &&
        this.configuracao.obs_padrao_faturamento !== null &&
        this.configuracao.obs_padrao_faturamento !== ""
      ) {
        this.faturamento.observacao = this.configuracao.obs_padrao_faturamento;
      }

      if (
        !this.faturamento.FaturamentoItem ||
        this.faturamento.FaturamentoItem.length === 0
      ) {
        this.adicionarProdutoEmBranco();
      }
    },

    async modalProdutos(exibir) {
      try {
        this.exibirProdutos = exibir;
        import("@/views/produtos/ProdutosModal.vue").then((module) => {
          this.modalComponent = markRaw(module.default);
        });
        if (exibir === true) {
          setTimeout(() => {
            getOrCreateInstanceModal(
              "kt_modal_produtos_consultar",
              /*open*/ () => {
                this.$utils.requestFocus("txtPesquisarProdutos");
              },
              /*close*/ () => {
                this.modalProdutos(false);
              }
            );
          }, 100);
        } else {
          // setTimeout(() => {
          //   document.getElementById("InclusaoRapida").focus();
          // }, 100);
        }
      } catch (error) {
        console.log(error);
        this.exibirProdutos = false;
      }
    },

    async confirmarFaturamento() {
      this.errosGerais = {};
      this.errosValidacao = [];
      this.errosValidacaoGeral = [];
      this.loading = true;
      this.confirmouCadastro = true;

      if ((await this.validar()) === true) {
        this.faturamento.peso_bruto != null
          ? this.faturamento.peso_bruto.toString()
          : "0";

        this.faturamento.peso_liquido != null
          ? this.faturamento.peso_liquido.toString()
          : "0";

        this.faturamento.utiliza_icms_sub = this.$utils.booleanToString(
          this.faturamento.utiliza_icms_sub
        );

        if (
          this.configuracao.obs_padrao_faturamento &&
          this.configuracao.obs_padrao_faturamento !== null &&
          this.configuracao.obs_padrao_faturamento !== "" &&
          this.configuracao.percentual_simples_nacional &&
          this.configuracao.percentual_simples_nacional > 0
        ) {
          this.faturamento.observacao = this.faturamento.observacao.replace(
            /R\$[0-9,.]+;/g,
            "R$ " +
              this.$utils.formatarNumero(
                (this.faturamento.total *
                  this.configuracao.percentual_simples_nacional) /
                  100
              ) +
              ";"
          );

          this.faturamento.observacao = this.faturamento.observacao.replace(
            /R\$ \d+(,\d{1,2});/g,
            (match) => {
              const numericValue = match.match(/\d+(,\d{1,2})/)[0];
              const novoValor =
                "R$ " +
                this.$utils.formatarNumero(
                  (this.faturamento.total *
                    this.configuracao.percentual_simples_nacional) /
                    100
                );
              return novoValor + ";";
            }
          );

          this.faturamento.observacao = this.faturamento.observacao.replace(
            /\.\.\.%/g,
            this.$utils.formatarNumero(
              this.configuracao.percentual_simples_nacional
            ) + "%"
          );
        }

        if (this.faturamento.id === 0) {
          this.faturamento.guid = this.$utils.generateUuidv4();
          this.faturamento.operador = this.user.User.id;

          let formData = this.$utils.convertModelToFormData(this.faturamento);
          try {
            let ret = await this.$store.dispatch(
              "faturamento/postFaturamento",
              formData
            );

            await this.limparFaturamentoLocalStorage(
              this.user.User.id,
              this.faturamento.id
            );

            this.idFaturamentoGravado = ret.Data.id;
            await this.carregarFaturamento();
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJsonAtalho(error, faturamentoMapper)
            );
            this.errosGerais = error;
            this.errosValidacao = error;
            this.confirmouCadastro = false;
          }
        } else {
          let formData = this.$utils.convertModelToFormData(this.faturamento);
          try {
            let ret = await this.$store.dispatch(
              "faturamento/putFaturamento",
              formData
            );
            this.idFaturamentoGravado = ret.Data.id;
            await this.carregarFaturamento();
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJsonAtalho(error, faturamentoMapper)
            );
            this.errosGerais = error;
            this.errosValidacao = error;
            this.confirmouCadastro = false;
          }
        }

        if (this.errosGerais.Message) {
          this.scroll("errosGerais");
        }

        this.faturamento.utiliza_icms_sub = this.$utils.stringToBoolean(
          this.faturamento.utiliza_icms_sub
        );

        this.faturamento.peso_bruto =
          this.faturamento.peso_bruto != null
            ? parseFloat(this.faturamento.peso_bruto)
            : 0;
        this.faturamento.peso_liquido =
          this.faturamento.peso_liquido != null
            ? parseFloat(this.faturamento.peso_liquido)
            : 0;

        if (this.confirmouCadastro === true) {
          if (this.faturamento.modelo === "55") {
            await this.acoesNFe();
          } else {
            toast.success("Faturamento salvo com sucesso!", { timeout: 2000 });
            setTimeout(async () => {
              this.limparFaturamentoLocalStorage(
                this.user.User.id,
                this.faturamento.id
              );
              if (this.faturamento.id !== 0) {
                await this.deleteControleEdicao(this.faturamento.id);
              }
            }, 500);
            if (this.modal === true) {
              this.$emit("confirmarFaturamento");
            } else {
              this.$router.push("/movimentacao/faturamento/consultar");
            }
          }
        } else {
          toast.error("Ocorreu uma falha ao gravar o faturamento, verifique!", {
            timeout: 5000,
          });
        }
      } else {
        await this.$swal.showInvalidAlert("Verifique os avisos!");
      }
      this.loading = false;
      setTimeout(MenuComponent.reinitialization, 500);
    },

    async exibirAcoesNFeModal(exibir) {
      this.exibirModalAcoesNFe = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_acoes_nfe_modal",
          /*open*/ () => {
            this.$utils.requestFocus("kt_acoes_nfe_modal");
          },
          /*close*/ () => {
            this.exibirAcoesNFeModal(false);
          }
        );
      } else {
        setTimeout(async () => {
          this.limparFaturamentoLocalStorage(
            this.user.User.id,
            this.faturamento.id
          );
          if (this.faturamento.id !== 0) {
            await this.deleteControleEdicao(this.faturamento.id);
          }
          if (this.modal === true) {
            await this.$emit("confirmarFaturamento");
          } else {
            await this.$router.push("/movimentacao/faturamento/consultar");
          }
        }, 500);
      }
    },
    async acoesNFe() {
      this.exibirAcoesNFeModal(true);
    },
    async confirmarAcoesNFeModal() {
      console.log("");
    },

    async validar() {
      if (this.faturamento.FaturamentoItem.length <= 0) {
        this.atualizarErrosValidacao(
          "",
          "É necessário ao menos um produto para gravar um faturamento",
          "tabProduto",
          "kt_faturamento_produtos",
          ""
        );
      }

      if (this.addItemBranco === false) {
        var itensRemover = this.faturamento.FaturamentoItem.filter(function (
          obj
        ) {
          return obj.em_branco === true;
        });

        if (itensRemover.length > 0) {
          itensRemover.forEach((item) => {
            this.faturamento.FaturamentoItem.splice(
              this.faturamento.FaturamentoItem.indexOf(item),
              1
            );
          });
        }
      }

      return true;
    },

    atualizarErrosValidacao(id, error, idTab, idPage, click) {
      this.errosValidacao[id] = error;
      this.errosValidacaoGeral.push({
        error: this.getErrorByID(id),
        elemento: id,
        tab: idTab,
        tabID: idPage,
        onClick: click,
      });
    },

    async inclusaoRapidaProduto() {
      var filterOdata = "";
      this.errosGerais = {};
      this.errosValidacao = [];
      if (this.pesquisaProduto != "") {
        var radio = document.getElementsByName("rbPesquisaRapida");
        if (radio[0].checked && this.$utils.isNumber(this.pesquisaProduto)) {
          //Pesquisa código
          filterOdata = "&$filter=codigo eq " + this.pesquisaProduto;
        }
        if (radio[1].checked) {
          //Pesquisa barras
          filterOdata = "&$filter=ean eq '" + this.pesquisaProduto + "'";
        }
        if (filterOdata != "") {
          try {
            var retOdata = await this.$store.dispatch(
              "produto/getProdutoOData",
              "?$expand=Adicional($expand=AdicionalGrupo($expand=AdicionalGrupoItem)),ProdutoTributacao" +
                filterOdata
            );
            if (retOdata.value !== null && retOdata.value.length > 0) {
              var produto = retOdata.value[0];
              this.selecionarProduto(produto);
            } else {
              await this.$swal.showInvalidAlert(
                "Nenhum Produto foi encontrado com o código informado!"
              );
            }
          } catch (error) {
            this.errosGerais = error;
          }
        } else {
          this.errosValidacao = {
            inclusaoRapida: "Verifique o código do produto",
          };
        }
      } else {
        this.errosValidacao = { inclusaoRapida: "Informe o código do produto" };
      }
    },

    modalAdicional(exibir) {
      this.exibirAdicional = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_adicional_produto",
          /*open*/ () => {
            this.$utils.requestFocusSelect(`Qtd`);
          },
          /*close*/ () => {
            this.modalAdicional(false);
          }
        );
      }
    },

    async editarAdicional(index) {
      this.errosGerais = {};
      try {
        var ret = await this.$store.dispatch(
          "produto/getProduto",
          this.faturamento.FaturamentoItem[index].id_produto
        );
        if (ret.Success === true) {
          var prod = ret.Data;
          prod.promocaoAtiva = this.verificarPromocaoAtiva(prod);
          if (prod.promocaoAtiva === true) {
            if (
              this.faturamento.FaturamentoItem[index].preco !==
              prod.preco_promocao
            ) {
              prod.promocaoAtiva = false;
              prod.preco = this.faturamento.FaturamentoItem[index].preco;
            }
          } else {
            prod.preco = this.faturamento.FaturamentoItem[index].preco;
          }
          prod.qtd = this.faturamento.FaturamentoItem[index].qtd;
          prod.id_estoque = this.faturamento.FaturamentoItem[index].id_estoque;
          this.adicionalProduto = this.preencheAdicionalEdicao(prod, index);
          this.addFaturamentoItem = false;
          this.indexEdicaoFaturamentoItem = index;
          this.modalAdicional(true);
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },

    preencheAdicionalEdicao(prod, index) {
      for (var i = 0; i < prod.Adicional.AdicionalGrupo.length; i++) {
        for (
          var y = 0;
          y < prod.Adicional.AdicionalGrupo[i].AdicionalGrupoItem.length;
          y++
        ) {
          for (
            var z = 0;
            z <
            this.faturamento.FaturamentoItem[index].FaturamentoSubItem.length;
            z++
          ) {
            if (
              this.faturamento.FaturamentoItem[index].FaturamentoSubItem[z]
                .id_adicional_grupo_item ===
              prod.Adicional.AdicionalGrupo[i].AdicionalGrupoItem[y].id
            ) {
              prod.Adicional.AdicionalGrupo[i].AdicionalGrupoItem[y].qtd =
                this.faturamento.FaturamentoItem[index].FaturamentoSubItem[
                  z
                ].qtd;
            }
          }
        }
      }

      prod.observacao =
        this.faturamento.FaturamentoItem[index].observacao.split("Obs: ")[1];

      return prod;
    },

    confirmarAdicional(produto, add, index) {
      this.modalAdicional(false);
      this.preencheProdutoSelecionado(produto, add, index);
    },

    verificarPromocaoAtiva(produto) {
      var promocaoAtiva = false;
      if (produto.promocao_ativa === "1" && produto.preco_promocao > 0) {
        if (new Date(produto.data_inicio_promocao) <= new Date()) {
          if (new Date(produto.data_fim_promocao) >= new Date()) {
            if (produto.promocao_tipo === "0") {
              promocaoAtiva = true;
            } else {
              if (produto.promocao_dias_semana !== null) {
                var diaDaSemana = new Date().getDay();
                if (produto.promocao_dias_semana.includes(diaDaSemana)) {
                  promocaoAtiva = true;
                }
              }
            }
          }
        }
      }
      return promocaoAtiva;
    },

    async preencheProdutoSelecionado(produto, add, index) {
      try {
        var listSubItem = [];
        var quantidade = produto.qtd ? produto.qtd : 1;
        var obs = "";
        let idPedido = 0;

        if (produto.Adicional != null) {
          for (var i = 0; i < produto.Adicional.AdicionalGrupo.length; i++) {
            for (
              var y = 0;
              y < produto.Adicional.AdicionalGrupo[i].AdicionalGrupoItem.length;
              y++
            ) {
              var item =
                produto.Adicional.AdicionalGrupo[i].AdicionalGrupoItem[y];
              if (item.qtd > 0) {
                obs +=
                  (obs != "" ? "\r\n" : "") +
                  item.qtd +
                  "  " +
                  item.descricao +
                  (item.valor > 0
                    ? " - " + this.$utils.formatarNumero(item.valor)
                    : "");

                listSubItem.push({
                  id: null,
                  id_faturamento: null,
                  id_faturamento_item: null,
                  id_adicional_grupo_item: item.id,
                  item: 0,
                  descricao: item.descricao,
                  qtd: item.qtd,
                  preco: item.valor,
                  total: 0,
                  desconto: 0,
                  acrescimo: 0,
                  cod_referencia: item.cod_referencia,
                  observacao: "",
                });
              }
            }
          }
        }
        obs += produto.observacao
          ? (obs != "" ? "\r\nObs: " : "") + produto.observacao
          : "";

        if (
          produto.PedidoSubItem !== undefined &&
          produto.PedidoSubItem !== null &&
          produto.PedidoSubItem.length > 0
        ) {
          for (const item in produto.PedidoSubItem) {
            const adicional = produto.PedidoSubItem[item];
            obs +=
              (obs != "" ? "\r\n" : "") +
              adicional.qtd +
              "  " +
              adicional.descricao +
              (adicional.preco > 0
                ? " - " + this.$utils.formatarNumero(adicional.preco)
                : "");
            listSubItem.push({
              id: null,
              id_faturamento: null,
              id_faturamento_item: null,
              id_adicional_grupo_item: adicional.id_adicional_grupo_item,
              item: 0,
              descricao: adicional.descricao,
              qtd: adicional.qtd,
              preco: adicional.preco,
              total: adicional.total,
              desconto: adicional.desconto,
              acrescimo: adicional.acrescimo,
              cod_referencia: adicional.cod_referencia,
              observacao: adicional.observacao,
            });
          }
        }

        if (
          produto.id_pedido !== undefined &&
          produto.id_pedido !== null &&
          produto.id_pedido > 0
        ) {
          idPedido = produto.id_pedido;
        }

        var em_branco = false;
        if (produto.em_branco !== undefined) {
          em_branco = produto.em_branco;
        }

        if (add === true) {
          var preco =
            produto.promocaoAtiva === true
              ? produto.preco_promocao
              : produto.preco;

          let cfop = String(produto.ProdutoTributacao.cfop);

          if (cfop && cfop.length >= 4) {
            let clienteUF =
              this.faturamento.FaturamentoCliente.FaturamentoEndereco.uf;
            let emitenteUF = this.user.User.Emitente.uf;

            if (clienteUF !== emitenteUF && cfop.startsWith("5")) {
              cfop = "6" + cfop.substring(1);
            }
          } else {
            if (
              this.faturamento.ModelosFaturamento &&
              this.faturamento.ModelosFaturamento !== null
            ) {
              let clienteUF =
                this.faturamento.FaturamentoCliente.FaturamentoEndereco.uf;
              let emitenteUF = this.user.User.Emitente.uf;

              if (clienteUF !== emitenteUF) {
                cfop = this.faturamento.ModelosFaturamento.cfop_externa;
              } else {
                cfop = this.faturamento.ModelosFaturamento.cfop_interna;
              }
            }
          }

          let itemAdicionar = {
            id: 0,
            id_faturamento: 0,
            item: 0,
            id_produto: produto.id,
            id_estoque: produto.id_estoque,
            id_estoque_variacao: null,
            und: produto.und,
            nome: produto.nome,
            qtd: quantidade,
            custo: produto.preco_custo,
            preco: preco,
            desconto: 0,
            acrescimo: 0,
            valor_frete: 0,
            valor_outras: 0,
            valor_seguro: 0,
            total_sub_itens: 0,
            total: 0,
            cod_referencia: produto.cod_referencia,
            observacao: obs,
            Produto: produto,
            FaturamentoSubItem: listSubItem.length > 0 ? listSubItem : [],
            brinde: produto.brinde,
            st: produto.ProdutoTributacao.st,
            cfop: cfop,
            csosn: produto.ProdutoTributacao.csosn,
            icms: parseFloat(produto.ProdutoTributacao.icms),
            ipi: produto.ProdutoTributacao.ipi,
            mva: produto.ProdutoTributacao.mva,
            aliqi: parseFloat(produto.ProdutoTributacao.aliqi),
            reducao: produto.ProdutoTributacao.reducao,
            base_icms: 0,
            total_icms: 0,
            base_icms_sub: 0,
            total_icms_sub: 0,
            total_ipi: 0,
            det_cod_barras: null,
            det_metragem: null,
            det_pesagem: null,
            det_tipo_embalagem: null,
            det_tolerancia: null,
            id_vendedor: null,
            comissao: 0,
            xped: null,
            nitemped: null,
            peso_bruto: 0,
            peso_liquido: 0,
            qtd_entregue: 0,
            qtd_importada: 0,
            tipo_prod: null,
            em_branco: em_branco,
            FaturamentoItemNFe: {},
            cancelado: "0",
            id_pedido: idPedido,
            pis_st: produto.ProdutoTributacao.pis_st,
            pis_base: 0,
            pis_aliq: produto.ProdutoTributacao.pis_aliq,
            total_pis: 0,
            cofins_st: produto.ProdutoTributacao.cofins_st,
            cofins_base: 0,
            cofins_aliq: produto.ProdutoTributacao.cofins_aliq,
            total_cofins: 0,
            total_imposto: 0,
            total_imposto_estadual: 0,
            p_fcp: produto.ProdutoTributacao.aliq_fcp,
            v_fcp: 0,
            p_fcp_st: produto.ProdutoTributacao.aliq_fcp,
            v_fcp_st: 0,
          };

          if (
            produto.ProdutoTributacao &&
            produto.ProdutoTributacao.id_estoque_st &&
            produto.ProdutoTributacao.id_estoque_st !== null &&
            produto.ProdutoTributacao.id_estoque_st > 0
          ) {
            let tabelaEstados = await this.retornarTabelaEstados(
              produto.ProdutoTributacao.id_estoque_st
            );
            if (tabelaEstados !== null) {
              itemAdicionar.aliqi = tabelaEstados.aliqi;
              itemAdicionar.icms = tabelaEstados.aliq;
              itemAdicionar.mva = tabelaEstados.mva;
              itemAdicionar.reducao = tabelaEstados.reducao;
              itemAdicionar.st = tabelaEstados.st;
              itemAdicionar.csosn = tabelaEstados.csosn;

              if (
                tabelaEstados.estoqueST &&
                tabelaEstados.estoqueST.cfop &&
                tabelaEstados.estoqueST.cfop.length > 0
              ) {
                itemAdicionar.cfop = String(tabelaEstados.estoqueST.cfop);
              }
            }
          }

          this.faturamento.FaturamentoItem.push(itemAdicionar);

          if (produto.em_branco === undefined || produto.em_branco === false) {
            setTimeout(() => {
              var input = document.getElementById(
                `FaturamentoItem[${
                  this.faturamento.FaturamentoItem.length - 1
                }]qtd`
              );
              input.focus();

              if (this.pesquisaAdicionarExcluirProduto != "") {
                this.pesquisaAdicionarExcluirProduto = "";
                this.nextFocus("txtAdicionarExcluirProduto");
              }

              MenuComponent.reinitialization();
            }, 100);
          }
        } else {
          this.faturamento.FaturamentoItem[index].qtd = quantidade;
          this.faturamento.FaturamentoItem[index].total_sub_itens = 0;
          this.faturamento.FaturamentoItem[index].total = 0;
          this.faturamento.FaturamentoItem[index].observacao = obs;
          this.faturamento.FaturamentoItem[index].Produto = produto;
          this.faturamento.FaturamentoItem[index].id_estoque =
            produto.id_estoque;
          this.faturamento.FaturamentoItem[index].FaturamentoSubItem = null;
          this.faturamento.FaturamentoItem[index].FaturamentoSubItem =
            listSubItem.length > 0 ? listSubItem : [];

          toast.info("Produto atualizado com sucesso!", {
            timeout: 2000,
          });
        }

        this.pesquisaProduto = "";
        this.recalcularValores();
      } catch (error) {
        console.log(error);
      }
    },

    async selecionarProduto(produto) {
      this.errosGerais = {};
      try {
        var ret = await this.$store.dispatch("produto/getProduto", produto.id);
        if (ret.Success === true) {
          var prod = ret.Data;
          if (produto.brinde === undefined || produto.brinde === null) {
            prod.brinde = "N";
          } else {
            prod.brinde = produto.brinde;
            prod.qtd = produto.qtd;
          }
          prod.promocaoAtiva = this.verificarPromocaoAtiva(prod);
          if (prod.Estoque != null && prod.Estoque.length > 0) {
            prod.id_estoque = prod.Estoque[0].id;
          }
          if (prod.Adicional != null) {
            this.adicionalProduto = prod;
            this.addFaturamentoItem = true;
            this.indexEdicaoFaturamentoItem = -1;
            this.modalAdicional(true);
          } else {
            if (prod.Estoque != null && prod.Estoque.length > 1) {
              this.produtoEstoque = prod;
              this.addFaturamentoItem = true;
              this.indexEdicaoFaturamentoItem = -1;
              this.modalEstoques(true);
            } else {
              this.preencheProdutoSelecionado(prod, true, -1);
            }
          }
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },

    modalEstoques(exibir) {
      this.exibirEstoques = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_estoques",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarEstoques");
          },
          /*close*/ () => {
            this.modalEstoques(false);
          }
        );
      }
    },

    async editarEstoque(index) {
      try {
        var ret = await this.$store.dispatch(
          "produto/getProduto",
          this.faturamento.FaturamentoItem[index].id_produto
        );
        if (ret.Success === true) {
          var prod = ret.Data;
          prod.promocaoAtiva = this.verificarPromocaoAtiva(prod);
          if (prod.promocaoAtiva === true) {
            if (
              this.faturamento.FaturamentoItem[index].preco !==
              prod.preco_promocao
            ) {
              prod.promocaoAtiva = false;
              prod.preco = this.faturamento.FaturamentoItem[index].preco;
            }
          } else {
            prod.preco = this.faturamento.FaturamentoItem[index].preco;
          }
          prod.qtd = this.faturamento.FaturamentoItem[index].qtd;
          prod.id_estoque = this.faturamento.FaturamentoItem[index].id_estoque;
          prod.observacao = this.faturamento.FaturamentoItem[index].observacao;
          this.produtoEstoque =
            prod.Adicional != null
              ? this.preencheAdicionalEdicao(prod, index)
              : prod;
          this.addFaturamentoItem = false;
          this.indexEdicaoFaturamentoItem = index;
          this.modalEstoques(true);
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },

    confirmarEstoque(produto, add, index) {
      this.modalEstoques(false);
      this.preencheProdutoSelecionado(produto, add, index);
    },

    async recalcularValores() {
      var totalProdutos = 0;
      var totalDescontos = 0;
      var totalAcrescimos = 0;
      var totalBaseICMS = 0;
      var totalValorICMS = 0;
      var totalBaseICMSST = 0;
      var totalValorICMSST = 0;
      var totalIPI = 0;
      var totalPesoBruto = 0;
      var totalPesoLiquido = 0;
      let cfops = [];
      let totalPIS = 0;
      let totalCOFINS = 0;
      let totalImposto = 0;
      let totalImpostoEstadual = 0;
      let totalFCP = 0;
      let totalFCPST = 0;

      if (this.addItemBranco === false) {
        var itensRemover = this.faturamento.FaturamentoItem.filter(function (
          obj
        ) {
          return obj.em_branco === true;
        });

        if (itensRemover.length > 0) {
          itensRemover.forEach((item) => {
            this.faturamento.FaturamentoItem.splice(
              this.faturamento.FaturamentoItem.indexOf(item),
              1
            );
          });
        }
      }

      for (var i = 0; i < this.faturamento.FaturamentoItem.length; i++) {
        var item = this.faturamento.FaturamentoItem[i];
        var totalSubItens = 0;
        for (var y = 0; y < item.FaturamentoSubItem.length; y++) {
          var subItem = item.FaturamentoSubItem[y];
          subItem.total = subItem.qtd * subItem.preco;
          totalSubItens += subItem.total;
        }

        item.total_sub_itens = item.qtd * totalSubItens;

        if (this.camposLivres === false) {
          item.total =
            item.qtd * item.preco +
            item.total_sub_itens -
            item.desconto +
            item.acrescimo;

          if (
            this.configuracao.utilizar_formula_bc_ipi &&
            this.configuracao.utilizar_formula_bc_ipi === "1"
          ) {
            item.total_ipi = parseFloat(
              ((this.calculaBaseIPI(i) * item.ipi) / 100).toFixed(2)
            );
          } else {
            item.total_ipi = parseFloat(
              ((item.total * item.ipi) / 100).toFixed(2)
            );
          }

          if (
            this.configuracao.utilizar_formula_bc_pis_cofins &&
            this.configuracao.utilizar_formula_bc_pis_cofins === "1"
          ) {
            item.pis_base = this.calculaBasePIS(i);
            item.cofins_base = this.calculaBaseCOFINS(i);
            item.total_pis = parseFloat(
              ((this.calculaBasePIS(i) * item.pis_aliq) / 100).toFixed(2)
            );
            item.total_cofins = parseFloat(
              ((this.calculaBaseCOFINS(i) * item.cofins_aliq) / 100).toFixed(2)
            );
          } else {
            item.pis_base = item.total;
            item.cofins_base = item.total;
            item.total_pis = parseFloat(
              ((item.total * item.pis_aliq) / 100).toFixed(2)
            );
            item.total_cofins = parseFloat(
              ((item.total * item.cofins_aliq) / 100).toFixed(2)
            );
          }
        }

        totalProdutos += item.total;
        totalDescontos += item.desconto;
        totalAcrescimos += item.acrescimo;
        totalIPI += item.total_ipi;
        totalPIS += item.total_pis;
        totalCOFINS += item.total_cofins;

        if (item.peso_bruto > 0) {
          totalPesoBruto += item.qtd * item.peso_bruto;
        } else {
          totalPesoBruto += item.qtd * item.Produto.peso;
        }

        if (item.peso_liquido > 0) {
          totalPesoLiquido += item.qtd * item.peso_liquido;
        } else {
          totalPesoLiquido += item.qtd * item.Produto.peso_liquido;
        }

        if (item.cfop !== undefined && item.cfop !== null) {
          const cfopStr = String(item.cfop);
          if (cfopStr !== "" && !cfops.includes(cfopStr)) {
            cfops.push(cfopStr);
          }
          if (cfopStr !== "") {
            item.cfop = cfopStr;
          }
        }

        if (item.FaturamentoItemNFe) {
          if (item.FaturamentoItemNFe.tipo_desoneracao === "8") {
            this.exibirGrupoCompra = true;
          } else {
            this.faturamento.FaturamentoCompra.splice(0);
            this.exibirGrupoCompra = false;
          }

          item.p_fcp = item.FaturamentoItemNFe.aliquota_fcp;
          item.p_fcp_st = item.FaturamentoItemNFe.aliquota_fcp_st;
        }
      }

      this.faturamento.cfop = cfops.join(",");

      if (cfops.length > 0) {
        //Selecionar a natureza da operação da primeira CFOP
        this.faturamento.natureza_operacao = await this.retornarNaturezaCFOP(
          cfops[0]
        );
      }

      this.faturamento.total_produtos = totalProdutos;
      this.faturamento.total_descontos = totalDescontos;
      this.faturamento.total_acrescimo = totalAcrescimos;
      this.faturamento.total_ipi = totalIPI;
      this.faturamento.peso_bruto = totalPesoBruto;
      this.faturamento.peso_liquido = totalPesoLiquido;

      this.faturamento.total =
        this.faturamento.total_produtos +
        this.faturamento.total_outras +
        this.faturamento.total_frete +
        this.faturamento.total_seguro +
        this.faturamento.total_ipi;

      //Ratear valores Frete, Seguro e Outras
      for (var p = 0; p < this.faturamento.FaturamentoItem.length; p++) {
        var it = this.faturamento.FaturamentoItem[p];
        var valorFrete = 0;
        var valorOutras = 0;
        var valorSeguro = 0;
        var percentualProporcional = (it.total * 100) / totalProdutos;

        valorFrete =
          (this.faturamento.total_frete * percentualProporcional) / 100;
        it.valor_frete = valorFrete;

        valorOutras =
          (this.faturamento.total_outras * percentualProporcional) / 100;
        it.valor_outras = valorOutras;

        valorSeguro =
          (this.faturamento.total_seguro * percentualProporcional) / 100;
        it.valor_seguro = valorSeguro;

        this.calculaBaseST(p);
        totalBaseICMS += it.base_icms;
        totalValorICMS += it.total_icms;
        totalBaseICMSST += it.base_icms_sub;
        totalValorICMSST += it.total_icms_sub;
        totalFCP += parseFloat(it.v_fcp);
        totalFCPST += parseFloat(it.v_fcp_st);
      }

      this.faturamento.base_icms = totalBaseICMS;
      this.faturamento.total_icms = totalValorICMS;
      this.faturamento.base_icms_sub = totalBaseICMSST;
      this.faturamento.total_icms_sub = totalValorICMSST;
      this.faturamento.total_pis = totalPIS;
      this.faturamento.total_cofins = totalCOFINS;
      this.faturamento.total_imposto = totalImposto;
      this.faturamento.total_imposto_estadual = totalImpostoEstadual;
      this.faturamento.total_fcp = totalFCP;
      this.faturamento.total_fcp_st = totalFCPST;

      if (
        this.faturamento.utiliza_icms_sub === true ||
        this.faturamento.utiliza_icms_sub === "1"
      ) {
        this.faturamento.total =
          this.faturamento.total_produtos +
          this.faturamento.total_outras +
          this.faturamento.total_frete +
          this.faturamento.total_seguro +
          this.faturamento.total_ipi +
          this.faturamento.total_icms_sub +
          this.faturamento.total_fcp_st;
      }

      this.faturamento.comissao_valor =
        (this.faturamento.comissao_per * this.faturamento.total) / 100;

      if (
        !this.faturamento.FaturamentoItem ||
        this.faturamento.FaturamentoItem.length === 0
      ) {
        this.adicionarProdutoEmBranco();
      }
    },

    calculaPercentualComissao() {
      this.faturamento.comissao_per =
        (this.faturamento.comissao_valor * 100) / this.faturamento.total;
      this.recalcularValores();
    },

    calculaBaseST(index) {
      try {
        if (this.camposLivres === false) {
          var item = this.faturamento.FaturamentoItem[index];
          if (this.user.User.Emitente.crt === 1) {
            if (
              item.csosn &&
              item.csosn !== null &&
              (item.csosn !== "") & (item.csosn.length === 4)
            ) {
              let csosn = item.csosn.substring(1, 4);
              if (csosn === "101") {
                item.base_icms = 0;
                item.total_icms = 0;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else if (
                csosn === "102" ||
                csosn === "103" ||
                csosn === "300" ||
                csosn === "400"
              ) {
                item.base_icms = 0;
                item.total_icms = 0;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else if (csosn === "201") {
                item.base_icms = 0;
                item.total_icms = 0;
                item.base_icms_sub = this.calculaBCST(index);
                item.total_icms_sub = this.calculaICMSST(index);
                this.calcularFCP(0, item.base_icms_sub, index);
              } else if (csosn === "202") {
                item.base_icms = 0;
                item.total_icms = 0;
                item.base_icms_sub = this.calculaBCST(index);
                item.total_icms_sub = this.calculaICMSST(index);
                this.calcularFCP(0, item.base_icms_sub, index);
              } else if (csosn === "500") {
                item.base_icms = 0;
                item.total_icms = 0;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else if (csosn === "900") {
                if (this.configuracao.st_90 === "1") {
                  item.base_icms = item.total;
                  item.total_icms = (item.base_icms * item.icms) / 100;
                } else {
                  item.base_icms = 0;
                  item.total_icms = 0;
                }
                item.base_icms_sub = this.calculaBCST(index);
                item.total_icms_sub = this.calculaICMSST(index);
                this.calcularFCP(0, item.base_icms_sub, index);
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              }
            }
          } else {
            if (item.st !== null && item.st !== "" && item.st.length === 3) {
              let st = item.st.substring(1, 3);
              if (st === "00") {
                if (this.configuracao.st_00 === "1") {
                  if (
                    this.configuracao.utilizar_formula_bc_icms &&
                    this.configuracao.utilizar_formula_bc_icms === "1"
                  ) {
                    item.base_icms = this.calculaBCICMS(index);
                    item.total_icms = this.calculaValorICMS(index);
                  } else {
                    item.base_icms = item.total;
                    item.total_icms = (item.base_icms * item.icms) / 100;
                  }
                  item.base_icms_sub = 0;
                  item.total_icms_sub = 0;
                } else {
                  item.base_icms = 0;
                  item.total_icms = 0;
                }
                this.calcularFCP(item.base_icms, item.base_icms_sub, index);
              } else if (st === "10") {
                if (this.configuracao.st_10 === "1") {
                  if (
                    this.configuracao.utilizar_formula_bc_icms &&
                    this.configuracao.utilizar_formula_bc_icms === "1"
                  ) {
                    item.base_icms = this.calculaBCICMS(index);
                    item.total_icms = this.calculaValorICMS(index);
                  } else {
                    item.base_icms = item.total;
                    item.total_icms = (item.base_icms * item.icms) / 100;
                  }
                  item.base_icms_sub = this.calculaBCST(index);
                  item.total_icms_sub = this.calculaICMSST(index);
                } else {
                  item.base_icms = 0;
                  item.total_icms = 0;
                }
                this.calcularFCP(item.base_icms, item.base_icms_sub, index);
              } else if (st === "20") {
                if (this.configuracao.st_20 === "1") {
                  if (
                    this.configuracao.utilizar_formula_bc_icms &&
                    this.configuracao.utilizar_formula_bc_icms === "1"
                  ) {
                    item.base_icms = this.calculaBCICMS(index);
                    item.total_icms = this.calculaValorICMS(index);
                  } else {
                    item.base_icms =
                      item.total - (item.total * item.reducao) / 100;
                    item.total_icms = (item.base_icms * item.icms) / 100;
                  }
                  item.base_icms_sub = 0;
                  item.total_icms_sub = 0;
                } else {
                  item.base_icms = 0;
                  item.total_icms = 0;
                }
                this.calcularFCP(item.base_icms, item.base_icms_sub, index);
              } else if (st === "30") {
                if (this.configuracao.st_30 === "1") {
                  if (
                    this.configuracao.utilizar_formula_bc_icms &&
                    this.configuracao.utilizar_formula_bc_icms === "1"
                  ) {
                    item.base_icms = this.calculaBCICMS(index);
                    item.total_icms = this.calculaValorICMS(index);
                  } else {
                    item.base_icms = item.total;
                    item.total_icms = (item.base_icms * item.icms) / 100;
                  }
                  item.base_icms_sub = this.calculaBCST(index);
                  item.total_icms_sub = this.calculaICMSST(index);
                } else {
                  item.base_icms = 0;
                  item.total_icms = 0;
                }
                this.calcularFCP(item.base_icms, item.base_icms_sub, index);
              } else if (st === "40") {
                if (this.configuracao.st_40 === "1") {
                  if (
                    this.configuracao.utilizar_formula_bc_icms &&
                    this.configuracao.utilizar_formula_bc_icms === "1"
                  ) {
                    item.base_icms = this.calculaBCICMS(index);
                    item.total_icms = this.calculaValorICMS(index);
                  } else {
                    item.base_icms =
                      item.total - (item.total * item.reducao) / 100;
                    item.total_icms = (item.base_icms * item.icms) / 100;
                  }
                  item.base_icms_sub = 0;
                  item.total_icms_sub = 0;
                } else {
                  item.base_icms = 0;
                  item.total_icms = 0;
                }
                this.calcularFCP(0, 0, index);
              } else if (st === "41") {
                if (this.configuracao.st_41 === "1") {
                  if (
                    this.configuracao.utilizar_formula_bc_icms &&
                    this.configuracao.utilizar_formula_bc_icms === "1"
                  ) {
                    item.base_icms = this.calculaBCICMS(index);
                    item.total_icms = this.calculaValorICMS(index);
                  } else {
                    item.base_icms =
                      item.total - (item.total * item.reducao) / 100;
                    item.total_icms = (item.base_icms * item.icms) / 100;
                  }
                  item.base_icms_sub = 0;
                  item.total_icms_sub = 0;
                } else {
                  item.base_icms = 0;
                  item.total_icms = 0;
                }
                this.calcularFCP(0, 0, index);
              } else if (st === "50") {
                if (this.configuracao.st_50 === "1") {
                  if (
                    this.configuracao.utilizar_formula_bc_icms &&
                    this.configuracao.utilizar_formula_bc_icms === "1"
                  ) {
                    item.base_icms = this.calculaBCICMS(index);
                    item.total_icms = this.calculaValorICMS(index);
                  } else {
                    item.base_icms =
                      item.total - (item.total * item.reducao) / 100;
                    item.total_icms = (item.base_icms * item.icms) / 100;
                  }
                  item.base_icms_sub = 0;
                  item.total_icms_sub = 0;
                } else {
                  item.base_icms = 0;
                  item.total_icms = 0;
                }
                this.calcularFCP(0, 0, index);
              } else if (st === "51") {
                if (this.configuracao.st_51 === "1") {
                  if (
                    this.configuracao.utilizar_formula_bc_icms &&
                    this.configuracao.utilizar_formula_bc_icms === "1"
                  ) {
                    item.base_icms = this.calculaBCICMS(index);
                    item.total_icms = this.calculaValorICMS(index);
                  } else {
                    item.base_icms =
                      item.total - (item.total * item.reducao) / 100;
                    item.total_icms = (item.base_icms * item.icms) / 100;
                  }
                  item.base_icms_sub = 0;
                  item.total_icms_sub = 0;
                } else {
                  item.base_icms = 0;
                  item.total_icms = 0;
                }
                this.calcularFCP(item.base_icms, item.base_icms_sub, index);
              } else if (st === "60") {
                if (this.configuracao.st_60 === "1") {
                  if (
                    this.configuracao.utilizar_formula_bc_icms &&
                    this.configuracao.utilizar_formula_bc_icms === "1"
                  ) {
                    item.base_icms = this.calculaBCICMS(index);
                    item.total_icms = this.calculaValorICMS(index);
                  } else {
                    item.base_icms =
                      item.total - (item.total * item.reducao) / 100;
                    item.total_icms = (item.base_icms * item.icms) / 100;
                  }
                  item.base_icms_sub = 0;
                  item.total_icms_sub = 0;
                } else {
                  item.base_icms = 0;
                  item.total_icms = 0;
                  item.base_icms_sub = 0;
                  item.total_icms_sub = 0;
                }
                this.calcularFCP(item.base_icms, item.base_icms_sub, index);
              } else if (st === "70") {
                if (this.configuracao.st_70 === "1") {
                  if (
                    this.configuracao.utilizar_formula_bc_icms &&
                    this.configuracao.utilizar_formula_bc_icms === "1"
                  ) {
                    item.base_icms = this.calculaBCICMS(index);
                    item.total_icms = this.calculaValorICMS(index);
                  } else {
                    item.base_icms =
                      item.total - (item.total * item.reducao) / 100;
                    item.total_icms = (item.base_icms * item.icms) / 100;
                  }
                  item.base_icms_sub = this.calculaBCST(index);
                  item.total_icms_sub = this.calculaICMSST(index);
                } else {
                  item.base_icms = 0;
                  item.total_icms = 0;
                }
                this.calcularFCP(item.base_icms, item.base_icms_sub, index);
              } else if (st === "90") {
                if (this.configuracao.st_90 === "1") {
                  if (
                    this.configuracao.utilizar_formula_bc_icms &&
                    this.configuracao.utilizar_formula_bc_icms === "1"
                  ) {
                    item.base_icms = this.calculaBCICMS(index);
                    item.total_icms = this.calculaValorICMS(index);
                  } else {
                    item.base_icms =
                      item.total - (item.total * item.reducao) / 100;
                    item.total_icms = (item.base_icms * item.icms) / 100;
                  }
                  item.base_icms_sub = this.calculaBCST(index);
                  item.total_icms_sub = this.calculaICMSST(index);
                } else {
                  item.base_icms = 0;
                  item.total_icms = 0;
                }
                this.calcularFCP(item.base_icms, item.base_icms_sub, index);
              }
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    calcularFCP(base, base_st, index) {
      var item = this.faturamento.FaturamentoItem[index];
      try {
        if (item.p_fcp && item.p_fcp_st) {
          item.v_fcp = parseFloat((base * item.p_fcp) / 100).toFixed(2);
          item.v_fcp_st = parseFloat((base * item.p_fcp_st) / 100).toFixed(2);
        } else {
          item.v_fcp = 0;
          item.v_fcp_st = 0;
        }
      } catch (error) {
        console.log(error);
      }
    },

    calculaBCST(index) {
      try {
        if (this.camposLivres === false) {
          var item = this.faturamento.FaturamentoItem[index];
          var VALOR_BASE_CALCULO_ICMS = item.base_icms;
          var ALIQ_ICMS = item.icms;
          var VALOR_ICMS = item.total_icms;
          var VALOR_TOTAL_PRODUTOS = this.faturamento.total_produtos;
          var VALOR_TOTAL_NOTA = this.faturamento.total;
          var MVA = item.mva;
          var VALOR_UNITARIO = item.preco;
          var QTD = item.qtd;
          var DESCONTO = item.desconto;
          var ACRESCIMO = item.acrescimo;
          var VALOR_TOTAL_ITEM = item.total;
          var BASE_CALCULO_ICMS_SUBSTITUICAO = item.base_icms_sub;
          var VALOR_ICMS_SUBSTITUICAO = item.total_icms_sub;
          var VALOR_IPI = item.ipi;
          var ALIQI = item.aliqi;
          var REDUCAO = item.reducao;
          var VALOR_FRETE = item.valor_frete;
          var VALOR_OUTRAS = item.valor_outras;

          var formula = this.configuracao.formula_basecalculo;

          if (formula.toString().includes("VALOR_BASE_CALCULO_ICMS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_BASE_CALCULO_ICMS", VALOR_BASE_CALCULO_ICMS);
          }

          if (formula.toString().includes("ALIQ_ICMS")) {
            formula = formula.toString().replaceAll("ALIQ_ICMS", ALIQ_ICMS);
          }

          if (formula.toString().includes("VALOR_ICMS")) {
            formula = formula.toString().replaceAll("VALOR_ICMS", VALOR_ICMS);
          }

          if (formula.toString().includes("VALOR_TOTAL_PRODUTOS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_PRODUTOS", VALOR_TOTAL_PRODUTOS);
          }

          if (formula.toString().includes("VALOR_TOTAL_NOTA")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_NOTA", VALOR_TOTAL_NOTA);
          }

          if (formula.toString().includes("MVA")) {
            formula = formula.toString().replaceAll("MVA", MVA);
          }

          if (formula.toString().includes("VALOR_UNITARIO")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_UNITARIO", VALOR_UNITARIO);
          }

          if (formula.toString().includes("QTD")) {
            formula = formula.toString().replaceAll("QTD", QTD);
          }

          if (formula.toString().includes("DESCONTO")) {
            formula = formula.toString().replaceAll("DESCONTO", DESCONTO);
          }

          if (formula.toString().includes("ACRESCIMO")) {
            formula = formula.toString().replaceAll("ACRESCIMO", ACRESCIMO);
          }

          if (formula.toString().includes("VALOR_TOTAL_ITEM")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_ITEM", VALOR_TOTAL_ITEM);
          }

          if (formula.toString().includes("BASE_CALCULO_ICMS_SUBSTITUICAO")) {
            formula = formula
              .toString()
              .replaceAll(
                "BASE_CALCULO_ICMS_SUBSTITUICAO",
                BASE_CALCULO_ICMS_SUBSTITUICAO
              );
          }

          if (formula.toString().includes("VALOR_ICMS_SUBSTITUICAO")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_ICMS_SUBSTITUICAO", VALOR_ICMS_SUBSTITUICAO);
          }

          if (formula.toString().includes("VALOR_IPI")) {
            formula = formula.toString().replaceAll("VALOR_IPI", VALOR_IPI);
          }

          if (formula.toString().includes("ALIQI")) {
            formula = formula.toString().replaceAll("ALIQI", ALIQI);
          }

          if (formula.toString().includes("VALOR_REDUCAO")) {
            formula = formula.toString().replaceAll("VALOR_REDUCAO", REDUCAO);
          }

          if (formula.toString().includes("VALOR_FRETE")) {
            formula = formula.toString().replaceAll("VALOR_FRETE", VALOR_FRETE);
          }

          if (formula.toString().includes("VALOR_OUTRAS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_OUTRAS", VALOR_OUTRAS);
          }

          formula = formula.toString().replaceAll(" ", "").trim();

          var resultado = math.evaluate(formula);

          return resultado;
        }
      } catch (error) {
        console.log(error);
        return 0;
      }
    },

    calculaICMSST(index) {
      try {
        if (this.camposLivres === false) {
          var item = this.faturamento.FaturamentoItem[index];
          var VALOR_BASE_CALCULO_ICMS = item.base_icms;
          var ALIQ_ICMS = item.icms;
          var VALOR_ICMS = item.total_icms;
          var VALOR_TOTAL_PRODUTOS = this.faturamento.total_produtos;
          var VALOR_TOTAL_NOTA = this.faturamento.total;
          var MVA = item.mva;
          var VALOR_UNITARIO = item.preco;
          var QTD = item.qtd;
          var DESCONTO = item.desconto;
          var ACRESCIMO = item.acrescimo;
          var VALOR_TOTAL_ITEM = item.total;
          var BASE_CALCULO_ICMS_SUBSTITUICAO = item.base_icms_sub;
          var VALOR_ICMS_SUBSTITUICAO = item.total_icms_sub;
          var VALOR_IPI = item.ipi;
          var ALIQI = item.aliqi;
          var REDUCAO = item.reducao;
          var VALOR_FRETE = item.valor_frete;
          var VALOR_OUTRAS = item.valor_outras;

          var formula = this.configuracao.formula_icms_sub;

          if (formula.toString().includes("VALOR_BASE_CALCULO_ICMS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_BASE_CALCULO_ICMS", VALOR_BASE_CALCULO_ICMS);
          }

          if (formula.toString().includes("ALIQ_ICMS")) {
            formula = formula.toString().replaceAll("ALIQ_ICMS", ALIQ_ICMS);
          }

          if (formula.toString().includes("VALOR_ICMS")) {
            formula = formula.toString().replaceAll("VALOR_ICMS", VALOR_ICMS);
          }

          if (formula.toString().includes("VALOR_TOTAL_PRODUTOS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_PRODUTOS", VALOR_TOTAL_PRODUTOS);
          }

          if (formula.toString().includes("VALOR_TOTAL_NOTA")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_NOTA", VALOR_TOTAL_NOTA);
          }

          if (formula.toString().includes("MVA")) {
            formula = formula.toString().replaceAll("MVA", MVA);
          }

          if (formula.toString().includes("VALOR_UNITARIO")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_UNITARIO", VALOR_UNITARIO);
          }

          if (formula.toString().includes("QTD")) {
            formula = formula.toString().replaceAll("QTD", QTD);
          }

          if (formula.toString().includes("DESCONTO")) {
            formula = formula.toString().replaceAll("DESCONTO", DESCONTO);
          }

          if (formula.toString().includes("ACRESCIMO")) {
            formula = formula.toString().replaceAll("ACRESCIMO", ACRESCIMO);
          }

          if (formula.toString().includes("VALOR_TOTAL_ITEM")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_ITEM", VALOR_TOTAL_ITEM);
          }

          if (formula.toString().includes("BASE_CALCULO_ICMS_SUBSTITUICAO")) {
            formula = formula
              .toString()
              .replaceAll(
                "BASE_CALCULO_ICMS_SUBSTITUICAO",
                BASE_CALCULO_ICMS_SUBSTITUICAO
              );
          }

          if (formula.toString().includes("VALOR_ICMS_SUBSTITUICAO")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_ICMS_SUBSTITUICAO", VALOR_ICMS_SUBSTITUICAO);
          }

          if (formula.toString().includes("VALOR_IPI")) {
            formula = formula.toString().replaceAll("VALOR_IPI", VALOR_IPI);
          }

          if (formula.toString().includes("ALIQI")) {
            formula = formula.toString().replaceAll("ALIQI", ALIQI);
          }

          if (formula.toString().includes("VALOR_REDUCAO")) {
            formula = formula.toString().replaceAll("VALOR_REDUCAO", REDUCAO);
          }

          if (formula.toString().includes("VALOR_FRETE")) {
            formula = formula.toString().replaceAll("VALOR_FRETE", VALOR_FRETE);
          }

          if (formula.toString().includes("VALOR_OUTRAS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_OUTRAS", VALOR_OUTRAS);
          }

          formula = formula.toString().replaceAll(" ", "").trim();

          var resultado = math.evaluate(formula);

          return resultado;
        }
      } catch (error) {
        console.log(error);
        return 0;
      }
    },

    calculaBCICMS(index) {
      try {
        if (this.camposLivres === false) {
          var item = this.faturamento.FaturamentoItem[index];
          var VALOR_BASE_CALCULO_ICMS = item.base_icms;
          var ALIQ_ICMS = item.icms;
          var VALOR_ICMS = item.total_icms;
          var VALOR_TOTAL_PRODUTOS = this.faturamento.total_produtos;
          var VALOR_TOTAL_NOTA = this.faturamento.total;
          var MVA = item.mva;
          var VALOR_UNITARIO = item.preco;
          var QTD = item.qtd;
          var DESCONTO = item.desconto;
          var ACRESCIMO = item.acrescimo;
          var VALOR_TOTAL_ITEM = item.total;
          var BASE_CALCULO_ICMS_SUBSTITUICAO = item.base_icms_sub;
          var VALOR_ICMS_SUBSTITUICAO = item.total_icms_sub;
          var VALOR_IPI = item.ipi;
          var ALIQI = item.aliqi;
          var REDUCAO = item.reducao;
          var VALOR_FRETE = item.valor_frete;
          var VALOR_OUTRAS = item.valor_outras;

          var formula = this.configuracao.formula_basecalculo_icms;

          if (formula.toString().includes("VALOR_BASE_CALCULO_ICMS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_BASE_CALCULO_ICMS", VALOR_BASE_CALCULO_ICMS);
          }

          if (formula.toString().includes("ALIQ_ICMS")) {
            formula = formula.toString().replaceAll("ALIQ_ICMS", ALIQ_ICMS);
          }

          if (formula.toString().includes("VALOR_ICMS")) {
            formula = formula.toString().replaceAll("VALOR_ICMS", VALOR_ICMS);
          }

          if (formula.toString().includes("VALOR_TOTAL_PRODUTOS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_PRODUTOS", VALOR_TOTAL_PRODUTOS);
          }

          if (formula.toString().includes("VALOR_TOTAL_NOTA")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_NOTA", VALOR_TOTAL_NOTA);
          }

          if (formula.toString().includes("MVA")) {
            formula = formula.toString().replaceAll("MVA", MVA);
          }

          if (formula.toString().includes("VALOR_UNITARIO")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_UNITARIO", VALOR_UNITARIO);
          }

          if (formula.toString().includes("QTD")) {
            formula = formula.toString().replaceAll("QTD", QTD);
          }

          if (formula.toString().includes("DESCONTO")) {
            formula = formula.toString().replaceAll("DESCONTO", DESCONTO);
          }

          if (formula.toString().includes("ACRESCIMO")) {
            formula = formula.toString().replaceAll("ACRESCIMO", ACRESCIMO);
          }

          if (formula.toString().includes("VALOR_TOTAL_ITEM")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_ITEM", VALOR_TOTAL_ITEM);
          }

          if (formula.toString().includes("BASE_CALCULO_ICMS_SUBSTITUICAO")) {
            formula = formula
              .toString()
              .replaceAll(
                "BASE_CALCULO_ICMS_SUBSTITUICAO",
                BASE_CALCULO_ICMS_SUBSTITUICAO
              );
          }

          if (formula.toString().includes("VALOR_ICMS_SUBSTITUICAO")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_ICMS_SUBSTITUICAO", VALOR_ICMS_SUBSTITUICAO);
          }

          if (formula.toString().includes("VALOR_IPI")) {
            formula = formula.toString().replaceAll("VALOR_IPI", VALOR_IPI);
          }

          if (formula.toString().includes("ALIQI")) {
            formula = formula.toString().replaceAll("ALIQI", ALIQI);
          }

          if (formula.toString().includes("VALOR_REDUCAO")) {
            formula = formula.toString().replaceAll("VALOR_REDUCAO", REDUCAO);
          }

          if (formula.toString().includes("VALOR_FRETE")) {
            formula = formula.toString().replaceAll("VALOR_FRETE", VALOR_FRETE);
          }

          if (formula.toString().includes("VALOR_OUTRAS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_OUTRAS", VALOR_OUTRAS);
          }

          formula = formula.toString().replaceAll(" ", "").trim();

          var resultado = math.evaluate(formula);

          return resultado;
        }
      } catch (error) {
        console.log(error);
        return 0;
      }
    },

    calculaValorICMS(index) {
      try {
        if (this.camposLivres === false) {
          var item = this.faturamento.FaturamentoItem[index];
          var VALOR_BASE_CALCULO_ICMS = item.base_icms;
          var ALIQ_ICMS = item.icms;
          var VALOR_ICMS = item.total_icms;
          var VALOR_TOTAL_PRODUTOS = this.faturamento.total_produtos;
          var VALOR_TOTAL_NOTA = this.faturamento.total;
          var MVA = item.mva;
          var VALOR_UNITARIO = item.preco;
          var QTD = item.qtd;
          var DESCONTO = item.desconto;
          var ACRESCIMO = item.acrescimo;
          var VALOR_TOTAL_ITEM = item.total;
          var BASE_CALCULO_ICMS_SUBSTITUICAO = item.base_icms_sub;
          var VALOR_ICMS_SUBSTITUICAO = item.total_icms_sub;
          var VALOR_IPI = item.ipi;
          var ALIQI = item.aliqi;
          var REDUCAO = item.reducao;
          var VALOR_FRETE = item.valor_frete;
          var VALOR_OUTRAS = item.valor_outras;

          var formula = this.configuracao.formula_valor_icms;

          if (formula.toString().includes("VALOR_BASE_CALCULO_ICMS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_BASE_CALCULO_ICMS", VALOR_BASE_CALCULO_ICMS);
          }

          if (formula.toString().includes("ALIQ_ICMS")) {
            formula = formula.toString().replaceAll("ALIQ_ICMS", ALIQ_ICMS);
          }

          if (formula.toString().includes("VALOR_ICMS")) {
            formula = formula.toString().replaceAll("VALOR_ICMS", VALOR_ICMS);
          }

          if (formula.toString().includes("VALOR_TOTAL_PRODUTOS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_PRODUTOS", VALOR_TOTAL_PRODUTOS);
          }

          if (formula.toString().includes("VALOR_TOTAL_NOTA")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_NOTA", VALOR_TOTAL_NOTA);
          }

          if (formula.toString().includes("MVA")) {
            formula = formula.toString().replaceAll("MVA", MVA);
          }

          if (formula.toString().includes("VALOR_UNITARIO")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_UNITARIO", VALOR_UNITARIO);
          }

          if (formula.toString().includes("QTD")) {
            formula = formula.toString().replaceAll("QTD", QTD);
          }

          if (formula.toString().includes("DESCONTO")) {
            formula = formula.toString().replaceAll("DESCONTO", DESCONTO);
          }

          if (formula.toString().includes("ACRESCIMO")) {
            formula = formula.toString().replaceAll("ACRESCIMO", ACRESCIMO);
          }

          if (formula.toString().includes("VALOR_TOTAL_ITEM")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_ITEM", VALOR_TOTAL_ITEM);
          }

          if (formula.toString().includes("BASE_CALCULO_ICMS_SUBSTITUICAO")) {
            formula = formula
              .toString()
              .replaceAll(
                "BASE_CALCULO_ICMS_SUBSTITUICAO",
                BASE_CALCULO_ICMS_SUBSTITUICAO
              );
          }

          if (formula.toString().includes("VALOR_ICMS_SUBSTITUICAO")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_ICMS_SUBSTITUICAO", VALOR_ICMS_SUBSTITUICAO);
          }

          if (formula.toString().includes("VALOR_IPI")) {
            formula = formula.toString().replaceAll("VALOR_IPI", VALOR_IPI);
          }

          if (formula.toString().includes("ALIQI")) {
            formula = formula.toString().replaceAll("ALIQI", ALIQI);
          }

          if (formula.toString().includes("VALOR_REDUCAO")) {
            formula = formula.toString().replaceAll("VALOR_REDUCAO", REDUCAO);
          }

          if (formula.toString().includes("VALOR_FRETE")) {
            formula = formula.toString().replaceAll("VALOR_FRETE", VALOR_FRETE);
          }

          if (formula.toString().includes("VALOR_OUTRAS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_OUTRAS", VALOR_OUTRAS);
          }

          formula = formula.toString().replaceAll(" ", "").trim();

          var resultado = math.evaluate(formula);

          return resultado;
        }
      } catch (error) {
        console.log(error);
        return 0;
      }
    },

    calculaBaseIPI(index) {
      try {
        if (this.camposLivres === false) {
          var item = this.faturamento.FaturamentoItem[index];
          var VALOR_BASE_CALCULO_ICMS = item.base_icms;
          var ALIQ_ICMS = item.icms;
          var VALOR_ICMS = item.total_icms;
          var VALOR_TOTAL_PRODUTOS = this.faturamento.total_produtos;
          var VALOR_TOTAL_NOTA = this.faturamento.total;
          var MVA = item.mva;
          var VALOR_UNITARIO = item.preco;
          var QTD = item.qtd;
          var DESCONTO = item.desconto;
          var ACRESCIMO = item.acrescimo;
          var VALOR_TOTAL_ITEM = item.total;
          var BASE_CALCULO_ICMS_SUBSTITUICAO = item.base_icms_sub;
          var VALOR_ICMS_SUBSTITUICAO = item.total_icms_sub;
          var VALOR_IPI = item.ipi;
          var ALIQI = item.aliqi;
          var REDUCAO = item.reducao;
          var VALOR_FRETE = item.valor_frete;
          var VALOR_OUTRAS = item.valor_outras;

          var formula = this.configuracao.formula_base_ipi;

          if (formula.toString().includes("VALOR_BASE_CALCULO_ICMS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_BASE_CALCULO_ICMS", VALOR_BASE_CALCULO_ICMS);
          }

          if (formula.toString().includes("ALIQ_ICMS")) {
            formula = formula.toString().replaceAll("ALIQ_ICMS", ALIQ_ICMS);
          }

          if (formula.toString().includes("VALOR_ICMS")) {
            formula = formula.toString().replaceAll("VALOR_ICMS", VALOR_ICMS);
          }

          if (formula.toString().includes("VALOR_TOTAL_PRODUTOS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_PRODUTOS", VALOR_TOTAL_PRODUTOS);
          }

          if (formula.toString().includes("VALOR_TOTAL_NOTA")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_NOTA", VALOR_TOTAL_NOTA);
          }

          if (formula.toString().includes("MVA")) {
            formula = formula.toString().replaceAll("MVA", MVA);
          }

          if (formula.toString().includes("VALOR_UNITARIO")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_UNITARIO", VALOR_UNITARIO);
          }

          if (formula.toString().includes("QTD")) {
            formula = formula.toString().replaceAll("QTD", QTD);
          }

          if (formula.toString().includes("DESCONTO")) {
            formula = formula.toString().replaceAll("DESCONTO", DESCONTO);
          }

          if (formula.toString().includes("ACRESCIMO")) {
            formula = formula.toString().replaceAll("ACRESCIMO", ACRESCIMO);
          }

          if (formula.toString().includes("VALOR_TOTAL_ITEM")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_ITEM", VALOR_TOTAL_ITEM);
          }

          if (formula.toString().includes("BASE_CALCULO_ICMS_SUBSTITUICAO")) {
            formula = formula
              .toString()
              .replaceAll(
                "BASE_CALCULO_ICMS_SUBSTITUICAO",
                BASE_CALCULO_ICMS_SUBSTITUICAO
              );
          }

          if (formula.toString().includes("VALOR_ICMS_SUBSTITUICAO")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_ICMS_SUBSTITUICAO", VALOR_ICMS_SUBSTITUICAO);
          }

          if (formula.toString().includes("VALOR_IPI")) {
            formula = formula.toString().replaceAll("VALOR_IPI", VALOR_IPI);
          }

          if (formula.toString().includes("ALIQI")) {
            formula = formula.toString().replaceAll("ALIQI", ALIQI);
          }

          if (formula.toString().includes("VALOR_REDUCAO")) {
            formula = formula.toString().replaceAll("VALOR_REDUCAO", REDUCAO);
          }

          if (formula.toString().includes("VALOR_FRETE")) {
            formula = formula.toString().replaceAll("VALOR_FRETE", VALOR_FRETE);
          }

          if (formula.toString().includes("VALOR_OUTRAS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_OUTRAS", VALOR_OUTRAS);
          }

          formula = formula.toString().replaceAll(" ", "").trim();

          var resultado = math.evaluate(formula);
          return resultado;
        }
      } catch (error) {
        console.log(error);
        return 0;
      }
    },

    calculaBasePIS(index) {
      try {
        if (this.camposLivres === false) {
          var item = this.faturamento.FaturamentoItem[index];
          var VALOR_BASE_CALCULO_ICMS = item.base_icms;
          var ALIQ_ICMS = item.icms;
          var VALOR_ICMS = item.total_icms;
          var VALOR_TOTAL_PRODUTOS = this.faturamento.total_produtos;
          var VALOR_TOTAL_NOTA = this.faturamento.total;
          var MVA = item.mva;
          var VALOR_UNITARIO = item.preco;
          var QTD = item.qtd;
          var DESCONTO = item.desconto;
          var ACRESCIMO = item.acrescimo;
          var VALOR_TOTAL_ITEM = item.total;
          var BASE_CALCULO_ICMS_SUBSTITUICAO = item.base_icms_sub;
          var VALOR_ICMS_SUBSTITUICAO = item.total_icms_sub;
          var VALOR_IPI = item.ipi;
          var ALIQI = item.aliqi;
          var REDUCAO = item.reducao;
          var VALOR_FRETE = item.valor_frete;
          var VALOR_OUTRAS = item.valor_outras;

          var formula = this.configuracao.formula_base_pis;

          if (formula.toString().includes("VALOR_BASE_CALCULO_ICMS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_BASE_CALCULO_ICMS", VALOR_BASE_CALCULO_ICMS);
          }

          if (formula.toString().includes("ALIQ_ICMS")) {
            formula = formula.toString().replaceAll("ALIQ_ICMS", ALIQ_ICMS);
          }

          if (formula.toString().includes("VALOR_ICMS")) {
            formula = formula.toString().replaceAll("VALOR_ICMS", VALOR_ICMS);
          }

          if (formula.toString().includes("VALOR_TOTAL_PRODUTOS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_PRODUTOS", VALOR_TOTAL_PRODUTOS);
          }

          if (formula.toString().includes("VALOR_TOTAL_NOTA")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_NOTA", VALOR_TOTAL_NOTA);
          }

          if (formula.toString().includes("MVA")) {
            formula = formula.toString().replaceAll("MVA", MVA);
          }

          if (formula.toString().includes("VALOR_UNITARIO")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_UNITARIO", VALOR_UNITARIO);
          }

          if (formula.toString().includes("QTD")) {
            formula = formula.toString().replaceAll("QTD", QTD);
          }

          if (formula.toString().includes("DESCONTO")) {
            formula = formula.toString().replaceAll("DESCONTO", DESCONTO);
          }

          if (formula.toString().includes("ACRESCIMO")) {
            formula = formula.toString().replaceAll("ACRESCIMO", ACRESCIMO);
          }

          if (formula.toString().includes("VALOR_TOTAL_ITEM")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_ITEM", VALOR_TOTAL_ITEM);
          }

          if (formula.toString().includes("BASE_CALCULO_ICMS_SUBSTITUICAO")) {
            formula = formula
              .toString()
              .replaceAll(
                "BASE_CALCULO_ICMS_SUBSTITUICAO",
                BASE_CALCULO_ICMS_SUBSTITUICAO
              );
          }

          if (formula.toString().includes("VALOR_ICMS_SUBSTITUICAO")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_ICMS_SUBSTITUICAO", VALOR_ICMS_SUBSTITUICAO);
          }

          if (formula.toString().includes("VALOR_IPI")) {
            formula = formula.toString().replaceAll("VALOR_IPI", VALOR_IPI);
          }

          if (formula.toString().includes("ALIQI")) {
            formula = formula.toString().replaceAll("ALIQI", ALIQI);
          }

          if (formula.toString().includes("VALOR_REDUCAO")) {
            formula = formula.toString().replaceAll("VALOR_REDUCAO", REDUCAO);
          }

          if (formula.toString().includes("VALOR_FRETE")) {
            formula = formula.toString().replaceAll("VALOR_FRETE", VALOR_FRETE);
          }

          if (formula.toString().includes("VALOR_OUTRAS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_OUTRAS", VALOR_OUTRAS);
          }

          formula = formula.toString().replaceAll(" ", "").trim();

          var resultado = math.evaluate(formula);

          return resultado;
        }
      } catch (error) {
        console.log(error);
        return 0;
      }
    },

    calculaBaseCOFINS(index) {
      try {
        if (this.camposLivres === false) {
          var item = this.faturamento.FaturamentoItem[index];
          var VALOR_BASE_CALCULO_ICMS = item.base_icms;
          var ALIQ_ICMS = item.icms;
          var VALOR_ICMS = item.total_icms;
          var VALOR_TOTAL_PRODUTOS = this.faturamento.total_produtos;
          var VALOR_TOTAL_NOTA = this.faturamento.total;
          var MVA = item.mva;
          var VALOR_UNITARIO = item.preco;
          var QTD = item.qtd;
          var DESCONTO = item.desconto;
          var ACRESCIMO = item.acrescimo;
          var VALOR_TOTAL_ITEM = item.total;
          var BASE_CALCULO_ICMS_SUBSTITUICAO = item.base_icms_sub;
          var VALOR_ICMS_SUBSTITUICAO = item.total_icms_sub;
          var VALOR_IPI = item.ipi;
          var ALIQI = item.aliqi;
          var REDUCAO = item.reducao;
          var VALOR_FRETE = item.valor_frete;
          var VALOR_OUTRAS = item.valor_outras;

          var formula = this.configuracao.formula_base_cofins;

          if (formula.toString().includes("VALOR_BASE_CALCULO_ICMS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_BASE_CALCULO_ICMS", VALOR_BASE_CALCULO_ICMS);
          }

          if (formula.toString().includes("ALIQ_ICMS")) {
            formula = formula.toString().replaceAll("ALIQ_ICMS", ALIQ_ICMS);
          }

          if (formula.toString().includes("VALOR_ICMS")) {
            formula = formula.toString().replaceAll("VALOR_ICMS", VALOR_ICMS);
          }

          if (formula.toString().includes("VALOR_TOTAL_PRODUTOS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_PRODUTOS", VALOR_TOTAL_PRODUTOS);
          }

          if (formula.toString().includes("VALOR_TOTAL_NOTA")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_NOTA", VALOR_TOTAL_NOTA);
          }

          if (formula.toString().includes("MVA")) {
            formula = formula.toString().replaceAll("MVA", MVA);
          }

          if (formula.toString().includes("VALOR_UNITARIO")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_UNITARIO", VALOR_UNITARIO);
          }

          if (formula.toString().includes("QTD")) {
            formula = formula.toString().replaceAll("QTD", QTD);
          }

          if (formula.toString().includes("DESCONTO")) {
            formula = formula.toString().replaceAll("DESCONTO", DESCONTO);
          }

          if (formula.toString().includes("ACRESCIMO")) {
            formula = formula.toString().replaceAll("ACRESCIMO", ACRESCIMO);
          }

          if (formula.toString().includes("VALOR_TOTAL_ITEM")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_TOTAL_ITEM", VALOR_TOTAL_ITEM);
          }

          if (formula.toString().includes("BASE_CALCULO_ICMS_SUBSTITUICAO")) {
            formula = formula
              .toString()
              .replaceAll(
                "BASE_CALCULO_ICMS_SUBSTITUICAO",
                BASE_CALCULO_ICMS_SUBSTITUICAO
              );
          }

          if (formula.toString().includes("VALOR_ICMS_SUBSTITUICAO")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_ICMS_SUBSTITUICAO", VALOR_ICMS_SUBSTITUICAO);
          }

          if (formula.toString().includes("VALOR_IPI")) {
            formula = formula.toString().replaceAll("VALOR_IPI", VALOR_IPI);
          }

          if (formula.toString().includes("ALIQI")) {
            formula = formula.toString().replaceAll("ALIQI", ALIQI);
          }

          if (formula.toString().includes("VALOR_REDUCAO")) {
            formula = formula.toString().replaceAll("VALOR_REDUCAO", REDUCAO);
          }

          if (formula.toString().includes("VALOR_FRETE")) {
            formula = formula.toString().replaceAll("VALOR_FRETE", VALOR_FRETE);
          }

          if (formula.toString().includes("VALOR_OUTRAS")) {
            formula = formula
              .toString()
              .replaceAll("VALOR_OUTRAS", VALOR_OUTRAS);
          }

          formula = formula.toString().replaceAll(" ", "").trim();

          var resultado = math.evaluate(formula);

          return resultado;
        }
      } catch (error) {
        console.log(error);
        return 0;
      }
    },

    modalTransportadoras(exibir) {
      this.exibirTransportadoras = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_transportadoras_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarTransportadoras");
          },
          /*close*/ () => {
            this.modalTransportadoras(false);
          }
        );
      }
    },

    async selecionarTransportadora(transportadora) {
      this.faturamento.id_transportadora = transportadora.id;

      if (!this.faturamento.Transportadora) {
        this.faturamento.Transportadora = JSON.parse(
          JSON.stringify(faturamentoInicializado.Transportadora)
        );
      }

      this.faturamento.Transportadora.nome = transportadora.nome;
      if (this.importacaoPedidoVenda === false) {
        toast.info("Transportadora / Entregador selecionado com sucesso!", {
          timeout: 2000,
        });
      }
    },

    modalMotoristas(exibir) {
      this.exibirMotoristas = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_motoristas_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarMotoristas");
          },
          /*close*/ () => {
            this.modalMotoristas(false);
          }
        );
      }
    },

    async selecionarMotorista(motorista) {
      this.faturamento.id_motorista = motorista.id;

      if (!this.faturamento.Motorista) {
        this.faturamento.Motorista = JSON.parse(
          JSON.stringify(faturamentoInicializado.Motorista)
        );
      }

      this.faturamento.Motorista.nome = motorista.nome;
      if (this.importacaoPedidoVenda === false) {
        toast.info("Motorista selecionado com sucesso!", {
          timeout: 2000,
        });
      }
    },

    modalVendedores(exibir) {
      this.exibirVendedores = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_vendedores_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarVendedores");
          },
          /*close*/ () => {
            this.modalVendedores(false);
          }
        );
      }
    },

    async selecionarVendedor(vendedor) {
      this.faturamento.id_vendedor = vendedor.id;

      if (!this.faturamento.Vendedor) {
        this.faturamento.Vendedor = JSON.parse(
          JSON.stringify(faturamentoInicializado.Vendedor)
        );
      }

      this.faturamento.Vendedor.nome = vendedor.nome;
      this.faturamento.comissao_per = vendedor.comissao;
      this.recalcularValores();
      if (this.importacaoPedidoVenda === false) {
        toast.info("Vendedor selecionado com sucesso!", {
          timeout: 2000,
        });
      }
    },

    async removerProduto(index) {
      await this.$swal.showQuestionAlert(
        "Deseja remover o item selecionado?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosGerais = {};
            this.isLoadingItens = true;

            this.faturamento.FaturamentoItem.splice(index, 1);
            toast.success("Produto removido com sucesso!", { timeout: 3000 });
            await this.recalcularValores();

            this.nextFocus("InclusaoRapida");
            this.isLoadingItens = false;
          }
        }
      );
    },

    modalEditarProdutoObservacoes(exibir) {
      this.exibirEditarProdutoObservacoes = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_produto_observacoes",
          /*open*/ () => {
            this.$utils.requestFocus("txtObservacaoProduto");
          },
          /*close*/ () => {
            this.modalEditarProdutoObservacoes(false);
          }
        );
      }
    },

    editarObservacoesProduto(index) {
      this.indexEdicaoFaturamentoItem = index;
      this.observacaoFaturamentoItem =
        this.faturamento.FaturamentoItem[index].observacao;
      this.modalEditarProdutoObservacoes(true);
    },

    confirmarObservacoesProduto(observacao) {
      this.faturamento.FaturamentoItem[
        this.indexEdicaoFaturamentoItem
      ].observacao = observacao;
      this.indexEdicaoFaturamentoItem = -1;
      this.modalEditarProdutoObservacoes(false);

      toast.info("Produto atualizado com sucesso!", {
        timeout: 2000,
      });
    },

    somaQtdProdutos() {
      if (this.faturamento.FaturamentoItem.length > 0) {
        return math.round(_.sumBy(this.faturamento.FaturamentoItem, "qtd"), 4);
      } else {
        return 0;
      }
    },

    async recalcularItensFaturamento() {
      await this.$swal.showQuestionAlert(
        "Deseja recalcular todos os itens do faturamento?",
        (alert) => {
          if (alert.isConfirmed) {
            this.recalcularValores();
          }
        }
      );
    },

    async adicionarProdutoFaturamento() {
      if (this.faturamento.FaturamentoItem.length > 0) {
        if (
          this.faturamento.FaturamentoItem[
            this.faturamento.FaturamentoItem.length - 1
          ].em_branco === undefined ||
          this.faturamento.FaturamentoItem[
            this.faturamento.FaturamentoItem.length - 1
          ].em_branco === false
        ) {
          this.adicionarProdutoEmBranco();
        }
      } else {
        this.adicionarProdutoEmBranco();
      }
    },

    async adicionarProdutoEmBranco() {
      var produto = {
        codigo: "",
        nome: "",
        und: "",
        qtd: 0,
        preco: 0,
        preco_custo: 0,
        cod_referencia: "",
        ProdutoTributacao: {
          aliqi: 0,
          icms: 0,
          mva: 0,
          reducao: 0,
          st: "",
          csosn: "",
          cfop: "",
        },
        em_branco: true,
      };
      this.addItemBranco = true;
      await this.preencheProdutoSelecionado(produto, true, 0);

      setTimeout(() => {
        var input = document.getElementById(
          `FaturamentoItem[${
            this.faturamento.FaturamentoItem.length - 1
          }]id_produto`
        );
        input.focus();
      }, 500);
      this.addItemBranco = false;
    },

    async adicionarProdutoCodigoGrid(index) {
      var codigo = this.faturamento.FaturamentoItem[index].Produto.codigo;
      var filterOdata = "";
      this.errosGerais = {};
      this.errosValidacao = [];
      if (codigo != "") {
        filterOdata =
          "&$filter=(codigo eq " + codigo + " or ean eq '" + codigo + "')";
        if (filterOdata != "") {
          try {
            var retOdata = await this.$store.dispatch(
              "produto/getProdutoOData",
              "?$expand=Adicional($expand=AdicionalGrupo($expand=AdicionalGrupoItem)),ProdutoTributacao" +
                filterOdata
            );
            if (retOdata.value !== null && retOdata.value.length > 0) {
              this.faturamento.FaturamentoItem.splice(index, 1);
              var produto = retOdata.value[0];
              this.selecionarProduto(produto);
            } else {
              await this.$swal.showInvalidAlert(
                "Nenhum Produto foi encontrado com o código informado!"
              );
            }
          } catch (error) {
            this.errosGerais = error;
          }
        } else {
          this.errosValidacao = {
            inclusaoRapida: "Verifique o código do produto",
          };
        }
      } else {
        this.errosValidacao = { inclusaoRapida: "Informe o código do produto" };
      }
    },

    async verificarCFOP(id, index) {
      try {
        this.isLoadingItens = true;
        var item = this.faturamento.FaturamentoItem[index];
        if (item && item.cfop !== "") {
          var retOdata = await this.$store.dispatch(
            "cfop/getCfopOData",
            "?$select=codigo&$filter=codigo eq " + item.cfop
          );
          if (retOdata.value !== null && retOdata.value.length > 0) {
            if (this.errosValidacao[id] !== undefined) {
              delete this.errosValidacao[id];
            }
          } else {
            if (this.errosValidacao[id] === undefined) {
              this.errosValidacao[id] = {};
            }
            this.errosValidacao[id] = "CFOP Inválido";
            await this.$swal.showInvalidAlert("CFOP inválido", (alert) => {
              this.focusOnElement(id);
            });
          }
        } else {
          if (this.errosValidacao[id] === undefined) {
            this.errosValidacao[id] = {};
          }
          this.errosValidacao[id] = "CFOP Inválido";
          await this.$swal.showInvalidAlert("CFOP inválido", (alert) => {
            this.focusOnElement(id);
          });
        }
      } catch (error) {
        console.log(error);
      }
      this.isLoadingItens = false;

      if (!this.getErrorByID(id)) {
        this.user.User.Emitente.crt != 1
          ? this.nextFocus(`FaturamentoItem[${index}]st`)
          : this.nextFocus(`FaturamentoItem[${index}]csosn`);
      }
    },

    focusOnElement(id) {
      const input = document.getElementById(id);
      if (input) {
        input.focus();
      }
    },
    async verificarCST(id, index) {
      try {
        var item = this.faturamento.FaturamentoItem[index];
        if (item && item.st !== "") {
          let result = this.$utils.validarCST(item.st);
          if (result === true) {
            if (this.errosValidacao[id] !== undefined) {
              delete this.errosValidacao[id];
            }
          } else {
            if (this.errosValidacao[id] === undefined) {
              this.errosValidacao[id] = {};
            }
            this.errosValidacao[id] = "CST Inválida";
            await this.$swal.showInvalidAlert("CST Inválida", (alert) => {
              this.focusOnElement(id);
            });
          }
        } else {
          if (this.errosValidacao[id] === undefined) {
            this.errosValidacao[id] = {};
          }
          this.errosValidacao[id] = "CST Inválida";
          await this.$swal.showInvalidAlert("CST Inválida", (alert) => {
            this.focusOnElement(id);
          });
        }
      } catch (error) {
        console.log(error);
      }

      if (!this.getErrorByID(id)) {
        this.nextFocus(`FaturamentoItem[${index}]icms`);
      }
    },

    async verificarCSOSN(id, index) {
      try {
        var item = this.faturamento.FaturamentoItem[index];
        if (item && item.csosn !== "") {
          let result = this.$utils.validarCSOSN(item.csosn);
          if (result === true) {
            if (this.errosValidacao[id] !== undefined) {
              delete this.errosValidacao[id];
            }
          } else {
            if (this.errosValidacao[id] === undefined) {
              this.errosValidacao[id] = {};
            }
            this.errosValidacao[id] = "CSOSN Inválido";
            await this.$swal.showInvalidAlert("CSOSN Inválido", (alert) => {
              this.focusOnElement(id);
            });
          }
        } else {
          if (this.errosValidacao[id] === undefined) {
            this.errosValidacao[id] = {};
          }
          this.errosValidacao[id] = "CSOSN Inválido";
          await this.$swal.showInvalidAlert("CSOSN Inválido", (alert) => {
            this.focusOnElement(id);
          });
        }
      } catch (error) {
        console.log(error);
      }

      if (!this.getErrorByID(id)) {
        this.nextFocus(`FaturamentoItem[${index}]icms`);
      }
    },

    async retornarNaturezaCFOP(cfop) {
      let natureza = "";
      try {
        var retOdata = await this.$store.dispatch(
          "cfop/getCfopOData",
          "?$select=nome&$filter=codigo eq " + cfop
        );
        if (retOdata.value !== null && retOdata.value.length > 0) {
          natureza = retOdata.value[0].nome;
        }
      } catch (error) {
        console.log(error);
      }
      return natureza;
    },

    limparTransportadoraFaturamento() {
      this.faturamento.Transportadora = JSON.parse(
        JSON.stringify(faturamentoInicializado.Transportadora)
      );
      this.faturamento.id_transportadora = null;
    },

    limparMotoristaFaturamento() {
      this.faturamento.Motorista = null;
      this.faturamento.id_motorista = null;
    },

    adicionarPagamento(pagamento) {
      this.faturamento.FaturamentoPagamento.push(pagamento);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Pagamento adicionado com sucesso!", { timeout: 2000 });
      this.recalcularValores();
    },
    editarPagamento() {
      toast.success("Pagamento alterado com sucesso!", { timeout: 2000 });
      this.recalcularValores();
    },
    modalFaturamentoPagamento(exibir) {
      this.exibirFaturamentoPagamento = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_pagamento_editar",
          /*open*/ () => {
            this.$utils.requestFocus("txtValorPagamento");
          },
          /*close*/ () => {
            this.modalFaturamentoPagamento(false);
          }
        );
      }
    },
    async adicionarFaturamentoPagamento() {
      if (this.faturamento.total === 0) {
        await this.$swal.showInvalidAlert(
          "O valor total do faturamento está zerado!"
        );
      } else {
        this.indexFaturamentoPagamento = -1;
        this.modalFaturamentoPagamento(true);
      }
    },
    editarFaturamentoPagamento(index) {
      this.indexFaturamentoPagamento = index;
      this.modalFaturamentoPagamento(true);
    },
    async removerPagamento(id, index) {
      this.errosGerais = {};
      this.loadingPagamento = true;

      this.faturamento.FaturamentoPagamento.splice(index, 1);
      toast.success("Pagamento excluído com sucesso!", { timeout: 2000 });
      this.recalcularValores();

      this.loadingPagamento = false;
    },
    adicionarFaturamentoReceber() {
      if (this.faturamento.total === 0) {
        toast.info("O valor total está zerado!", { timeout: 3000 });
      } else {
        this.modalFaturamentoReceber(true);
      }
    },
    modalFaturamentoReceber(exibir) {
      this.exibirFaturamentoReceber = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_receber_editar",
          /*open*/ () => {
            this.$utils.requestFocus("txtQtdParcelas");
          },
          /*close*/ () => {
            this.modalFaturamentoReceber(false);
          }
        );
      }
    },
    confirmarParcelamento(condicao) {
      if (!this.faturamento.Condicao) {
        this.faturamento.Condicao = JSON.parse(
          JSON.stringify(faturamentoInicializado.Condicao)
        );
      }

      if (condicao != null) {
        this.faturamento.id_condicao = condicao.id_condicao;
        this.faturamento.Condicao.condicoes = condicao.condicoes;
      } else {
        this.faturamento.id_condicao = null;
        this.faturamento.Condicao.condicoes = "";
      }
      this.modalFaturamentoReceber(false);
    },

    getEspeciePagamento(especie) {
      if (especie === "1") {
        // Dinheiro
        return "media/icons/duotune/finance/fin003.svg";
      } else if (especie === "2") {
        // Cheque
        return "media/icons/duotune/files/fil003.svg";
      } else if (especie === "3") {
        // Cartão de Crédito
        return "media/icons/duotune/finance/fin002.svg";
      } else if (especie === "4") {
        // Cartão de Débito
        return "media/icons/duotune/finance/fin002.svg";
      } else if (especie === "5") {
        // Crédito Loja / A PRAZO / Convênio / T.E.F
        return "media/icons/duotune/coding/cod002.svg";
      } else if (especie === "10") {
        // Vale Alimentação
        return "media/icons/duotune/ecommerce/ecm011.svg";
      } else if (especie === "11") {
        // Vale Refeição
        return "media/icons/duotune/ecommerce/ecm011.svg";
      } else if (especie === "12") {
        // Vale Presente
        return "media/icons/duotune/ecommerce/ecm011.svg";
      } else if (especie === "13") {
        // Vale Combustível
        return "media/icons/duotune/ecommerce/ecm011.svg";
      } else if (especie === "17") {
        // PIX
        return "media/icons/duotune/finance/fin010.svg";
      } else {
        // Outros
        return "media/icons/duotune/finance/fin008.svg";
      }
    },

    limparEnderecoEntrega() {
      this.faturamento.FaturamentoCliente.FaturamentoEnderecoEntrega =
        JSON.parse(
          JSON.stringify(
            faturamentoInicializado.FaturamentoCliente
              .FaturamentoEnderecoEntrega
          )
        );
    },

    limparEnderecoRetirada() {
      this.faturamento.FaturamentoCliente.FaturamentoEnderecoRetirada =
        JSON.parse(
          JSON.stringify(
            faturamentoInicializado.FaturamentoCliente
              .FaturamentoEnderecoRetirada
          )
        );
    },

    modalFaturamentoEditarChave(exibir) {
      this.exibirFaturamentoEditarChave = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_chave",
          /*open*/ () => {
            this.$utils.requestFocus("txtChaveAcesso");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarChave(false);
          }
        );
      }
    },
    async adicionarFaturamentoChave() {
      if (this.faturamento.FaturamentoChaveReferenciada.length < 500) {
        this.indexFaturamentoEditarChave = -1;
        this.chaveAcessoAtual = "";
        this.modalFaturamentoEditarChave(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que 500 chaves de acesso!"
        );
      }
    },
    editarFaturamentoChave(index) {
      this.indexFaturamentoEditarChave = index;
      this.chaveAcessoAtual =
        this.faturamento.FaturamentoChaveReferenciada[index].chave;
      this.modalFaturamentoEditarChave(true);
    },
    removerFaturamentoChave(index) {
      this.loadingNFeReferenciada = true;
      this.faturamento.FaturamentoChaveReferenciada.splice(index, 1);
      toast.success("Chave de acesso excluída com sucesso!", { timeout: 2000 });
      this.loadingNFeReferenciada = false;
    },
    async vadicionarChave(chave) {
      if (this.verificarChaveExistente(chave.chave)) {
        await this.$swal.showInvalidAlert(
          "A chave de acesso já foi adicionada!"
        );
      } else {
        this.faturamento.FaturamentoChaveReferenciada.push(chave);
        setTimeout(MenuComponent.reinitialization, 500);
        toast.success("Chave adicionada com sucesso!", { timeout: 2000 });
      }
    },
    async editarChave(chave, index) {
      if (this.verificarChaveExistente(chave.chave)) {
        await this.$swal.showInvalidAlert(
          "A chave de acesso já foi adicionada!"
        );
      } else {
        this.faturamento.FaturamentoChaveReferenciada[index] = chave;
        toast.success("Chave alterada com sucesso!", { timeout: 2000 });
      }
    },

    verificarChaveExistente(chaveAcesso) {
      for (
        let i = 0;
        i < this.faturamento.FaturamentoChaveReferenciada.length;
        i++
      ) {
        if (
          this.faturamento.FaturamentoChaveReferenciada[i].chave === chaveAcesso
        ) {
          return true;
        }
      }
      return false;
    },

    modalFaturamentoEditarAutorizados(exibir) {
      this.exibirFaturamentoEditarAutorizados = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_autorizados",
          /*open*/ () => {
            this.$utils.requestFocus("txtAutorizado");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarAutorizados(false);
          }
        );
      }
    },
    async adicionarFaturamentoAutorizados() {
      if (this.faturamento.FaturamentoAutorizados.length < 10) {
        this.indexFaturamentoAutorizado = -1;
        this.autorizadoAtual = "";
        this.modalFaturamentoEditarAutorizados(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que 10 autorizados!"
        );
      }
    },
    editarFaturamentoAutorizado(index) {
      this.indexFaturamentoAutorizado = index;
      this.autorizadoAtual =
        this.faturamento.FaturamentoAutorizados[index].documento;
      this.modalFaturamentoEditarAutorizados(true);
    },
    removerFaturamentoAutorizado(index) {
      this.loadingNFeAutorizados = true;
      this.faturamento.FaturamentoAutorizados.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingNFeAutorizados = false;
    },
    async adicionarAutorizado(autorizado) {
      if (this.verificarAutorizadoExistente(autorizado.documento)) {
        await this.$swal.showInvalidAlert(
          "O documento informado já está adicionado!"
        );
      } else {
        this.faturamento.FaturamentoAutorizados.push(autorizado);
        setTimeout(MenuComponent.reinitialization, 500);
        toast.success("Documento adicionado com sucesso!", { timeout: 2000 });
      }
    },
    async editarAutorizado(autorizado, index) {
      if (this.verificarAutorizadoExistente(autorizado.documento)) {
        await this.$swal.showInvalidAlert(
          "O documento informado já está adicionado!"
        );
      } else {
        this.faturamento.FaturamentoAutorizados[index] = autorizado;
        toast.success("Documento atualizado com sucesso!", { timeout: 2000 });
      }
    },

    verificarAutorizadoExistente(documento) {
      for (let i = 0; i < this.faturamento.FaturamentoAutorizados.length; i++) {
        if (
          this.faturamento.FaturamentoAutorizados[i].documento === documento
        ) {
          return true;
        }
      }
      return false;
    },

    verificarIndicadorPresenca() {
      return this.faturamento.ind_pres == 2 ||
        this.faturamento.ind_pres == 3 ||
        this.faturamento.ind_pres == 9 ||
        this.faturamento.ind_intermed == 1
        ? true
        : false;
    },

    modalFaturamentoEditarNFProdutorRural(exibir) {
      this.exibirFaturamentoEditarNFProdutorRural = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_nf_produtor",
          /*open*/ () => {
            this.$utils.requestFocus("txtNNF");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarNFProdutorRural(false);
          }
        );
      }
    },
    async adicionarFaturamentoNFProdutor() {
      if (this.faturamento.FaturamentoRefNFP.length < 1) {
        this.indexFaturamentoNFProdutorRural = -1;
        this.nfProdutorRuralAtual = [];
        this.modalFaturamentoEditarNFProdutorRural(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que uma nota de produtor!"
        );
      }
    },
    editarFaturamentoNFProdutor(index) {
      this.indexFaturamentoNFProdutorRural = index;
      this.nfProdutorRuralAtual = this.faturamento.FaturamentoRefNFP[index];
      this.modalFaturamentoEditarNFProdutorRural(true);
    },
    removerFaturamentoNFProdutor(index) {
      this.loadingNFProdutor = true;
      this.faturamento.FaturamentoRefNFP.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingNFProdutor = false;
    },
    adicionarNFProdutor(refNFP) {
      this.faturamento.FaturamentoRefNFP.push(refNFP);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Documento adicionado com sucesso!", { timeout: 2000 });
    },
    editarNFProdutor(refNFP, index) {
      this.faturamento.FaturamentoRefNFP[index] = refNFP;
      toast.success("Documento atualizado com sucesso!", { timeout: 2000 });
    },

    modalFaturamentoEditarNFA(exibir) {
      this.exibirFaturamentoEditarNFA = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_nf_produtor",
          /*open*/ () => {
            this.$utils.requestFocus("txtNNF");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarNFA(false);
          }
        );
      }
    },
    async adicionarFaturamentoNFA() {
      if (this.faturamento.FaturamentoRefNFA.length < 1) {
        this.indexFaturamentoNFA = -1;
        this.nfaAtual = [];
        this.modalFaturamentoEditarNFA(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que uma nota 1/1A!"
        );
      }
    },
    editarFaturamentoNFA(index) {
      this.indexFaturamentoNFA = index;
      this.nfaAtual = this.faturamento.FaturamentoRefNFA[index];
      this.modalFaturamentoEditarNFA(true);
    },
    removerFaturamentoNFA(index) {
      this.loadingNFA = true;
      this.faturamento.FaturamentoRefNFA.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingNFA = false;
    },
    adicionarNFA(refNFA) {
      this.faturamento.FaturamentoRefNFA.push(refNFA);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Documento adicionado com sucesso!", { timeout: 2000 });
    },
    editarNFA(refNFA, index) {
      this.faturamento.FaturamentoRefNFA[index] = refNFA;
      toast.success("Documento atualizado com sucesso!", { timeout: 2000 });
    },

    editarFaturamentoNFeProduto(index) {
      this.indexFaturamentoNFeProduto = index;
      this.nfeProdutoAtual = this.faturamento.FaturamentoItem[index];
      this.modalFaturamentoEditarNFeProduto(true);
    },

    modalFaturamentoEditarNFeProduto(exibir) {
      this.exibirFaturamentoEditarNFeProduto = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_nfe_produto",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_faturamento_editar_nfe_produto");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarNFeProduto(false);
          }
        );
      }
    },
    async editarNFeProduto(produto, index) {
      this.faturamento.FaturamentoItem[index].FaturamentoItemNFe =
        produto.FaturamentoItemNFe;

      if (produto.FaturamentoItemNFe.EstoqueSt) {
        let tabelaEstados = await this.retornarTabelaEstados(
          produto.FaturamentoItemNFe.id_estoque_st
        );
        if (tabelaEstados !== null) {
          this.faturamento.FaturamentoItem[index].aliqi = tabelaEstados.aliqi;
          this.faturamento.FaturamentoItem[index].icms = tabelaEstados.aliq;
          this.faturamento.FaturamentoItem[index].mva = tabelaEstados.mva;
          this.faturamento.FaturamentoItem[index].reducao =
            tabelaEstados.reducao;
          this.faturamento.FaturamentoItem[index].st = tabelaEstados.st;
          this.faturamento.FaturamentoItem[index].csosn = tabelaEstados.csosn;

          if (
            tabelaEstados.estoqueST &&
            tabelaEstados.estoqueST.cfop &&
            tabelaEstados.estoqueST.cfop.length > 0
          ) {
            this.faturamento.FaturamentoItem[index].cfop = String(
              tabelaEstados.estoqueST.cfop
            );
          }
        }
      }

      await this.recalcularValores();
      toast.success("Dados atualizados com sucesso!", { timeout: 2000 });
    },

    async retornarTabelaEstados(id) {
      let ufCliente =
        this.faturamento.FaturamentoCliente.FaturamentoEndereco.uf;
      try {
        let filter =
          "?$filter=id_estoque_st eq " +
          id +
          " and uf eq '" +
          ufCliente +
          "' and simples_nac eq '0'";
        let retOdata = await this.$store.dispatch("stUf/getStUfOData", filter);
        if (retOdata.value !== null && retOdata.value.length > 0) {
          let stUF = retOdata.value[0];

          filter = "?$filter=id eq " + id;
          let retOdataEstoqueSt = await this.$store.dispatch(
            "estoqueSt/getEstoqueStOData",
            filter
          );

          if (
            retOdataEstoqueSt.value !== null &&
            retOdataEstoqueSt.value.length > 0
          ) {
            stUF.estoqueST = retOdataEstoqueSt.value[0];
          }

          return stUF;
        }
      } catch (error) {
        console.log(error);
      }
      return null;
    },

    modalEditarProdutoPeso(exibir) {
      this.exibirEditarProdutoPeso = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_produto_peso_item",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesoBruto");
          },
          /*close*/ () => {
            this.modalEditarProdutoPeso(false);
          }
        );
      }
    },

    editarPesoProduto(index) {
      this.indexEdicaoFaturamentoItem = index;
      this.pesoBrutoFaturamentoItem = 0;
      this.pesoLiquidoFaturamentoItem = 0;

      this.pesoBrutoFaturamentoItem = parseFloat(
        this.faturamento.FaturamentoItem[index].peso_bruto
      );
      this.pesoLiquidoFaturamentoItem = parseFloat(
        this.faturamento.FaturamentoItem[index].peso_liquido
      );
      this.modalEditarProdutoPeso(true);
    },

    confirmarPesoProduto(pesoBruto, pesoLiquido) {
      this.faturamento.FaturamentoItem[
        this.indexEdicaoFaturamentoItem
      ].peso_bruto = pesoBruto;
      this.faturamento.FaturamentoItem[
        this.indexEdicaoFaturamentoItem
      ].peso_liquido = pesoLiquido;
      this.indexEdicaoFaturamentoItem = -1;
      this.modalEditarProdutoPeso(false);

      this.recalcularValores();

      toast.info("Produto atualizado com sucesso!", {
        timeout: 2000,
      });
    },

    editarTotalProduto(index) {
      this.indexEdicaoFaturamentoItem = index;
      var item = this.faturamento.FaturamentoItem[index];
      if (item.qtd === 0) {
        toast.info("A quantidade do produto está zerada!", { timeout: 3000 });
      } else if (item.preco === 0) {
        toast.info("O valor do produto está zerado!", { timeout: 3000 });
      } else {
        this.labelTotal = "Valor Total do Produto";
        this.totalDescontoModal = item.total + item.desconto - item.acrescimo;
        this.exibirRemoverDesconto = false;
        this.modalDesconto(true);
      }
    },

    editarTotal() {
      if (this.faturamento.total === 0) {
        toast.info("O valor total do faturamento está zerado!", {
          timeout: 3000,
        });
      } else {
        this.labelTotal = "Valor Total";
        this.totalDescontoModal =
          this.faturamento.total +
          this.faturamento.total_descontos -
          this.faturamento.total_acrescimo;
        this.exibirRemoverDesconto = true;
        this.modalDesconto(true);
      }
    },

    modalDesconto(exibir) {
      this.exibirDesconto = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_faturamento_modal_desconto",
          /*open*/ () => {
            this.$utils.requestFocus("txtValorDesconto");
          },
          /*close*/ () => {
            this.modalDesconto(false);
          }
        );
      }
    },

    confirmarDesconto(desconto, label) {
      if (label === "Valor Total") {
        this.atualizarDescontoTotal(desconto);
      } else if (label === "Valor Total do Produto") {
        this.atualizarDescontoTotalProduto(desconto);
      }
    },

    removerDesconto(label) {
      if (label === "Valor Total") {
        this.atualizarDescontoTotal(0);
      }
      this.modalDesconto(false);
    },

    atualizarDescontoTotalProduto(desconto) {
      if (desconto < 0) {
        this.faturamento.FaturamentoItem[
          this.indexEdicaoFaturamentoItem
        ].desconto = desconto * -1;
        this.faturamento.FaturamentoItem[
          this.indexEdicaoFaturamentoItem
        ].acrescimo = 0;
      } else {
        this.faturamento.FaturamentoItem[
          this.indexEdicaoFaturamentoItem
        ].desconto = 0;
        this.faturamento.FaturamentoItem[
          this.indexEdicaoFaturamentoItem
        ].acrescimo = desconto;
      }

      this.recalcularValores();
    },

    atualizarDescontoTotal(desconto) {
      for (var p = 0; p < this.faturamento.FaturamentoItem.length; p++) {
        var valorDesconto = 0;
        var valorAcrescimo = 0;
        var percentualProporcional =
          (this.faturamento.FaturamentoItem[p].total * 100) /
          this.faturamento.total;

        if (desconto < 0) {
          valorDesconto = (desconto * -1 * percentualProporcional) / 100;
          this.faturamento.FaturamentoItem[p].desconto = valorDesconto;
          this.faturamento.FaturamentoItem[p].acrescimo = 0;
        } else if (desconto === 0) {
          this.faturamento.FaturamentoItem[p].desconto = 0;
          this.faturamento.FaturamentoItem[p].acrescimo = 0;
        } else {
          this.faturamento.FaturamentoItem[p].desconto = 0;
          valorAcrescimo = (desconto * percentualProporcional) / 100;
          this.faturamento.FaturamentoItem[p].acrescimo = valorAcrescimo;
        }
      }

      this.recalcularValores();
    },
    selecionarCfop(cfop) {
      this.faturamento.cfop = cfop.codigo;
      this.faturamento.natureza_operacao = cfop.nome;
      this.modalCfops(false);
    },
    modalCfops(exibir) {
      this.exibirCfops = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_cfops_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarCfops");
          },
          /*close*/ () => {
            this.modalCfops(false);
          }
        );
      }
    },
    selecionarConta(conta) {
      this.faturamento.id_conta = conta.id;
    },
    modalContas(exibir) {
      this.exibirContas = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_contas_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarContas");
          },
          /*close*/ () => {
            this.modalContas(false);
          }
        );
      }
    },
    selecionarCusto(custo) {
      this.faturamento.id_custo = custo.id;
    },
    modalCustos(exibir) {
      this.exibirCustos = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_custos_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarCustos");
          },
          /*close*/ () => {
            this.modalCustos(false);
          }
        );
      }
    },
    modalFaturamentoEditarExporta(exibir) {
      this.exibirFaturamentoEditarExporta = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_exporta",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_faturamento_editar_exporta");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarExporta(false);
          }
        );
      }
    },
    async adicionarFaturamentoExporta() {
      if (this.faturamento.FaturamentoExporta.length < 1) {
        this.indexFaturamentoExporta = -1;
        this.exportaAtual = {};
        this.modalFaturamentoEditarExporta(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que um grupo de exportação!"
        );
      }
    },
    editarFaturamentoExporta(index) {
      this.indexFaturamentoExporta = index;
      this.exportaAtual = this.faturamento.FaturamentoExporta[index];
      this.modalFaturamentoEditarExporta(true);
    },
    removerFaturamentoExporta(index) {
      this.loadingExporta = true;
      this.faturamento.FaturamentoExporta.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingExporta = false;
    },
    adicionarExporta(ref) {
      this.faturamento.FaturamentoExporta.push(ref);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Registro adicionado com sucesso!", { timeout: 2000 });
    },
    editarExporta(ref, index) {
      this.faturamento.FaturamentoExporta[index] = ref;
      toast.success("Registro atualizado com sucesso!", { timeout: 2000 });
    },

    modalFaturamentoEditarCompra(exibir) {
      this.exibirFaturamentoEditarCompra = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_compra",
          /*open*/ () => {
            this.$utils.requestFocus("txtxNEmp");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarCompra(false);
          }
        );
      }
    },
    async adicionarFaturamentoCompra() {
      if (this.faturamento.FaturamentoCompra.length < 1) {
        this.indexFaturamentoCompra = -1;
        this.compraAtual = {};
        this.modalFaturamentoEditarCompra(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que um grupo de compra!"
        );
      }
    },
    editarFaturamentoCompra(index) {
      this.indexFaturamentoCompra = index;
      this.compraAtual = this.faturamento.FaturamentoCompra[index];
      this.modalFaturamentoEditarCompra(true);
    },
    removerFaturamentoCompra(index) {
      this.loadingCompra = true;
      this.faturamento.FaturamentoCompra.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingCompra = false;
    },
    adicionarCompra(ref) {
      this.faturamento.FaturamentoCompra.push(ref);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Registro adicionado com sucesso!", { timeout: 2000 });
    },
    editarCompra(ref, index) {
      this.faturamento.FaturamentoCompra[index] = ref;
      toast.success("Registro atualizado com sucesso!", { timeout: 2000 });
    },

    modalFaturamentoEditarVeicTransp(exibir) {
      this.exibirFaturamentoEditarVeicTransp = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_veic_transp",
          /*open*/ () => {
            this.$utils.requestFocus("txtPlaca");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarVeicTransp(false);
          }
        );
      }
    },
    async adicionarFaturamentoVeicTransp() {
      if (this.faturamento.FaturamentoVeicTransp.length < 1) {
        this.indexFaturamentoVeicTransp = -1;
        this.veicTranspAtual = {};
        this.modalFaturamentoEditarVeicTransp(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que um veículo!"
        );
      }
    },
    editarFaturamentoVeicTransp(index) {
      this.indexFaturamentoVeicTransp = index;
      this.veicTranspAtual = this.faturamento.FaturamentoVeicTransp[index];
      this.modalFaturamentoEditarVeicTransp(true);
    },
    removerFaturamentoVeicTransp(index) {
      this.loadingVeicTransp = true;
      this.faturamento.FaturamentoVeicTransp.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingVeicTransp = false;
    },
    adicionarVeicTransp(ref) {
      this.faturamento.FaturamentoVeicTransp.push(ref);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Registro adicionado com sucesso!", { timeout: 2000 });
    },
    editarVeicTransp(ref, index) {
      this.faturamento.FaturamentoVeicTransp[index] = ref;
      toast.success("Registro atualizado com sucesso!", { timeout: 2000 });
    },

    async carregarModeloPadrao() {
      try {
        let filter = "?$filter=padrao eq '1' and nfe eq '1'";
        let retOdata = await this.$store.dispatch(
          "modelosFaturamento/getModelosFaturamentoOData",
          filter
        );
        if (retOdata.value !== null && retOdata.value.length > 0) {
          this.faturamento.ModelosFaturamento = retOdata.value[0];
          this.faturamento.id_modelo_faturamento =
            this.faturamento.ModelosFaturamento.id;

          this.faturamento.modelo = this.faturamento.ModelosFaturamento.modelo;
          this.faturamento.serie = this.faturamento.ModelosFaturamento.serie;
        } else {
          await this.$swal.showInvalidAlert(
            "Não existe um modelo padrão para o faturamento, é necessário configurar um para prosseguir!",
            (alert) => {
              this.$router.push("/movimentacao/faturamento/consultar");
            }
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    async retornarModeloFaturamento(id) {
      try {
        let retModelo = await this.$store.dispatch(
          "modelosFaturamento/getModelosFaturamento",
          id
        );

        if (retModelo.Success === true) {
          return retModelo.Data;
        }
      } catch (error) {
        console.log(error);
      }
      return null;
    },
    async modalFaturamentoSelecionarModelo(exibir) {
      this.exibirFaturamentoSelecionarModelo = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_modelos_faturamento",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisar");
          },
          /*close*/ () => {
            this.modalFaturamentoSelecionarModelo(false);
          }
        );
      } else {
        if (this.faturamento.FaturamentoCliente.id_cliente === null) {
          await this.modalClientes(true);
        }
      }
    },
    async selecionarModelosFaturamento() {
      this.modalFaturamentoSelecionarModelo(true);
    },
    async confirmarModeloFaturamento(modelo) {
      let retModelo = await this.retornarModeloFaturamento(modelo.id);
      if (retModelo != null) {
        this.faturamento.modelo = retModelo.modelo;
        this.faturamento.serie = retModelo.serie;
        this.faturamento.ModelosFaturamento = retModelo;
        this.faturamento.id_modelo_faturamento =
          this.faturamento.ModelosFaturamento.id;
      }
    },
    focusAviso(value) {
      if (typeof value.onClick === "function") {
        this.tabFocus(value.tab, value.tabID);
        if (value.indices && value.indices.length > 0) {
          this.indices = value.indices;
        } else {
          this.indices = [];
        }
        value.onClick();
        setTimeout(() => {
          this.nextFocus(value.elemento);
        }, 800);
      } else {
        this.tabFocus(value.tab, value.tabID);
        this.nextFocus(value.elemento);
      }
    },
    getErrorByID(id) {
      return this.errosValidacao[id] &&
        this.errosValidacao[id] !== undefined &&
        this.errosValidacao[id] !== ""
        ? this.errosValidacao[id]
        : null;
    },
    mapperModal() {
      faturamentoMapper.FaturamentoItempeso_bruto[2] =
        this.editarPesoProduto.bind(this, null);

      faturamentoMapper.FaturamentoItempeso_liquido[2] =
        this.editarPesoProduto.bind(this, null);

      faturamentoMapper.FaturamentoItemobservacao[2] =
        this.editarObservacoesProduto.bind(this, null);
    },

    modalEditarProdutoDetalhes(exibir) {
      this.exibirEditarProdutoDetalhes = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_produto_detalhes",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_produto_detalhes");
          },
          /*close*/ () => {
            this.modalEditarProdutoDetalhes(false);
          }
        );
      } else {
        this.indexEdicaoFaturamentoItem = -1;
        this.detPesagemFaturamentoItem = "";
        this.detToleranciaFaturamentoItem = "";
        this.detTipoEmbalagemFaturamentoItem = "";
        this.detCodBarrasFaturamentoItem = "";
        this.detMetragemFaturamentoItem = "";
      }
    },
    editarDetalhesProduto(index) {
      this.indexEdicaoFaturamentoItem = index;
      this.detPesagemFaturamentoItem =
        this.faturamento.FaturamentoItem[
          this.indexEdicaoFaturamentoItem
        ].det_pesagem;
      this.detToleranciaFaturamentoItem =
        this.faturamento.FaturamentoItem[
          this.indexEdicaoFaturamentoItem
        ].det_tolerancia;
      this.detTipoEmbalagemFaturamentoItem =
        this.faturamento.FaturamentoItem[
          this.indexEdicaoFaturamentoItem
        ].det_tipo_embalagem;
      this.detCodBarrasFaturamentoItem =
        this.faturamento.FaturamentoItem[
          this.indexEdicaoFaturamentoItem
        ].det_cod_barras;
      this.detMetragemFaturamentoItem =
        this.faturamento.FaturamentoItem[
          this.indexEdicaoFaturamentoItem
        ].det_metragem;
      this.modalEditarProdutoDetalhes(true);
    },
    confirmarDetalhesProduto(
      detPesagem,
      detTolerancia,
      detTipoEmbalagem,
      detCodBarras,
      detMetragem
    ) {
      this.faturamento.FaturamentoItem[
        this.indexEdicaoFaturamentoItem
      ].det_pesagem = detPesagem;

      this.faturamento.FaturamentoItem[
        this.indexEdicaoFaturamentoItem
      ].det_tolerancia = detTolerancia;

      this.faturamento.FaturamentoItem[
        this.indexEdicaoFaturamentoItem
      ].det_tipo_embalagem = detTipoEmbalagem;

      this.faturamento.FaturamentoItem[
        this.indexEdicaoFaturamentoItem
      ].det_cod_barras = detCodBarras;

      this.faturamento.FaturamentoItem[
        this.indexEdicaoFaturamentoItem
      ].det_metragem = detMetragem;

      this.indexEdicaoFaturamentoItem = -1;
      this.modalEditarProdutoDetalhes(false);

      toast.info("Produto atualizado com sucesso!", {
        timeout: 2000,
      });
    },
    scroll(refName) {
      let el = this.$refs[refName];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    async modalVendedorItem(exibir) {
      this.exibirModalVendedorItem = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_editar_vendedor_item",
          /*open*/ () => {
            this.$utils.requestFocus("id_vendedor");
          },
          /*close*/ () => {
            this.modalVendedorItem(false);
          }
        );
      }
    },
    async editarVendedorItem(index) {
      this.indexEdicaoFaturamentoItem = index;
      var item = this.faturamento.FaturamentoItem[index];
      this.idVendedorItemAtual = item.id_vendedor;
      this.comissaoVendedorItemAtual = item.comissao;
      this.modalVendedorItem(true);
    },
    async confirmarVendedorItem(idVendedor, comissao) {
      this.faturamento.FaturamentoItem[
        this.indexEdicaoFaturamentoItem
      ].id_vendedor = idVendedor;
      this.faturamento.FaturamentoItem[
        this.indexEdicaoFaturamentoItem
      ].comissao = comissao;
    },

    async abrirFaturamento(id_faturamento) {
      let result = false;

      const id_usuario = this.user.User.id;
      const faturamentosSalvos = this.getFaturamentosSalvos();
      const faturamentoSalvo = faturamentosSalvos[id_usuario] || {};
      const faturamentoSalvoExistente =
        Object.keys(faturamentoSalvo).length !== 0 &&
        Object.prototype.hasOwnProperty.call(faturamentoSalvo, id_faturamento);

      if (id_faturamento === 0) {
        if (faturamentoSalvoExistente) {
          await this.$swal.showQuestionAlert(
            "Existe uma inclusão de faturamento em andamento! Deseja continuar a edição?",
            async (alert) => {
              if (alert.isConfirmed) {
                this.faturamento = JSON.parse(
                  JSON.stringify(faturamentoSalvo[id_faturamento])
                );
                result = true;
              } else {
                await this.limparFaturamentoLocalStorage(
                  id_usuario,
                  id_faturamento
                );
              }
            }
          );
        }
      } else {
        const faturamentoEmEdicao = await this.verificaControleEdicao(
          id_faturamento
        );
        const faturamentoEmEdicaoEncontrado =
          Object.keys(faturamentoEmEdicao).length !== 0;

        if (faturamentoEmEdicaoEncontrado) {
          if (faturamentoEmEdicao.id_usuario !== id_usuario) {
            await this.$swal.showQuestionAlert(
              "Existe uma edição do faturamento Nº " +
                id_faturamento +
                " em andamento pelo usuário " +
                faturamentoEmEdicao.Usuario.nome +
                "! Se você continuar as alterações anteriores serão descartadas! Tem certeza que deseja editar mesmo assim?",
              async (alert) => {
                if (alert.isConfirmed) {
                  this.limparFaturamentoLocalStorage(
                    faturamentoEmEdicao.id_usuario,
                    id_faturamento
                  );
                  await this.insertControleEdicao(id_faturamento);
                } else {
                  this.limparFaturamentoLocalStorage(
                    id_usuario,
                    id_faturamento
                  );
                  if (this.modal === true) {
                    this.$emit("cancelarFaturamento", false);
                  } else {
                    this.$router.push("/movimentacao/faturamento/consultar");
                  }
                }
              }
            );
          } else {
            await this.insertControleEdicao(id_faturamento);

            if (faturamentoSalvoExistente) {
              await this.$swal.showQuestionAlert(
                "Existe uma edição do faturamento Nº " +
                  id_faturamento +
                  " em andamento! Deseja continuar a edição?",
                (alert) => {
                  if (alert.isConfirmed) {
                    this.faturamento = JSON.parse(
                      JSON.stringify(faturamentoSalvo[id_faturamento])
                    );
                    result = true;
                  } else {
                    this.limparFaturamentoLocalStorage(
                      id_usuario,
                      id_faturamento
                    );
                  }
                }
              );
            }
          }
        } else {
          this.limparFaturamentoLocalStorage(id_usuario, id_faturamento);
          await this.insertControleEdicao(id_faturamento);
        }
      }

      return result;
    },

    async limparFaturamentoLocalStorage(id_usuario, id_faturamento) {
      const faturamentosSalvos = this.getFaturamentosSalvos();

      if (
        Object.prototype.hasOwnProperty.call(faturamentosSalvos, id_usuario)
      ) {
        delete faturamentosSalvos[id_usuario][id_faturamento];

        if (Object.keys(faturamentosSalvos[id_usuario]).length === 0) {
          delete faturamentosSalvos[id_usuario];
        }

        localStorage.setItem(
          "faturamentosSalvos",
          JSON.stringify(faturamentosSalvos)
        );
      }
    },
    salvarFaturamentoLocalStorage() {
      const faturamentosSalvos = this.getFaturamentosSalvos();
      const id_usuario = this.user.User.id;
      const id_faturamento =
        this.faturamento && this.faturamento.id ? this.faturamento.id : 0;

      if (
        !Object.prototype.hasOwnProperty.call(faturamentosSalvos, id_usuario)
      ) {
        faturamentosSalvos[id_usuario] = {};
      }

      faturamentosSalvos[id_usuario][id_faturamento] = this.faturamento;
      localStorage.setItem(
        "faturamentosSalvos",
        JSON.stringify(faturamentosSalvos)
      );
    },
    getFaturamentosSalvos() {
      return JSON.parse(localStorage.getItem("faturamentosSalvos")) || {};
    },
    async verificaControleEdicao(id_edicao) {
      let result = {};
      try {
        var ret = await this.$store.dispatch(
          "controleEdicao/getControleEdicaoOData",
          "?$filter=id_edicao eq " +
            id_edicao +
            " and modulo eq 'Faturamentos'" +
            "&$expand=Usuario($select=nome)"
        );
        if (ret.value !== null && ret.value.length > 0) {
          result = ret.value[0];
        }
      } catch (error) {
        console.log(error);
      }

      return result;
    },
    async insertControleEdicao(id_edicao) {
      await this.deleteControleEdicao(id_edicao);

      var controleEdicao = {
        id: 0,
        id_edicao: id_edicao,
        id_usuario: this.user.User.id,
        modulo: "Faturamentos",
      };

      try {
        var ret = await this.$store.dispatch(
          "controleEdicao/postControleEdicao",
          controleEdicao
        );
      } catch (error) {
        console.log(error);
      }
    },
    async deleteControleEdicao(id_edicao) {
      var controleEdicao = {
        id_edicao: id_edicao,
        modulo: "Faturamentos",
      };

      try {
        var ret = await this.$store.dispatch(
          "controleEdicao/deleteControleEdicaoIdEdicao",
          controleEdicao
        );
      } catch (error) {
        console.log(error);
      }
    },
    async cancelarFaturamento() {
      this.limparFaturamentoLocalStorage(
        this.user.User.id,
        this.faturamento.id
      );
      if (this.faturamento.id !== 0) {
        await this.deleteControleEdicao(this.faturamento.id);
      }

      if (this.modal === true) {
        this.$emit("cancelarFaturamento", false);
      } else {
        this.$router.push("/movimentacao/faturamento/consultar");
      }
    },
    ativarCamposLivres() {
      this.camposLivres = !this.camposLivres;
      const itemsToSetVisible = [
        "base_icms",
        "total_icms",
        "base_icms_sub",
        "total_icms_sub",
        "total_ipi",
      ];
      this.setVisibilityTrueForItems(
        this.tableProdutoHeader,
        itemsToSetVisible,
        this.camposLivres
      );
    },

    setVisibilityTrueForItems(items, itemKeys, visible) {
      for (const item of items) {
        if (itemKeys.includes(item.key)) {
          item.visible = visible;
        }
      }
    },

    async modalImportarPedidoVenda(exibir) {
      this.exibirModalImportacaoPedidoVenda = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_importacao_pedido_venda",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarPedidos");
          },
          /*close*/ () => {
            this.modalImportarPedidoVenda(false);
          }
        );
      }
    },

    async exibirModalImportarPedidoVenda(exibir) {
      this.modalImportarPedidoVenda(exibir);
    },

    async importarPedidoVenda(id, importarDuplicatas) {
      try {
        this.loading = true;
        this.importacaoPedidoVenda = true;

        const novaImportacao = {
          id_importacao: String(id),
          modulo: "Pedido de Venda",
        };

        const exists = this.faturamento.FaturamentoImportacoes.find(
          (item) =>
            String(item.id_importacao) === String(novaImportacao.id_importacao)
        );

        if (!exists) {
          var ret = await this.$store.dispatch("pedido/getPedido", id);
          if (ret.Success === true) {
            const pedido = ret.Data;

            if (pedido) {
              if (pedido.id_conta !== null) {
                this.faturamento.id_conta = pedido.id_conta;
              }

              if (pedido.id_custo !== null) {
                this.faturamento.id_custo = pedido.id_custo;
              }

              if (pedido.PedidoCliente.id_cliente !== null) {
                let retCli = await this.$store.dispatch(
                  "cliente/getCliente",
                  pedido.PedidoCliente.id_cliente
                );
                if (retCli.Success === true) {
                  await this.selecionarCliente(retCli.Data);
                }
              }

              if (
                pedido.PedidoCliente.PedidoEnderecoEntrega !== undefined &&
                pedido.PedidoCliente.PedidoEnderecoEntrega !== null
              ) {
                this.pesquisaEnderecoIndex = 1;
                pedido.PedidoCliente.PedidoEnderecoEntrega.id =
                  pedido.PedidoCliente.PedidoEnderecoEntrega.id_cliente_endereco;
                await this.selecionarEndereco(
                  pedido.PedidoCliente.PedidoEnderecoEntrega
                );
              }

              if (pedido.PedidoItem && pedido.PedidoItem.length > 0) {
                for (const item in pedido.PedidoItem) {
                  const produto = pedido.PedidoItem[item].Produto;
                  produto.qtd = pedido.PedidoItem[item].qtd;
                  produto.preco = pedido.PedidoItem[item].preco;
                  produto.PedidoSubItem = pedido.PedidoItem[item].PedidoSubItem;
                  produto.brinde =
                    pedido.PedidoItem[item].brinde === undefined ||
                    pedido.PedidoItem[item].brinde === null
                      ? "N"
                      : pedido.PedidoItem[item].brinde;
                  produto.id_pedido = pedido.id;
                  produto.id_estoque = pedido.PedidoItem[item].id_estoque;
                  await this.preencheProdutoSelecionado(produto, true, -1);
                }
              }

              if (
                pedido.id_vendedor !== undefined &&
                pedido.id_vendedor !== null &&
                pedido.id_vendedor > 0
              ) {
                if (pedido.Vendedor !== undefined && pedido.Vendedor !== null) {
                  await this.selecionarVendedor(pedido.Vendedor);
                }
              }

              if (
                pedido.id_transportadora !== undefined &&
                pedido.id_transportadora !== null &&
                pedido.id_transportadora > 0
              ) {
                if (
                  pedido.Transportadora !== undefined &&
                  pedido.Transportadora !== null
                ) {
                  await this.selecionarTransportadora(pedido.Transportadora);
                }
              }

              if (
                pedido.id_motorista !== undefined &&
                pedido.id_motorista !== null &&
                pedido.id_motorista > 0
              ) {
                if (
                  pedido.Motorista !== undefined &&
                  pedido.Motorista !== null
                ) {
                  await this.selecionarMotorista(pedido.Motorista);
                }
              }

              this.faturamento.frete = pedido.frete;

              if (
                pedido.observacao !== undefined &&
                pedido.observacao !== null
              ) {
                if (
                  this.faturamento.observacao !== null &&
                  this.faturamento.observacao.length > 0
                ) {
                  this.faturamento.observacao += "\r\n";
                }
                this.faturamento.observacao += pedido.observacao;
                this.faturamento.observacao =
                  this.faturamento.observacao.trim();
              }

              if (importarDuplicatas === true) {
                if (
                  pedido.PedidoReceber !== undefined &&
                  pedido.PedidoReceber !== null &&
                  pedido.PedidoReceber.length > 0
                ) {
                  pedido.PedidoReceber.forEach((item) => {
                    let p = {
                      id: 0,
                      id_faturamento: 0,
                      documento: "",
                      ordem: item.ordem,
                      emissao: item.emissao,
                      conta: item.conta,
                      custo: item.custo,
                      descricao: item.descricao,
                      vencimento: item.vencimento,
                      recebimento: item.recebimento,
                      valor: item.valor,
                      valor_recebido: item.valor_recebido,
                      cod_especie: item.cod_especie,
                      especie: item.especie,
                      juros: item.juros,
                      juros_reais: item.juros_reais,
                      modelo: item.modelo,
                      serie: item.serie,
                      banco: item.banco,
                      nosso_numero: item.nosso_numero,
                      guid: item.guid,
                    };

                    this.faturamento.FaturamentoReceber.push(
                      JSON.parse(JSON.stringify(p))
                    );
                  });
                }
              }

              this.faturamento.FaturamentoImportacoes.push(novaImportacao);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
      this.importacaoPedidoVenda = false;
      setTimeout(MenuComponent.reinitialization, 500);
    },
    editarAcoesNFeModal() {
      this.faturamento.peso_bruto != null
        ? this.faturamento.peso_bruto.toString()
        : "0";

      this.faturamento.peso_liquido != null
        ? this.faturamento.peso_liquido.toString()
        : "0";

      this.faturamento.utiliza_icms_sub = this.$utils.booleanToString(
        this.faturamento.utiliza_icms_sub
      );
      //this.$router.push("/movimentacao/faturamento/editar/" + this.id);

      setTimeout(async () => {
        this.limparFaturamentoLocalStorage(
          this.user.User.id,
          this.faturamento.id
        );
        if (this.faturamento.id !== 0) {
          await this.deleteControleEdicao(this.faturamento.id);
        }

        await this.carregarFaturamento();
      }, 500);
    },
  },
  watch: {
    faturamento: {
      deep: true,
      handler() {
        this.salvarFaturamentoLocalStorage();
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.fullPath.includes("movimentacao/faturamento/editar")) {
      this.asyncData();
    }
    next(); // Importante chamar next() para continuar a navegação
  },
  mounted() {
    this.keyListener = (e) => {
      // Utilizar o metakey como combinação além do ctrl
      //para manter a compatibilidade com o mac
      if (e.key === "a" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        e.stopPropagation();
        this.adicionarProdutoFaturamento();
      } else if (e.key === "s" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        e.stopPropagation();
        this.modalProdutos(true);
      } else if (e.key === "F3") {
        e.preventDefault();
        e.stopPropagation();
        this.modalProdutos(true);
      } else if (e.key === "F5") {
        e.preventDefault();
        e.stopPropagation();
        this.adicionarProdutoFaturamento();
      }
    };

    window.addEventListener("keydown", this.keyListener);
    this.asyncData();
    //this.mapperModal();
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.keyListener);

    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      backdrop.remove();
    }
  },
  data() {
    return {
      adicionalProduto: null,
      produtoEstoque: null,
      modalComponent: null,
      exibirEditarProdutoObservacoes: false,
      errosGerais: {},
      errosValidacao: [],
      errosValidacaoGeral: [],
      add: false,
      loading: false,
      isLoadingItens: false,
      idCliente: 0,
      idModalCliente: 0,
      exibirCliente: false,
      exibirClientes: false,
      pesquisaEnderecoIndex: 0,
      configuracao: {},
      pesquisaProduto: "",
      exibirProdutos: false,
      addFaturamentoItem: true,
      indexEdicaoFaturamentoItem: -1,
      exibirEstoques: false,
      exibirAdicional: false,
      exibirTransportadoras: false,
      exibirMotoristas: false,
      exibirVendedores: false,
      exibirVendedoresItem: false,
      idVendedorFaturamentoItem: null,
      nomeVendedorFaturamentoItem: "",
      comissaoVendedorFaturamentoItem: 0,
      observacaoFaturamentoItem: "",
      addItemBranco: false,
      exibirPagamento: true,
      loadingPagamento: false,
      exibirFaturamentoPagamento: false,
      exibirFaturamentoReceber: false,
      exibirFaturamentoReceberModal: false,
      loadingNFeReferenciada: false,
      exibirFaturamentoEditarChave: false,
      indexFaturamentoEditarChave: -1,
      chaveAcessoAtual: "",
      loadingNFeAutorizados: false,
      indexFaturamentoAutorizado: -1,
      autorizadoAtual: "",
      exibirFaturamentoEditarAutorizados: false,
      exibirFaturamentoEditarNFProdutorRural: false,
      indexFaturamentoNFProdutorRural: -1,
      nfProdutorRuralAtual: {},
      loadingNFProdutor: false,
      exibirFaturamentoEditarNFA: false,
      indexFaturamentoNFA: -1,
      nfaAtual: {},
      loadingNFA: false,
      exibirFaturamentoEditarNFeProduto: false,
      indexFaturamentoNFeProduto: -1,
      nfeProdutoAtual: {},
      exibirEditarProdutoPeso: false,
      pesoBrutoFaturamentoItem: 0,
      pesoLiquidoFaturamentoItem: 0,
      exibirDesconto: false,
      totalDescontoModal: 0,
      labelTotal: "",
      exibirRemoverDesconto: false,
      exibirCfops: false,
      exibirContas: false,
      exibirCustos: false,
      loadingExporta: false,
      exibirFaturamentoEditarExporta: false,
      indexFaturamentoExporta: -1,
      exportaAtual: {},
      loadingCompra: false,
      exibirFaturamentoEditarCompra: false,
      indexFaturamentoCompra: -1,
      compraAtual: {},
      exibirGrupoCompra: false,
      loadingVeicTransp: false,
      exibirFaturamentoEditarVeicTransp: false,
      indexFaturamentoVeicTransp: -1,
      veicTranspAtual: {},
      exibirFaturamentoSelecionarModelo: false,
      exibirEditarProdutoDetalhes: false,
      detPesagemFaturamentoItem: "",
      detToleranciaFaturamentoItem: "",
      detTipoEmbalagemFaturamentoItem: "",
      detCodBarrasFaturamentoItem: "",
      detMetragemFaturamentoItem: "",
      exibirModalVendedorItem: false,
      idVendedorItemAtual: null,
      comissaoVendedorItemAtual: 0,
      camposLivres: false,
      exibirModalImportacaoPedidoVenda: false,
      importacaoPedidoVenda: false,
      exibirModalAcoesNFe: false,
      idFaturamentoGravado: 0,
      timeOut: null,
      exibirInclusaoRapida: false,
      faturamento: JSON.parse(JSON.stringify(faturamentoInicializado)),
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
      optionsPreco: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: {
          min: 2,
          max: 10,
        },
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: true,
      },
      optionsQtd: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: {
          min: 0,
          max: 4,
        },
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: true,
      },
      tableProdutoHeader: [
        {
          name: "Item",
          key: "item",
          sortable: true,
        },
        {
          name: "Código",
          key: "id_produto",
          sortable: true,
        },
        {
          key: "imagem",
          sortable: false,
        },
        {
          name: "Nome do Produto",
          key: "nome",
          sortable: true,
        },
        {
          name: "UND",
          key: "und",
          sortable: true,
        },
        {
          name: "Qtd",
          key: "qtd",
          sortable: true,
        },
        {
          name: "Preço",
          key: "preco",
          sortable: true,
        },
        {
          name: "Total",
          key: "total",
          sortable: true,
        },
        {
          name: "CFOP",
          key: "cfop",
          sortable: true,
        },
        {
          name: "CST",
          key: "cst",
          sortable: true,
        },
        {
          name: "CSOSN",
          key: "csosn",
          sortable: true,
        },
        {
          name: "ICMS",
          key: "icms",
          sortable: true,
        },
        {
          name: "IPI",
          key: "ipi",
          sortable: true,
        },
        {
          name: "Base ICMS",
          key: "base_icms",
          sortable: true,
          visible: false,
        },
        {
          name: "Total ICMS",
          key: "total_icms",
          sortable: true,
          visible: false,
        },
        {
          name: "Base ICMS Sub",
          key: "base_icms_sub",
          sortable: true,
          visible: false,
        },
        {
          name: "Total ICMS Sub",
          key: "total_icms_sub",
          sortable: true,
          visible: false,
        },
        {
          name: "Total IPI",
          key: "total_ipi",
          sortable: true,
          visible: false,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
    };
  },
};
</script>
<style>
.text-quebrar-linha {
  white-space: pre-line;
}
</style>
